(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2957"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2957"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d8tQ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90c4571c3a376e78$export$2e2bcd8739ae039; });

var $knCXs = parcelRequire("knCXs");

var $9KW2j = parcelRequire("9KW2j");
/**
 * Populates dialog image element with QR code data from the opener element's data attributes.
 *
 * @param dialogImage - The image element inside the dialog to populate
 * @param opener - The element that triggered the dialog
 *
 * @example
 * Opener element should have these data attributes:
 * <button data-qr-opener data-qr-src="image.png" data-qr-alt="QR Code" data-qr-width="200" data-qr-height="200">Open QR</button>
 */ const $90c4571c3a376e78$var$setDialogImageFromOpener = (dialogImage, opener)=>{
    const qrSrc = opener.getAttribute('data-qr-src') ?? '';
    const qrAlt = opener.getAttribute('data-qr-alt') ?? '';
    const qrWidth = opener.getAttribute('data-qr-width');
    const qrHeight = opener.getAttribute('data-qr-height');
    if (!qrSrc) return;
    dialogImage.src = qrSrc;
    dialogImage.alt = qrAlt;
    if (qrWidth) dialogImage.width = Number(qrWidth);
    if (qrHeight) dialogImage.height = Number(qrHeight);
};
/**
 * Handles a click on a QR opener element.
 * On desktop: shows the QR modal populated with the opener's QR image.
 * On mobile/touch: redirects to the app download link from `data-app-download-link`.
 *
 * @param opener - The clicked element with `data-qr-*` and `data-app-download-link` attributes
 * @param dialog - The global QR dialog element
 * @param dialogImage - The image element inside the dialog
 */ const $90c4571c3a376e78$var$handleOpenerClick = (opener, dialog, dialogImage)=>{
    if ((0, $9KW2j.isMobileDevice)()) {
        const link = opener.getAttribute('data-app-download-link');
        if (link) window.location.href = link;
        return;
    }
    $90c4571c3a376e78$var$setDialogImageFromOpener(dialogImage, opener);
    if (typeof HTMLDialogElement === 'function') dialog.showModal();
    else dialog.removeAttribute('hidden');
};
/**
 * Initializes the global QR code popup.
 * Finds all `[data-qr-opener]` elements and attaches click handlers.
 * Requires `[data-qr-dialog-global]` and `[data-qr-dialog-image]` to be present in the DOM.
 */ const $90c4571c3a376e78$var$initQrPopup = ()=>{
    const dialog = document.querySelector('[data-qr-dialog-global]');
    const openers = Array.from(document.querySelectorAll('[data-qr-opener]'));
    if (!dialog || !openers.length) {
        console.error('QR popup initialization failed:', {
            dialogFound: Boolean(dialog),
            openerCount: openers.length
        });
        return;
    }
    const dialogImage = dialog.querySelector('[data-qr-dialog-image]');
    if (!dialogImage) {
        console.error('QR popup initialization failed: dialog image not found.');
        return;
    }
    openers.forEach((opener)=>{
        opener.addEventListener('click', ()=>$90c4571c3a376e78$var$handleOpenerClick(opener, dialog, dialogImage));
    });
    (0, $knCXs.modalHandle)(dialog);
};
var $90c4571c3a376e78$export$2e2bcd8739ae039 = $90c4571c3a376e78$var$initQrPopup;

});
parcelRegister("knCXs", function(module, exports) {

$parcel$export(module.exports, "modalHandle", function () { return $9258b8f367a9c85a$export$eaa6d74f8f42be11; });
/**
 * Sets up a dialog element to function as a tooltip that appears when hovering over a specified element.
 *
 * This function:
 * - Handles browser compatibility for the HTML Dialog element
 * - If the browser supports HTMLDialogElement, it uses the native show/close methods
 * - If not supported, it falls back to using the hidden attribute
 * - Sets the dialog parent's position to 'relative'
 * - Adds a 'tooltip' class to the dialog element
 *
 * @param dialog - The HTML dialog element to be displayed as a tooltip
 * @param dialogOpener - The element that triggers the dialog when hovered over
 *
 * @example
 * ```typescript
 * const dialog = document.querySelector<HTMLDialogElement>('#my-tooltip');
 * const opener = document.querySelector<HTMLElement>('#tooltip-opener');
 *
 * if (dialog && opener) {
 *   dialogHandle(dialog, opener);
 * }
 * ```
 */ const $9258b8f367a9c85a$export$f4caa643aa66c9b9 = (dialog, dialogOpener)=>{
    dialog.parentElement.style.position = 'relative';
    dialog.classList.add('tooltip');
    // check if dialog tag is supported
    if (typeof HTMLDialogElement === 'function') {
        dialog.removeAttribute('hidden');
        dialogOpener.addEventListener('mouseenter', ()=>dialog.show());
        dialogOpener.addEventListener('mouseout', ()=>dialog.close());
    } else {
        dialog.setAttribute('hidden', '');
        dialogOpener.addEventListener('mouseenter', ()=>dialog.removeAttribute('hidden'));
        dialogOpener.addEventListener('mouseout', ()=>dialog.setAttribute('hidden', ''));
    }
};
const $9258b8f367a9c85a$export$eaa6d74f8f42be11 = (modal, modalOpeners)=>{
    const closeBtn = modal.querySelector('[data-modal-close]');
    // Handle multiple openers or single opener
    const attachOpenEvent = (opener, action)=>{
        opener.addEventListener('click', action);
    };
    const setupOpeners = (action)=>{
        if (!modalOpeners) return;
        if (Array.isArray(modalOpeners)) modalOpeners.forEach((opener)=>attachOpenEvent(opener, action));
        else attachOpenEvent(modalOpeners, action);
    };
    // check if dialog tag is supported
    if (typeof HTMLDialogElement === 'function') {
        modal.removeAttribute('hidden');
        setupOpeners(()=>modal.showModal());
        modal.addEventListener('click', (e)=>{
            if (e.detail === 0) return; // ignore focus events
            const dialogDimensions = modal.getBoundingClientRect();
            if (e.clientX < dialogDimensions.left || e.clientX > dialogDimensions.right || e.clientY < dialogDimensions.top || e.clientY > dialogDimensions.bottom) modal.close();
        });
        if (closeBtn) closeBtn.addEventListener('click', ()=>modal.close());
    } else {
        modal.setAttribute('hidden', '');
        setupOpeners(()=>modal.removeAttribute('hidden'));
        modal.addEventListener('click', (e)=>{
            const dialogDimensions = modal.getBoundingClientRect();
            if (e.clientX < dialogDimensions.left || e.clientX > dialogDimensions.right || e.clientY < dialogDimensions.top || e.clientY > dialogDimensions.bottom) modal.setAttribute('hidden', '');
        });
        if (closeBtn) closeBtn.addEventListener('click', ()=>modal.setAttribute('hidden', ''));
    }
};

});

parcelRegister("9KW2j", function(module, exports) {

$parcel$export(module.exports, "isAndroid", function () { return $9b42097cc816bb4d$export$a11b0059900ceec8; });
$parcel$export(module.exports, "isMobileDevice", function () { return $9b42097cc816bb4d$export$44f917bf91becd01; });
$parcel$export(module.exports, "isAppInstalled", function () { return $9b42097cc816bb4d$export$4fe30fcd38d81a35; });
const $9b42097cc816bb4d$export$a11b0059900ceec8 = ()=>{
    return /Android/i.test(navigator.userAgent);
};
const $9b42097cc816bb4d$export$44f917bf91becd01 = ()=>{
    const userAgent = navigator.userAgent.toLowerCase();
    const isStandardMobile = /android|iphone|ipad|ipod/.test(userAgent);
    const isNewIPad = userAgent.includes('mac') && navigator.maxTouchPoints > 0;
    return isStandardMobile || isNewIPad;
};
const $9b42097cc816bb4d$export$4fe30fcd38d81a35 = async (appId)=>{
    if (!navigator.getInstalledRelatedApps) return false;
    try {
        const relatedApps = await navigator.getInstalledRelatedApps();
        return relatedApps.some((app)=>app.id === appId);
    } catch (error) {
        console.error(error);
        return false;
    }
};

});


parcelRegister("3owir", function(module, exports) {

$parcel$export(module.exports, "resetAllErrorMSG", function () { return $27ea6da7ca8a013d$export$4a34ef664e18407; });
$parcel$export(module.exports, "setInputErrorMSG", function () { return $27ea6da7ca8a013d$export$396f88f6c109920e; });
$parcel$export(module.exports, "setErrorMSG", function () { return $27ea6da7ca8a013d$export$a4b356ce5ec06b54; });
$parcel$export(module.exports, "checkValidity", function () { return $27ea6da7ca8a013d$export$50d70f8cedc54453; });
$parcel$export(module.exports, "emailValidator", function () { return $27ea6da7ca8a013d$export$85e9422a5732c151; });
$parcel$export(module.exports, "passwordValidator", function () { return $27ea6da7ca8a013d$export$5fe07b64a9ea357e; });
$parcel$export(module.exports, "consentValidator", function () { return $27ea6da7ca8a013d$export$ca8b57724d73832; });
$parcel$export(module.exports, "getStringField", function () { return $27ea6da7ca8a013d$export$5f70236e92c027f4; });
$parcel$export(module.exports, "getBooleanField", function () { return $27ea6da7ca8a013d$export$53099b6b3a9a33fb; });
$parcel$export(module.exports, "getPromoCodeField", function () { return $27ea6da7ca8a013d$export$e1b8d1a4f431da1; });
$parcel$export(module.exports, "getFormData", function () { return $27ea6da7ca8a013d$export$9643fd7297feaaf5; });
$parcel$export(module.exports, "checkIfPayloadComplete", function () { return $27ea6da7ca8a013d$export$88affea731eac155; });
$parcel$export(module.exports, "handleFailedRegistration", function () { return $27ea6da7ca8a013d$export$5e6f9f31ca3eae3f; });
$parcel$export(module.exports, "createConfirmEmailUrl", function () { return $27ea6da7ca8a013d$export$124f49a06a6137d3; });
$parcel$export(module.exports, "bindPasswordControls", function () { return $27ea6da7ca8a013d$export$46784b43517dd9a1; });
$parcel$export(module.exports, "bindSubmitButton", function () { return $27ea6da7ca8a013d$export$943abb409ee8f4d9; });
$parcel$export(module.exports, "initForm", function () { return $27ea6da7ca8a013d$export$653023c4fd90fd41; });
$parcel$export(module.exports, "initExitPopupFormControls", function () { return $27ea6da7ca8a013d$export$e10ab349d4e1180e; });

var $3cM09 = parcelRequire("3cM09");

var $daEfo = parcelRequire("daEfo");

var $i928P = parcelRequire("i928P");

var $7iiIP = parcelRequire("7iiIP");

var $aFzjB = parcelRequire("aFzjB");

var $bg4xJ = parcelRequire("bg4xJ");

var $ep8H5 = parcelRequire("ep8H5");

var $3Rj1s = parcelRequire("3Rj1s");
const $27ea6da7ca8a013d$var$currentLanguage = (0, $7iiIP.getCurrentLanguage)();
const $27ea6da7ca8a013d$var$SPACE_REGEX = / /g;
const $27ea6da7ca8a013d$var$boundControls = new Set();
const $27ea6da7ca8a013d$var$FORM_FIELD_SELECTOR = '.general-form-style__single-field';
const $27ea6da7ca8a013d$export$4a34ef664e18407 = ($formContainer)=>{
    const $errorMsgsSpans = $formContainer.querySelectorAll('[data-error-field]');
    const $invalidInputs = $formContainer.querySelectorAll('.is-invalid');
    const $serverError = $formContainer.querySelector('[data-error-server]');
    $errorMsgsSpans.forEach(($singleErrorSpan)=>{
        $singleErrorSpan.hidden = true;
    });
    $invalidInputs.forEach(($singleInvalidField)=>{
        $singleInvalidField.classList.remove('is-invalid');
    });
    if ($serverError) $serverError.hidden = true;
};
const $27ea6da7ca8a013d$export$396f88f6c109920e = (selector, errorMSG, $formContainer)=>{
    const $inputWithError = $formContainer.querySelector(selector);
    if (!$inputWithError) {
        console.warn(`Element with selector "${selector}" not found in the form container.`);
        return;
    }
    const $fieldContainer = $inputWithError.closest($27ea6da7ca8a013d$var$FORM_FIELD_SELECTOR);
    if (!$fieldContainer) {
        console.warn(`Could not find a parent container "${$27ea6da7ca8a013d$var$FORM_FIELD_SELECTOR}" for selector "${selector}".`);
        return;
    }
    const $errorSpanElement = $fieldContainer.querySelector('[data-error-field]');
    if ($errorSpanElement) {
        $errorSpanElement.innerHTML = errorMSG;
        $errorSpanElement.hidden = false;
    } else console.warn(`Error field [data-error-field] not found within the container for selector "${selector}".`);
    $inputWithError.classList.add('is-invalid');
};
const $27ea6da7ca8a013d$export$a4b356ce5ec06b54 = (selector, errorMSG, $formContainer)=>{
    const $errorLabel = $formContainer.querySelector(selector);
    if ($errorLabel) {
        $errorLabel.innerHTML = errorMSG;
        $errorLabel.hidden = false;
    }
};
const $27ea6da7ca8a013d$export$50d70f8cedc54453 = (checkResults, selector, $formContainer)=>{
    checkResults = checkResults.filter((n)=>n);
    if (checkResults.length) {
        $27ea6da7ca8a013d$export$396f88f6c109920e(selector, checkResults[0], $formContainer);
        return false;
    }
    return true;
};
const $27ea6da7ca8a013d$export$85e9422a5732c151 = (value, selector, $formContainer)=>{
    const isValid = [
        !(0, $3cM09.isNotEmptyTrimmedStringValidator)(value) ? (0, $daEfo.t9n)('formValidation.emptyField') : '',
        !(0, $3cM09.isEmailValidator)(value) ? (0, $daEfo.t9n)('formValidation.emailNotValid') : ''
    ];
    return $27ea6da7ca8a013d$export$50d70f8cedc54453(isValid, selector, $formContainer) ? value : null;
};
const $27ea6da7ca8a013d$export$5fe07b64a9ea357e = (value, selector, $formContainer)=>{
    const isValid = [
        !(0, $3cM09.isNotEmptyTrimmedStringValidator)(value) ? (0, $daEfo.t9n)('formValidation.emptyField') : '',
        !(0, $3cM09.isPasswordValidator)(value) ? (0, $daEfo.t9n)('formValidation.passwordToShort') : ''
    ];
    return $27ea6da7ca8a013d$export$50d70f8cedc54453(isValid, selector, $formContainer) ? value : null;
};
const $27ea6da7ca8a013d$export$ca8b57724d73832 = (value, selector, $formContainer)=>{
    const isValid = [
        !(0, $3cM09.isValueValidator)(value) ? (0, $daEfo.t9n)('formValidation.requiredField') : ''
    ];
    return $27ea6da7ca8a013d$export$50d70f8cedc54453(isValid, selector, $formContainer) ? value : null;
};
const $27ea6da7ca8a013d$export$5f70236e92c027f4 = (selector, validator, $formContainer, shouldBeValidated = true)=>{
    const ALLOWED_INPUT_TYPES = [
        'text',
        'hidden',
        'password',
        'textarea'
    ];
    const $inputElement = $formContainer.querySelector(selector);
    if (!$inputElement || !ALLOWED_INPUT_TYPES.includes($inputElement.type)) return null;
    const value = String($inputElement.value).trim();
    return shouldBeValidated ? validator(value, selector, $formContainer) : value;
};
const $27ea6da7ca8a013d$export$f8803584f13cd019 = (selector, validator, $formContainer, shouldBeValidated = true, fallbackWhenMissing = true)=>{
    const ALLOWED_INPUT_TYPES = [
        'checkbox'
    ];
    const $inputElement = $formContainer.querySelector(selector);
    if (!$inputElement || !ALLOWED_INPUT_TYPES.includes($inputElement.type)) return fallbackWhenMissing;
    const value = $inputElement.checked;
    return shouldBeValidated ? validator(value, selector, $formContainer) : value;
};
const $27ea6da7ca8a013d$export$53099b6b3a9a33fb = (selector, validator, $formContainer, shouldBeValidated = true)=>{
    const ALLOWED_INPUT_TYPES = [
        'checkbox'
    ];
    const $inputElement = $formContainer.querySelector(selector);
    if (!$inputElement || !ALLOWED_INPUT_TYPES.includes($inputElement.type)) return null;
    const value = $inputElement.checked;
    return shouldBeValidated ? validator(value, selector, $formContainer) : value;
};
const $27ea6da7ca8a013d$export$e1b8d1a4f431da1 = ($formContainer)=>{
    const $inputElement = $formContainer.querySelector('[data-promocode-field]');
    return $inputElement ? $inputElement.value.trim() : '';
};
const $27ea6da7ca8a013d$export$9643fd7297feaaf5 = ($formContainer)=>{
    return {
        email: $27ea6da7ca8a013d$export$5f70236e92c027f4('[data-email-field]', $27ea6da7ca8a013d$export$85e9422a5732c151, $formContainer),
        password: $27ea6da7ca8a013d$export$5f70236e92c027f4('[data-password-field]', $27ea6da7ca8a013d$export$5fe07b64a9ea357e, $formContainer),
        promocode: $27ea6da7ca8a013d$export$e1b8d1a4f431da1($formContainer),
        terms_and_conditions_accepted: $27ea6da7ca8a013d$export$53099b6b3a9a33fb('[data-checkbox-field="terms"]', $27ea6da7ca8a013d$export$ca8b57724d73832, $formContainer),
        promotion_program_rules_accepted: $27ea6da7ca8a013d$export$53099b6b3a9a33fb('[data-checkbox-field="promotion"]', $27ea6da7ca8a013d$export$ca8b57724d73832, $formContainer) || undefined,
        marketing_email_actions_accepted: $27ea6da7ca8a013d$export$53099b6b3a9a33fb('[data-checkbox-field="marketing-consent"]', $27ea6da7ca8a013d$export$ca8b57724d73832, $formContainer, false) || undefined,
        region: 'PL',
        language: $27ea6da7ca8a013d$var$currentLanguage
    };
};
const $27ea6da7ca8a013d$export$88affea731eac155 = (payload)=>{
    const REQUIRED_FIELDS = [
        'email',
        'password',
        'promocode',
        'terms_and_conditions_accepted',
        'region',
        'language'
    ];
    const requiredFieldsValid = REQUIRED_FIELDS.every((field)=>{
        const value = payload[field];
        if (value == null) return false;
        switch(field){
            case 'email':
            case 'password':
            case 'region':
            case 'language':
                return typeof value === 'string' && value.trim() !== '';
            case 'promocode':
                return typeof value === 'string' // promocode can be empty string
                ;
            case 'terms_and_conditions_accepted':
                return value === true;
            default:
                return true // For any other fields, just check for non-null/undefined
                ;
        }
    });
    // If promotion_program_rules_accepted exists and is not null/undefined,
    // not all forms have promotions
    if ('promotion_program_rules_accepted' in payload) {
        const value = payload.promotion_program_rules_accepted;
        const isValid = value != null && value === true;
        return isValid && requiredFieldsValid;
    }
    return requiredFieldsValid;
};
const $27ea6da7ca8a013d$var$handleFormSubmit = async ($formContainer = document, isWithCompetition = false)=>{
    $27ea6da7ca8a013d$export$4a34ef664e18407($formContainer);
    const captchaToken = '' // Placeholder for captcha token, replace with actual token retrieval logic
    ;
    const payload = {
        ...$27ea6da7ca8a013d$export$9643fd7297feaaf5($formContainer),
        captcha: captchaToken
    };
    if (!$27ea6da7ca8a013d$export$88affea731eac155(payload)) {
        console.warn('Incomplete or invalid form data');
        return;
    }
    try {
        const response = await (0, $ep8H5.registerUser)(payload);
        $27ea6da7ca8a013d$var$handleSuccessfulRegistration(payload, response, isWithCompetition);
    } catch (error) {
        $27ea6da7ca8a013d$export$5e6f9f31ca3eae3f(error, $formContainer);
    }
};
const $27ea6da7ca8a013d$export$124f49a06a6137d3 = (domain, params)=>{
    const redirect = `${domain}/#/confirm-email`;
    const createdUrl = (0, $bg4xJ.createUrlWithParams)(params, new URL(redirect));
    return createdUrl;
};
const $27ea6da7ca8a013d$var$handleSuccessfulRegistration = (payload, response, isWithCompetition)=>{
    const language = payload.language || (0, $7iiIP.getCurrentLanguage)();
    const registrationRef = response.ref || '';
    (0, $i928P.pushDataLayer)('form_submitted', {
        form_name: 'Rejstracja z landingu',
        form_url: window.location.href
    });
    if (isWithCompetition) {
        const competitionFrom = (0, $3Rj1s.getElementsForm)();
        (0, $3Rj1s.collectDataToSend)(competitionFrom);
    }
    window.location.href = $27ea6da7ca8a013d$export$124f49a06a6137d3(USER_BASE_URL_WT, {
        language: language,
        registrationRef: registrationRef
    });
};
const $27ea6da7ca8a013d$export$5e6f9f31ca3eae3f = (error, $formContainer)=>{
    if ((0, $aFzjB.isApiError)(error)) {
        const message = (0, $aFzjB.getApiErrorMessage)(error);
        switch(message){
            case 'email-already-exists':
            case 'biz-email-already-exists':
                $27ea6da7ca8a013d$export$396f88f6c109920e('[data-email-field]', (0, $daEfo.t9n)('formValidation.emailReserved'), $formContainer);
                return;
            case 'promocode-invalid':
                $27ea6da7ca8a013d$export$a4b356ce5ec06b54('[data-error-server]', (0, $daEfo.t9n)('formValidation.promocodeInvalid'), $formContainer);
                return;
            default:
                console.error('Registration error:', message);
                $27ea6da7ca8a013d$export$a4b356ce5ec06b54('[data-error-server]', (0, $daEfo.t9n)('formValidation.serverUnknownError'), $formContainer);
        }
    } else {
        const message = (0, $aFzjB.getGenericErrorMessage)(error);
        console.error('Generic Error on submit:', error);
        $27ea6da7ca8a013d$export$a4b356ce5ec06b54('[data-error-server]', message, $formContainer);
    }
};
const $27ea6da7ca8a013d$var$handleShowPassword = ($showPasswordButton, $passwordInput)=>{
    if ($passwordInput) {
        $passwordInput.type = `${$passwordInput.type === 'text' ? 'password' : 'text'}`;
        $showPasswordButton.textContent = `${$passwordInput.type === 'text' ? (0, $daEfo.t9n)('password.hide') : (0, $daEfo.t9n)('password.show')}`;
    }
};
const $27ea6da7ca8a013d$var$removeSpaces = (value)=>value.replace($27ea6da7ca8a013d$var$SPACE_REGEX, '');
const $27ea6da7ca8a013d$var$setValueKeepingCursor = ($input, transform)=>{
    const cursorPosition = $input.selectionStart ?? $input.value.length;
    const cursorPositionAfterTransform = transform($input.value.slice(0, cursorPosition)).length;
    $input.value = transform($input.value);
    $input.setSelectionRange(cursorPositionAfterTransform, cursorPositionAfterTransform);
};
const $27ea6da7ca8a013d$export$41affe952ecef6d7 = ($passwordInput)=>{
    const { value: value } = $passwordInput;
    if (value === $27ea6da7ca8a013d$var$removeSpaces(value)) return;
    $27ea6da7ca8a013d$var$setValueKeepingCursor($passwordInput, $27ea6da7ca8a013d$var$removeSpaces);
};
const $27ea6da7ca8a013d$export$46784b43517dd9a1 = ($formContainer)=>{
    $formContainer.querySelectorAll('[data-password-field]').forEach(($passwordInput)=>{
        if ($27ea6da7ca8a013d$var$boundControls.has($passwordInput)) return;
        $27ea6da7ca8a013d$var$boundControls.add($passwordInput);
        const $showPasswordButton = $passwordInput.closest($27ea6da7ca8a013d$var$FORM_FIELD_SELECTOR)?.querySelector('[data-show-password-button]');
        $passwordInput.addEventListener('input', ()=>$27ea6da7ca8a013d$export$41affe952ecef6d7($passwordInput));
        if ($showPasswordButton) $showPasswordButton.addEventListener('click', ()=>$27ea6da7ca8a013d$var$handleShowPassword($showPasswordButton, $passwordInput));
    });
};
const $27ea6da7ca8a013d$export$943abb409ee8f4d9 = ($formContainer, onSubmit)=>{
    const $submitButton = $formContainer.querySelector('[data-submit-form]');
    if (!$submitButton || $27ea6da7ca8a013d$var$boundControls.has($submitButton)) return;
    $27ea6da7ca8a013d$var$boundControls.add($submitButton);
    $submitButton.addEventListener('click', onSubmit);
};
const $27ea6da7ca8a013d$var$bindFormControls = ($formContainer, isWithCompetition = false)=>{
    $27ea6da7ca8a013d$export$943abb409ee8f4d9($formContainer, ()=>$27ea6da7ca8a013d$var$handleFormSubmit($formContainer, isWithCompetition));
    $27ea6da7ca8a013d$export$46784b43517dd9a1($formContainer);
};
const $27ea6da7ca8a013d$export$653023c4fd90fd41 = (isWithCompetition = false)=>{
    $27ea6da7ca8a013d$var$bindFormControls(document, isWithCompetition);
};
const $27ea6da7ca8a013d$export$e10ab349d4e1180e = ()=>{
    const $form = document.querySelector('[data-exit-popup]');
    if ($form) $27ea6da7ca8a013d$var$bindFormControls($form);
};

});
parcelRegister("3cM09", function(module, exports) {
"use strict";
var $2557ba2a47648495$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2557ba2a47648495$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2557ba2a47648495$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2557ba2a47648495$var$__exportStar((parcelRequire("dMzC4")), module.exports);

$2557ba2a47648495$var$__exportStar((parcelRequire("6a6TF")), module.exports);

});
parcelRegister("dMzC4", function(module, exports) {
"use strict";
/** @module Patterns */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isPolishStreetPattern = module.exports.isStreetPattern = module.exports.isPostalCodePattern = module.exports.isCharsCompanyPattern = module.exports.isBankAccountNamePattern = module.exports.isPasswordPattern = module.exports.isNumericPattern = module.exports.isNipPattern = module.exports.isNamePattern = module.exports.isLastNamePattern = module.exports.isGenericTextPattern = module.exports.isCityPattern = module.exports.isAlphaNumericPattern = module.exports.isAccountTypeOtherPattern = module.exports.isAccountNumberPattern = void 0;
var $a08b62134a7a893c$var$isAccountNumberPattern = function isAccountNumberPattern(value) {
    var pattern = '^[a-zA-Z0-9\\s]*$';
    return !!value.match(pattern);
};
module.exports.isAccountNumberPattern = $a08b62134a7a893c$var$isAccountNumberPattern;
/**
 * Checks if value matches account number pattern
 * <pre> /^[a-zA-Z0-9\\s]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isAccountTypeOtherPattern = function isAccountTypeOtherPattern(value) {
    var pattern = "^[a-zA-Z\u0105\u0107\u0119\u0142\u0144\xf3\u015B\u017A\u017C\u0104\u0106\u0118\u0141\u0143\xd3\u015A\u0179\u017B. ]*$";
    return !!value.match(pattern);
};
module.exports.isAccountTypeOtherPattern = $a08b62134a7a893c$var$isAccountTypeOtherPattern;
/**
 * Checks if value matches account type pattern
 * <pre> /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ. ]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isAlphaNumericPattern = function isAlphaNumericPattern(value) {
    var pattern = '^[a-zA-Z0-9]*$';
    return !!value.match(pattern);
};
module.exports.isAlphaNumericPattern = $a08b62134a7a893c$var$isAlphaNumericPattern;
/**
 * Checks if value matches alpha numeric pattern
 * <pre> /^[a-zA-Z0-9]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isCityPattern = function isCityPattern(value) {
    var pattern = "^([a-zA-Z\x80-\u024F]+(?:. |-| |'))*[a-zA-Z\x80-\u024F]*$";
    return !!value.match(pattern);
};
module.exports.isCityPattern = $a08b62134a7a893c$var$isCityPattern;
/**
 * Checks if value matches city pattern
 * <pre> /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isGenericTextPattern = function isGenericTextPattern(value) {
    var pattern = "^[0-9a-zA-Z\u0105\u0107\u0119\u0142\u0144\xf3\u015B\u017A\u017C\u0104\u0106\u0118\u0141\u0143\xd3\u015A\u0179\u017B\\s\\,\\.\\-\\+\\(\\)\\!\\?\\:\\@\\n]*$";
    return !!value.match(pattern);
};
module.exports.isGenericTextPattern = $a08b62134a7a893c$var$isGenericTextPattern;
/**
 * Checks if value matches generic text pattern
 * <pre> /^[0-9a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s\,\.\-\+\(\)\!\?\:\@\n]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isLastNamePattern = function isLastNamePattern(value) {
    var pattern = "^[a-zA-Z\\u00C0-\\u017F\\-\\s\\']*$";
    return !!value.match(pattern);
};
module.exports.isLastNamePattern = $a08b62134a7a893c$var$isLastNamePattern;
/**
 * Checks if value matches last name pattern
 * <pre> /^[a-zA-Z\u00C0-\u017F\-\s\']*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isNamePattern = function isNamePattern(value) {
    var pattern = "^[a-zA-Z\u0105\u0107\u0119\u0142\u0144\xf3\u015B\u017A\u017C\u0104\u0106\u0118\u0141\u0143\xd3\u015A\u0179\u017B ]*$";
    return !!value.match(pattern);
};
module.exports.isNamePattern = $a08b62134a7a893c$var$isNamePattern;
/**
 * Checks if value matches name pattern
 * <pre> /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ ]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isNipPattern = function isNipPattern(value) {
    var pattern = '^[a-zA-Z0-9\\s\\-]*$';
    return !!value.match(pattern);
};
module.exports.isNipPattern = $a08b62134a7a893c$var$isNipPattern;
/**
 * Checks if value matches nip pattern
 * <pre> /^[a-zA-Z0-9\s\-]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isNumericPattern = function isNumericPattern(value) {
    var pattern = '^[0-9]*$';
    return !!value.match(pattern);
};
module.exports.isNumericPattern = $a08b62134a7a893c$var$isNumericPattern;
/**
 * Checks if value matches numeric pattern
 * <pre> /^[0-9]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isPasswordPattern = function isPasswordPattern(value) {
    var pattern = "^[0-9a-zA-Z\u0105\u0107\u0119\u0142\u0144\xf3\u015B\u017A\u017C\u0104\u0106\u0118\u0141\u0143\xd3\u015A\u0179\u017B\\s\\-\\+\\_\\\\!\\@\\#\\$\\%\\^&\\*\\|\\\"\\'\\;\\:\\,\\.\\?\\(\\)\\[\\]\\{\\}]*$";
    return !!value.match(pattern);
};
module.exports.isPasswordPattern = $a08b62134a7a893c$var$isPasswordPattern;
/**
 * Checks if value matches password pattern
 * <pre> /^[0-9a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s\-\+\_\\!\@\#\$\%\^&\*\|\"\'\;\:\,\.\?\(\)\[\]\{\}]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isBankAccountNamePattern = function isBankAccountNamePattern(value) {
    var pattern = "^[0-9a-zA-Z\\u00C0-\\u017F\\xad\\xa0\\u201c\\u201d\\u201e\u201F\\u2013\\_\\;\\'\\@\\-\\s\\\",.\\/\\-\\+\\&\\(\\)]*$";
    return !!value.match(pattern);
};
module.exports.isBankAccountNamePattern = $a08b62134a7a893c$var$isBankAccountNamePattern;
/**
 * Checks if value matches bank account name pattern
 * <pre>
 *   /^[0-9a-zA-Z\u00C0-\u017F\xad\xa0\u201c\u201d\u201e\u201f\u2013\_\;\'\@\-\s\",.\/\-\+\&\(\)]*$/
 * </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isCharsCompanyPattern = function isCharsCompanyPattern(value) {
    var pattern = "^[a-zA-Z0-9\\u00C0-\\u017F\\xad\\xa0\\u201c\\u201d\\u201e\u201F\\u2013\\_\\;\\@\\-\\s\\.\\,\\&\\`\\'\\:\\(\\)\\!\\*\\\"\\/\\\\\\+]*$";
    return !!value.match(pattern);
};
module.exports.isCharsCompanyPattern = $a08b62134a7a893c$var$isCharsCompanyPattern;
/**
 * Checks if value matches company name pattern
 * <pre>
 *   /^[a-zA-Z0-9\u00C0-\u017F\xad\xa0\u201c\u201d\u201e\u201f\u2013\_\;\@\-\s\.\,\&\`\'\:\(\)\!\*\"\/\\\+]*$/
 * </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isPostalCodePattern = function isPostalCodePattern(value) {
    var pattern = '^[a-zA-Z0-9 \\-]*$';
    return !!value.match(pattern);
};
module.exports.isPostalCodePattern = $a08b62134a7a893c$var$isPostalCodePattern;
/**
 * Checks if value matches postal code pattern
 * <pre> /^[a-zA-Z0-9 \-]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isStreetPattern = function isStreetPattern(value) {
    var pattern = "^[0-9a-zA-Z\\u00C0-\\u017F\\-\\s\\.,\\/]*$";
    return !!value.match(pattern);
};
module.exports.isStreetPattern = $a08b62134a7a893c$var$isStreetPattern;
/**
 * Checks if value matches street name pattern
 * <pre> /^[0-9a-zA-Z\u00C0-\u017F\-\s\.,\/]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isPolishStreetPattern = function isPolishStreetPattern(value) {
    var pattern = "[a-zA-Z\\u00C0-\\u017F]+\\s\\d.*$";
    return !!value.match(pattern);
};
module.exports.isPolishStreetPattern = $a08b62134a7a893c$var$isPolishStreetPattern; /**
 * Checks if value matches <street><number> pattern
 * <pre> /[a-zA-Z\\u00C0-\\u017F]+\\s\\d.*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ 

});

parcelRegister("6a6TF", function(module, exports) {
"use strict";
/** @module General Validators */ var $47c906d6984dd304$var$__importDefault = function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isLatinValidator = module.exports.isAllKeysValidator = module.exports.isPropValidator = module.exports.isPassportValidator = module.exports.isIdNumberValidator = module.exports.isSwiftCountryValidator = module.exports.isSwiftValidator = module.exports.isCnapsCodeValidator = module.exports.isTaxNumberValidator = module.exports.isRoutingCodeValidator = module.exports.isLanNumberValidator = module.exports.isIbanLengthValidator = module.exports.isIbanValidator = module.exports.isOtherThanValidator = module.exports.isSameAsValidator = module.exports.isMaxLengthValidator = module.exports.isMinLengthValidator = module.exports.isEmailValidator = module.exports.isNotHigherOrEqualValidator = module.exports.isNotHigherValidator = module.exports.isNotSmallerOrEqualValidator = module.exports.isNotSmallerValidator = module.exports.isPasswordValidator = module.exports.isPostalCodeValidator = module.exports.isNipValidator = module.exports.isSelectedValidator = module.exports.isNotEmptyTrimmedStringValidator = module.exports.isNotEmptyStringValidator = module.exports.isNotEmptyUnlessValidator = module.exports.isNotUndefinedValidator = module.exports.isNotNullValidator = module.exports.isValueValidator = void 0;

var $54HQr = parcelRequire("54HQr");

var $47c906d6984dd304$var$value_of_letter_1 = $47c906d6984dd304$var$__importDefault((parcelRequire("c9uu9")));
var $47c906d6984dd304$var$isValueValidator = function isValueValidator(value) {
    return !!value;
};
module.exports.isValueValidator = $47c906d6984dd304$var$isValueValidator;
/**
 * Checks if any proper value was given
 * @param {any} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotNullValidator = function isNotNullValidator(value) {
    return value !== null;
};
module.exports.isNotNullValidator = $47c906d6984dd304$var$isNotNullValidator;
/**
 * Checks if value is not null
 * @param {any} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotUndefinedValidator = function isNotUndefinedValidator(value) {
    return value !== undefined;
};
module.exports.isNotUndefinedValidator = $47c906d6984dd304$var$isNotUndefinedValidator;
/**
 * Checks if value is not undefined
 * @param {any} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotEmptyUnlessValidator = function isNotEmptyUnlessValidator(value, canBeEmpty) {
    return canBeEmpty ? true : !!value;
};
module.exports.isNotEmptyUnlessValidator = $47c906d6984dd304$var$isNotEmptyUnlessValidator;
/**
 * Checks if value was given unless can be empty.
 * @param {string} value - value to check.
 * @param {boolean} canBeEmpty - if true validation is ignored
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotEmptyStringValidator = function isNotEmptyStringValidator(value) {
    return value !== '';
};
module.exports.isNotEmptyStringValidator = $47c906d6984dd304$var$isNotEmptyStringValidator;
/**
 * Checks if value is not empty string
 * @param {any} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotEmptyTrimmedStringValidator = function isNotEmptyTrimmedStringValidator(value) {
    return value.trim() !== '';
};
module.exports.isNotEmptyTrimmedStringValidator = $47c906d6984dd304$var$isNotEmptyTrimmedStringValidator;
/**
 * Checks if value is not empty string after trim
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isSelectedValidator = function isSelectedValidator(value) {
    return module.exports.isNotNullValidator(value) && module.exports.isNotUndefinedValidator(value) && value !== '' && value !== '?' && value !== '? string: ?' && value !== '? boolean: ?' && value !== '? undefined:undefined ?';
};
module.exports.isSelectedValidator = $47c906d6984dd304$var$isSelectedValidator;
/**
 * Checks if any option was chosen. Created for select2 library
 * @param {(string| boolean)} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNipValidator = function isNipValidator(value) {
    var weights = [
        6,
        5,
        7,
        2,
        3,
        4,
        5,
        6,
        7
    ];
    var nip = value.replace(/[\s-]|PL/g, '');
    var zip = function zip(rows) {
        return rows[0].map(function(_, c) {
            return rows.map(function(row) {
                return row[c];
            });
        });
    };
    if (nip.length === 10 && parseInt(nip, 10) > 0) {
        var zippedNip = zip([
            weights,
            nip.slice(0, 9)
        ]);
        var sum = zippedNip.map(function(_a) {
            var weight = _a[0], n = _a[1];
            return weight * n;
        }).reduce(function(a, b) {
            return a + b;
        }, 0);
        return sum % 11 === parseInt(nip[9], 10);
    }
    return false;
};
module.exports.isNipValidator = $47c906d6984dd304$var$isNipValidator;
/**
 * Checks if value is valid nip number
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isPostalCodeValidator = function isPostalCodeValidator(value, country) {
    return country === 'PL' ? !!value.match(/^\d{2}\-?\d{3}$/) && value !== '00-000' && value !== '00000' : country === 'CN' ? !!value.match(/^[0-9]{1,6}$/) : true;
};
module.exports.isPostalCodeValidator = $47c906d6984dd304$var$isPostalCodeValidator;
/**
 * Checks if value is valid polish or chinese postal code
 * @param {string} value - value to check.
 * @param {string} country - country of postal code.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isPasswordValidator = function isPasswordValidator(value) {
    return !!value.match(/^.{8,}$/);
};
module.exports.isPasswordValidator = $47c906d6984dd304$var$isPasswordValidator;
/**
 * Checks if value is valid password with 8 signs
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotSmallerValidator = function isNotSmallerValidator(value, minValue) {
    return value && parseFloat(value) >= parseFloat(minValue);
};
module.exports.isNotSmallerValidator = $47c906d6984dd304$var$isNotSmallerValidator;
/**
 * Checks if value is smaller than given minimal value
 * @param {string} value - value to check.
 * @param {string} minValue - minimal value.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotSmallerOrEqualValidator = function isNotSmallerOrEqualValidator(value, minValue) {
    return value && parseFloat(value) > parseFloat(minValue);
};
module.exports.isNotSmallerOrEqualValidator = $47c906d6984dd304$var$isNotSmallerOrEqualValidator;
/**
 * Checks if value is smaller or equal than given minimal value
 * @param {string} value - value to check.
 * @param {string} minValue - minimal value.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotHigherValidator = function isNotHigherValidator(value, maxValue) {
    return value && parseFloat(value) <= parseFloat(maxValue);
};
module.exports.isNotHigherValidator = $47c906d6984dd304$var$isNotHigherValidator;
/**
 * Checks if value is higher than given maximal value
 * @param {string} value - value to check.
 * @param {string} maxValue - maximal value.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotHigherOrEqualValidator = function isNotHigherOrEqualValidator(value, maxValue) {
    return value && parseFloat(value) < parseFloat(maxValue);
};
module.exports.isNotHigherOrEqualValidator = $47c906d6984dd304$var$isNotHigherOrEqualValidator;
/**
 * Checks if value is higher or equal than given maximal value
 * @param {string} value - value to check.
 * @param {string} maxValue - maximal value.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isEmailValidator = function isEmailValidator(value) {
    return value ? !!value.match(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i) : true;
};
module.exports.isEmailValidator = $47c906d6984dd304$var$isEmailValidator;
/**
 * Checks if value is valid email. Based on w3.org
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isMinLengthValidator = function isMinLengthValidator(value, minLength) {
    return value && value.length >= minLength;
};
module.exports.isMinLengthValidator = $47c906d6984dd304$var$isMinLengthValidator;
/**
 * Checks if value has smaller or equal length than given minimal length
 * @param {string} value - value to check.
 * @param {string} minLength - minimal length.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isMaxLengthValidator = function isMaxLengthValidator(value, maxLength) {
    return value && value.length <= maxLength;
};
module.exports.isMaxLengthValidator = $47c906d6984dd304$var$isMaxLengthValidator;
/**
 * Checks if value has bigger or equal length than given maximal length
 * @param {string} value - value to check.
 * @param {string} maxLength - maximal length.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isSameAsValidator = function isSameAsValidator(value, otherValue) {
    return value === otherValue;
};
module.exports.isSameAsValidator = $47c906d6984dd304$var$isSameAsValidator;
/**
 * Checks if value is equal to other value
 * @param {string} value - value to check.
 * @param {string} otherValue - other value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isOtherThanValidator = function isOtherThanValidator(value, otherValue) {
    return value !== otherValue;
};
module.exports.isOtherThanValidator = $47c906d6984dd304$var$isOtherThanValidator;
/**
 * Checks if value is not equal to other value
 * @param {string} value - value to check.
 * @param {string} otherValue - other value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isIbanValidator = function isIbanValidator(value, countryCode) {
    return $54HQr.ibanHelper.checkIban(value, countryCode);
};
module.exports.isIbanValidator = $47c906d6984dd304$var$isIbanValidator;
/**
 * Checks if value is valid iban number
 * @param {string} value - value to check.
 * @param {CountryCode} countryCode - country code.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isIbanLengthValidator = function isIbanLengthValidator(value, countryCode) {
    return $54HQr.ibanHelper.checkIbanLength(value, countryCode);
};
module.exports.isIbanLengthValidator = $47c906d6984dd304$var$isIbanLengthValidator;
/**
 * Checks if value is valid iban number
 * @param {string} value - value to check.
 * @param {CountryCode} countryCode - country code.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isLanNumberValidator = function isLanNumberValidator(value, country) {
    var lanCountriesRules = {
        AR: /^[0-9]{22}$/,
        AU: /^[A-Za-z0-9]{6,30}$/,
        BR: /^[0-9]{2,15}$/,
        CA: /^[A-Za-z0-9]{7,30}$/,
        CN: /^(?:OSA|NRA|FTN)?[A-Z0-9]{1,22}$/i,
        JP: /^[A-Za-z0-9]{7,14}$/,
        KR: /^[A-Za-z0-9]{11,16}$/,
        MX: /^[0-9]{18}$/,
        NZ: /^[A-Za-z0-9]{15,16}$/,
        PE: /^[0-9]{20}$/,
        SG: /^[A-Za-z0-9]{1,14}$/,
        TW: /^[A-Za-z0-9]{1,22}$/,
        US: /^[A-Za-z0-9]{9,30}$/,
        UY: /^[0-9]{7,14}$/
    };
    var defaultRule = /^[A-Za-z0-9]{1,30}$/;
    return !!value.replace(/ /g, '').match(lanCountriesRules[country] ? lanCountriesRules[country] : defaultRule);
};
module.exports.isLanNumberValidator = $47c906d6984dd304$var$isLanNumberValidator;
/**
 * Checks if value is valid non-iban account number
 * @param {string} value - value to check.
 * @param {string} [country] - optional country to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isRoutingCodeValidator = function isRoutingCodeValidator(value, country) {
    var countries = {
        BR: /^[0-9]{3}[0-9]{4,5}$/,
        CL: /^\d{3}$/,
        CO: /^(\d{2}|\d{5})$/,
        PE: /^[0-9]{3}$/,
        UY: /^[0-9]{4}$/
    };
    return !countries[country] || !!value.replace(/ /g, '').match(countries[country]);
};
module.exports.isRoutingCodeValidator = $47c906d6984dd304$var$isRoutingCodeValidator;
/**
 * Checks if value is valid routing code
 * @param {string} value - value to check.
 * @param {string} [country] - optional country to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isTaxNumberValidator = function isTaxNumberValidator(value, country, isCompany) {
    var countries = {
        AR: /^[0-9]{2}-?[0-9]{8}-?[0-9]{1}$/,
        BR: !isCompany ? /^[0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2}$/ : /^[0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2}$/,
        CL: /^(\d{1,3}(?:\.\d{1,3}){2}-[\dkK])$/,
        CO: /^\d{9}$/i,
        MX: /^[A-Za-z]{3,4}[ |\\-]{0,1}[0-9]{6}[ |\\-]{0,1}([0-9A-Za-z]{3})?$/,
        PE: /^[0-9]{6,9}$|^[0-9]{8}$|^[0-9]{11}$/,
        UY: /(^.{8,12}$)|(^[0-9]{2}[-]?[0-9]{6}[-]?[0-9]{3}[-]?[0-9]{1}$)|(^[0-9]{1}[\\.]?[0-9]{3}[\\.]?[0-9]{3}[-]?[0-9]$)/
    };
    return !countries[country] || !!value.replace(/ /g, '').match(countries[country]);
};
module.exports.isTaxNumberValidator = $47c906d6984dd304$var$isTaxNumberValidator;
/**
 * Checks if value is valid tax number
 * @param {string} value - value to check.
 * @param {string} [country] - optional country to check.
 * @param {boolean} [isCompany] - optional isCompany to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isCnapsCodeValidator = function isCnapsCodeValidator(value) {
    return !!value.match(/^\d{12}$/);
};
module.exports.isCnapsCodeValidator = $47c906d6984dd304$var$isCnapsCodeValidator;
/**
 * Checks if value is valid cnaps code
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isSwiftValidator = function isSwiftValidator(value) {
    return !!value.match(/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/i);
};
module.exports.isSwiftValidator = $47c906d6984dd304$var$isSwiftValidator;
/**
 * Checks if value is valid swift number
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isSwiftCountryValidator = function isSwiftCountryValidator(swift, country) {
    var swiftCountry = swift.substr(4, 2);
    return !country ? true : country === 'CN' ? [
        'CN',
        'HK',
        'MO'
    ].includes(swiftCountry) : swiftCountry === country;
};
module.exports.isSwiftCountryValidator = $47c906d6984dd304$var$isSwiftCountryValidator;
/**
 * Checks if given country is equal to country taken from swift
 * @param {string} swift - swift to check.
 * @param {string} country - country to compare.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isIdNumberValidator = function isIdNumberValidator(value) {
    var idNumberWeights = [
        7,
        3,
        1,
        9,
        7,
        3,
        1,
        7,
        3
    ];
    function checkIdNumber(id) {
        var controlSum = 0;
        for(var i = 0; i < id.length; i++)controlSum += i < 3 ? $47c906d6984dd304$var$value_of_letter_1.default(id[i]) * idNumberWeights[i] : parseInt(id[i], 10) * idNumberWeights[i];
        return controlSum % 10;
    }
    function isValid(id) {
        var parsedValue = id.replace(/ /g, '');
        return checkIdNumber(parsedValue) === 0 && parsedValue.length === 9;
    }
    return isValid(value);
};
module.exports.isIdNumberValidator = $47c906d6984dd304$var$isIdNumberValidator;
/**
 * Checks if value is valid polish id number
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isPassportValidator = function isPassportValidator(value) {
    var passportNumberWeights = [
        7,
        3,
        9,
        1,
        7,
        3,
        1,
        7,
        3
    ];
    function checkPassportNumber(passport) {
        var controlSum = 0;
        for(var i = 0; i < passport.length; i++)controlSum += i < 2 ? $47c906d6984dd304$var$value_of_letter_1.default(passport[i]) * passportNumberWeights[i] : parseInt(passport[i], 10) * passportNumberWeights[i];
        return controlSum % 10;
    }
    return checkPassportNumber(value) === 0 && value.length === 9;
};
module.exports.isPassportValidator = $47c906d6984dd304$var$isPassportValidator;
/**
 * Checks if value is valid polish passport number
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isPropValidator = function isPropValidator(validObject) {
    return !!validObject.valid;
};
module.exports.isPropValidator = $47c906d6984dd304$var$isPropValidator;
/**
 * Checks if given object has property valid and if it is equal to true
 * @param {{valid: boolean}} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isAllKeysValidator = function isAllKeysValidator(object, expectedKeys) {
    return expectedKeys.every(function(val) {
        return Object.keys(object).includes(val);
    });
};
module.exports.isAllKeysValidator = $47c906d6984dd304$var$isAllKeysValidator;
/**
 * Checks if given object has all keys
 * @param {object} object - value to check.
 * @param {string[]} expectedKeys - array of expected keys.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isLatinValidator = function isLatinValidator(value) {
    return !!value.match(/^(?:[\t-\r -~\xA0-\xA9\xAB\xAC\xAE-\xB1\xB4\xB6-\xB8\xBB\xBF-\u017F\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u037E\u0384\u0385\u0387\u03F6\u0482\u055A-\u055F\u0589\u058A\u058D-\u058F\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0606-\u060F\u061B\u061E\u061F\u066A-\u066D\u06D4\u06DE\u06E9\u06FD\u06FE\u0700-\u070D\u07F6-\u07F9\u07FE\u07FF\u0830-\u083E\u085E\u0964\u0965\u0970\u09F2\u09F3\u09FA\u09FB\u09FD\u0A76\u0AF0\u0AF1\u0B70\u0BF3-\u0BFA\u0C77\u0C7F\u0C84\u0D4F\u0D79\u0DF4\u0E3F\u0E4F\u0E5A\u0E5B\u0F01-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F85\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FDA\u104A-\u104F\u109E\u109F\u10FB\u1360-\u1368\u1390-\u1399\u1400\u166D\u166E\u1680\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DB\u1800-\u180A\u1940\u1944\u1945\u19DE-\u19FF\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B6A\u1B74-\u1B7C\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u1E9E\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2000-\u200A\u2010-\u2029\u202F-\u205F\u207A-\u207E\u208A-\u208E\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129-\u212B\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2775\u2794-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E52\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3000-\u3004\u3008-\u3020\u3030\u3036\u3037\u303D-\u303F\u309B\u309C\u30A0\u30FB\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAA77-\uAA79\uAADE\uAADF\uAAF0\uAAF1\uAB5B\uAB6A\uAB6B\uABEB\uFB29\uFBB2-\uFBC1\uFD3E\uFD3F\uFDFC\uFDFD\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFEFF\uFF01-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD00-\uDD02\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDC77\uDC78\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEC8\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3F]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFD5-\uDFF1\uDFFF]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3F\uDF44\uDF45]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F[\uDC9C\uDC9F]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE8B]|\uD838[\uDD4F\uDEFF]|\uD83A[\uDD5E\uDD5F]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA])+$/i);
};
module.exports.isLatinValidator = $47c906d6984dd304$var$isLatinValidator; /**
 * Checks if value is in Latin alphabet
 * or matches any kind of punctuation character
 * or matches any math symbols, currency signs, dingbats, box-drawing characters, etc
 * @param {string} value - value to check.
 * @returns {boolean}
 */ 

});
parcelRegister("54HQr", function(module, exports) {
"use strict";
var $3b1f562ac2636173$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3b1f562ac2636173$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3b1f562ac2636173$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3b1f562ac2636173$var$__exportStar((parcelRequire("gXzp5")), module.exports);

});
parcelRegister("gXzp5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ibanHelper = void 0;
module.exports.ibanHelper = {
    getCurrentCountryCode: function(iban) {
        return iban && iban.substr(0, 2).replace(/\d/g, '');
    },
    sanitize: function(iban) {
        return iban ? iban.replace(/\s/g, '') : null;
    },
    checkIbanLength: function(accountNumber, countryCode) {
        var sanitizedNumber = accountNumber.replace(/ /g, '');
        var isPrefix = sanitizedNumber.substr(0, 2).match(/[A-Z]/i);
        return countryCode === 'PL' && isPrefix && sanitizedNumber.length === 28 || countryCode === 'PL' && !isPrefix && sanitizedNumber.length === 26 || countryCode !== 'PL' && sanitizedNumber.length > 12;
    },
    checkIban: function(iban, countryCode) {
        iban = iban.toUpperCase().replace(/ /g, '');
        if (iban.length < 4) return false;
        // If country code is given, country code in iban should be the same as the given one
        // Or if there is no country code in iban, we add the given one
        if (countryCode) {
            var currentCountryCode = module.exports.ibanHelper.getCurrentCountryCode(iban);
            if (currentCountryCode) {
                if (currentCountryCode !== countryCode) return false;
            } else iban = "" + countryCode + iban;
        }
        if (!/^[A-Z]{2}/.test(iban)) return false;
        iban = iban.substr(4) + iban.substr(0, 4);
        var num = '';
        for(var i in iban)if (iban.hasOwnProperty(i)) {
            var c = iban[i];
            if (c >= '0' && c <= '9') num += c;
            else if (c >= 'A' && c <= 'Z') num += "" + (c.charCodeAt(0) - 55);
            else return false;
        }
        return module.exports.ibanHelper.iso7064Mod97_10(num) === 1;
    },
    iso7064Mod97_10: function(iban) {
        var remainder = iban;
        var block;
        while(remainder.length > 2){
            block = remainder.slice(0, 9);
            remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
        }
        return parseInt(remainder, 10) % 97;
    },
    getCompleteIban: function(iban, countryCode) {
        if (countryCode && iban) {
            var currentCountryCode = module.exports.ibanHelper.getCurrentCountryCode(iban);
            if (!currentCountryCode) iban = "" + countryCode + iban;
        }
        return module.exports.ibanHelper.sanitize(iban);
    }
};

});


parcelRegister("c9uu9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $8d8df90ed17471a8$var$valueOfLetter(value) {
    return value.toUpperCase().charCodeAt(0) - 55;
}
module.exports.default = $8d8df90ed17471a8$var$valueOfLetter;

});



parcelRegister("daEfo", function(module, exports) {

$parcel$export(module.exports, "t9n", function () { return $e2646c1083b46083$export$16fe4e029e1132f8; });

var $7iiIP = parcelRequire("7iiIP");

var $21DfC = parcelRequire("21DfC");

var $5xn28 = parcelRequire("5xn28");

var $f0qt3 = parcelRequire("f0qt3");

var $2GJ0A = parcelRequire("2GJ0A");

var $jmkw8 = parcelRequire("jmkw8");

var $9JuL0 = parcelRequire("9JuL0");

var $9XuHE = parcelRequire("9XuHE");

var $7MPYI = parcelRequire("7MPYI");

var $4Unqs = parcelRequire("4Unqs");

var $5MaYc = parcelRequire("5MaYc");

var $3sWA4 = parcelRequire("3sWA4");
const $e2646c1083b46083$var$translations = {
    [(0, $7iiIP.SupportedLanguages).pl]: (0, $21DfC.default),
    [(0, $7iiIP.SupportedLanguages).en]: (0, $5xn28.default),
    [(0, $7iiIP.SupportedLanguages).uk]: (0, $f0qt3.default),
    [(0, $7iiIP.SupportedLanguages).ru]: (0, $2GJ0A.default),
    [(0, $7iiIP.SupportedLanguages).de]: (0, $jmkw8.default),
    [(0, $7iiIP.SupportedLanguages).sk]: (0, $9JuL0.default),
    [(0, $7iiIP.SupportedLanguages).es]: (0, $9XuHE.default),
    [(0, $7iiIP.SupportedLanguages).cs]: (0, $7MPYI.default),
    [(0, $7iiIP.SupportedLanguages).ro]: (0, $4Unqs.default),
    [(0, $7iiIP.SupportedLanguages).fr]: (0, $5MaYc.default),
    [(0, $7iiIP.SupportedLanguages).it]: (0, $3sWA4.default)
};
const $e2646c1083b46083$var$getNestedValue = (obj, path)=>{
    return path.reduce((acc, key)=>acc?.[key], obj);
};
const $e2646c1083b46083$var$interpolate = (str, vars = {})=>{
    return str.replace(/{{\s*(\w+)\s*}}/g, (_, key)=>vars[key] ?? '');
};
const $e2646c1083b46083$export$16fe4e029e1132f8 = (key, vars, lang = (0, $7iiIP.getCurrentLanguage)())=>{
    const messages = $e2646c1083b46083$var$translations[lang] || $e2646c1083b46083$var$translations[(0, $7iiIP.SupportedLanguages).pl];
    const path = key.split('.');
    const raw = $e2646c1083b46083$var$getNestedValue(messages, path);
    return raw ? $e2646c1083b46083$var$interpolate(raw, vars) : key;
};

});
parcelRegister("7iiIP", function(module, exports) {

$parcel$export(module.exports, "SupportedLanguages", function () { return $e808b7286267199c$export$fcdd902bf6e4111a; });
$parcel$export(module.exports, "getLangFromUrl", function () { return $e808b7286267199c$export$5803c3c1cacc7a03; });
$parcel$export(module.exports, "setCookieLangFromUrl", function () { return $e808b7286267199c$export$3c45ba324da40a57; });
$parcel$export(module.exports, "getCurrentLanguage", function () { return $e808b7286267199c$export$604ba5624273df44; });

var $gFmOc = parcelRequire("gFmOc");

var $bg4xJ = parcelRequire("bg4xJ");

var $gXaPs = parcelRequire("gXaPs");
var $e808b7286267199c$export$fcdd902bf6e4111a = /*#__PURE__*/ function(SupportedLanguages) {
    SupportedLanguages["pl"] = "pl";
    SupportedLanguages["en"] = "en";
    SupportedLanguages["ru"] = "ru";
    SupportedLanguages["uk"] = "uk";
    SupportedLanguages["de"] = "de";
    SupportedLanguages["sk"] = "sk";
    SupportedLanguages["it"] = "it";
    SupportedLanguages["ro"] = "ro";
    SupportedLanguages["cs"] = "cs";
    SupportedLanguages["es"] = "es";
    SupportedLanguages["fr"] = "fr";
    return SupportedLanguages;
}({});
const $e808b7286267199c$export$910b680d1eea6990 = "pl";
const $e808b7286267199c$var$isBrowser = typeof window !== 'undefined';
const $e808b7286267199c$export$47c66070d6d6cd6d = (lang)=>typeof lang === 'string' && Object.values($e808b7286267199c$export$fcdd902bf6e4111a).includes(lang);
const $e808b7286267199c$export$e7bdde1845b77176 = ()=>{
    const cookieLang = (0, $gFmOc.default).getItem('language');
    return $e808b7286267199c$export$47c66070d6d6cd6d(cookieLang) ? cookieLang : null;
};
const $e808b7286267199c$export$5803c3c1cacc7a03 = (pathname)=>{
    const url = pathname || window.location.pathname;
    let lang = 'pl';
    Object.values($e808b7286267199c$export$fcdd902bf6e4111a).forEach((supportedLang)=>{
        if (url.includes(`/${supportedLang}/`) || url === `/${supportedLang}`) lang = supportedLang;
    });
    return lang;
};
const $e808b7286267199c$export$3c45ba324da40a57 = ()=>{
    const urlLang = String($e808b7286267199c$export$5803c3c1cacc7a03()).toLowerCase();
    (0, $gFmOc.default).setItem('language', urlLang, (0, $gFmOc.default).maximalCookieTTL);
};
const $e808b7286267199c$export$3b80a101022deeba = ()=>{
    let langParam = (0, $bg4xJ.getSingleParamFromUrl)('lang') || (0, $bg4xJ.getSingleParamFromUrl)('language');
    if (langParam === 'ua') langParam = 'uk' // ua is another name for uk
    ;
    return $e808b7286267199c$export$47c66070d6d6cd6d(langParam) ? langParam : null;
};
const $e808b7286267199c$export$b45fa50bf92adae6 = ()=>{
    const langFromEnv = $gXaPs?.env?.LANGUAGE;
    return $e808b7286267199c$export$47c66070d6d6cd6d(langFromEnv) ? langFromEnv : $e808b7286267199c$export$910b680d1eea6990;
};
const $e808b7286267199c$export$a3a2ff4338ba4f37 = ()=>{
    const firstSeg = window.location.pathname.split('/').filter(Boolean)[0];
    return $e808b7286267199c$export$47c66070d6d6cd6d(firstSeg) ? firstSeg : $e808b7286267199c$export$910b680d1eea6990;
};
const $e808b7286267199c$var$initialLanguage = $e808b7286267199c$var$isBrowser ? $e808b7286267199c$export$a3a2ff4338ba4f37() : $e808b7286267199c$export$b45fa50bf92adae6();
function $e808b7286267199c$export$604ba5624273df44() {
    if (!$e808b7286267199c$var$isBrowser) return $e808b7286267199c$var$initialLanguage;
    return $e808b7286267199c$export$3b80a101022deeba() ?? $e808b7286267199c$var$initialLanguage;
}

});
parcelRegister("gFmOc", function(module, exports) {

$parcel$export(module.exports, "setupCookies", function () { return $65c1a8927d8c0271$export$bc2fa9517e566815; });
$parcel$export(module.exports, "getAllowedCookies", function () { return $65c1a8927d8c0271$export$78bb765b962664de; });
$parcel$export(module.exports, "default", function () { return $65c1a8927d8c0271$export$2e2bcd8739ae039; });

var $j0XCl = parcelRequire("j0XCl");

var $7iiIP = parcelRequire("7iiIP");

var $4j5kN = parcelRequire("4j5kN");

var $6pOWp = parcelRequire("6pOWp");

var $bg4xJ = parcelRequire("bg4xJ");
const $65c1a8927d8c0271$export$bc2fa9517e566815 = ()=>{
    const decodedParams = (0, $bg4xJ.decodeUrlParams)(window.location.href);
    $65c1a8927d8c0271$var$cookieService.setupCookiesFromURL((0, $4j5kN.allowedParamsIds), decodedParams);
    (0, $7iiIP.setCookieLangFromUrl)();
    (0, $6pOWp.default).saveCookiesFromURL((0, $4j5kN.allowedReferalParams), decodedParams);
};
const $65c1a8927d8c0271$export$78bb765b962664de = (allowedCookies)=>{
    const cookiesArray = {};
    allowedCookies.forEach((item)=>{
        const cookieValue = $65c1a8927d8c0271$var$cookieService.getItem(item);
        if (cookieValue) cookiesArray[item] = cookieValue;
    });
    return cookiesArray;
};
const $65c1a8927d8c0271$export$79fcbe1b192cd706 = (domain = null)=>(domain || location.hostname).replace(/^(https?:\/\/)?(www\.)?/, '.');
const $65c1a8927d8c0271$var$cookieService = {
    maximalCookieTTL: 90,
    setItem: (key, value, days = 365, domain = '', sameSite = 'Lax')=>{
        const currentDate = new Date();
        currentDate.setTime(+currentDate + days * 86400000);
        document.cookie = `${key}=${value}; path=/; domain=${$65c1a8927d8c0271$export$79fcbe1b192cd706(domain)}; expires=${currentDate.toUTCString()}; SameSite=${sameSite}; Secure`;
    },
    getItem: (name)=>{
        if (!document.cookie) return null;
        const cookies = document.cookie.split('; ');
        const cookie = cookies.find((cookie)=>cookie.startsWith(`${name}=`));
        if (!cookie) return null;
        return cookie.substring(name.length + 1);
    },
    removeItem (key, domain) {
        if (document.cookie) {
            const zeroTime = new Date(0);
            document.cookie = `${key}=; expires=${zeroTime.toUTCString()}${domain ? `; domain=${domain}` : ''}; path=/`;
        }
    },
    setCookieByParamUrl (paramKey, cookieKey) {
        const urlParamsObject = (0, $bg4xJ.getParamsFromUrl)();
        if ((0, $bg4xJ.doesUrlContainParam)(paramKey, urlParamsObject)) $65c1a8927d8c0271$var$cookieService.setItem(cookieKey, urlParamsObject[paramKey], $65c1a8927d8c0271$var$cookieService.maximalCookieTTL);
    },
    setupCookiesFromURL: (allowedParamsIds, decodedParams)=>{
        const validParamsToStore = (0, $6pOWp.getValidParamsToStore)(allowedParamsIds, decodedParams);
        let cookiesSet = false;
        for(const paramName in validParamsToStore)if ((0, $bg4xJ.doesUrlContainParam)(paramName, validParamsToStore)) {
            const cookieName = paramName === 'xchangerId' ? 'xchanger_id' : paramName;
            $65c1a8927d8c0271$var$cookieService.setItem((0, $j0XCl.jsEscape)(cookieName), (0, $j0XCl.jsEscape)(validParamsToStore[paramName]), $65c1a8927d8c0271$var$cookieService.maximalCookieTTL);
            cookiesSet = true;
        }
        return cookiesSet;
    },
    setupCookiesFromClient: ()=>{
        if ($65c1a8927d8c0271$var$cookieService.getItem('ik_referrer')) // TODO: Check is this code relevant for us.
        $65c1a8927d8c0271$var$cookieService.setItem('ik_referrer', document.referrer, 730);
    }
};
var $65c1a8927d8c0271$export$2e2bcd8739ae039 = $65c1a8927d8c0271$var$cookieService;

});
parcelRegister("j0XCl", function(module, exports) {

$parcel$export(module.exports, "jsEscape", function () { return $92a8ba19a4daa20d$export$3f99cc35b82cb6c3; });
function $92a8ba19a4daa20d$export$acafce1f52201e8f(str) {
    return String(str).replace(/[^\w,. żźćńółęąśŻŹĆĄŚĘŁÓŃ]/gi, function(c) {
        return `&#${c.charCodeAt(0)};`;
    });
}
function $92a8ba19a4daa20d$export$3f99cc35b82cb6c3(str) {
    return String(str).replace(/[^\w,. żźćńółęąśŻŹĆĄŚĘŁÓŃ]/gi, function(c) {
        return `\\u${`0000${c.charCodeAt(0).toString(16)}`.slice(-4)}`;
    });
}

});

parcelRegister("4j5kN", function(module, exports) {

$parcel$export(module.exports, "allowedFunctionalCookies", function () { return $346dde72007f870d$export$9faac3ad31a8b3a0; });
$parcel$export(module.exports, "allAllowedCookies", function () { return $346dde72007f870d$export$db53466c6322891d; });
$parcel$export(module.exports, "allowedFunctionalCookiesForPanel", function () { return $346dde72007f870d$export$b52e95d1c236985a; });
$parcel$export(module.exports, "allAllowedCookiesForPanel", function () { return $346dde72007f870d$export$19e864c0c84efb0a; });
$parcel$export(module.exports, "allowedPartnerParams", function () { return $346dde72007f870d$export$27b8ff3de6fbdafe; });
$parcel$export(module.exports, "refvisParams", function () { return $346dde72007f870d$export$cf9fc973022c8ec9; });
$parcel$export(module.exports, "allowedReferalParams", function () { return $346dde72007f870d$export$db7a0dab00964012; });
$parcel$export(module.exports, "allowedParamsIds", function () { return $346dde72007f870d$export$ecec81a557091bf0; });
const $346dde72007f870d$export$81fa7ed7fa33276c = [
    'refererCode',
    'utm_source',
    'utm_campaign',
    'utm_medium',
    'utm_term',
    'utm_content',
    'ref',
    'refvis',
    'uap',
    'bankiervis'
];
const $346dde72007f870d$export$9faac3ad31a8b3a0 = [
    'language',
    'promo_popup',
    'promoPopup__showed'
];
const $346dde72007f870d$export$db53466c6322891d = [
    ...$346dde72007f870d$export$81fa7ed7fa33276c,
    ...$346dde72007f870d$export$9faac3ad31a8b3a0
];
const $346dde72007f870d$export$b52e95d1c236985a = [
    'language'
];
const $346dde72007f870d$export$19e864c0c84efb0a = [
    ...$346dde72007f870d$export$81fa7ed7fa33276c,
    ...$346dde72007f870d$export$b52e95d1c236985a
];
const $346dde72007f870d$export$46c8ad09d7879223 = [
    {
        name: 'utm_source',
        type: 'string'
    },
    {
        name: 'utm_medium',
        type: 'string'
    },
    {
        name: 'utm_term',
        type: 'string'
    },
    {
        name: 'utm_content',
        type: 'string'
    },
    {
        name: 'utm_campaign',
        type: 'string'
    }
];
const $346dde72007f870d$export$27b8ff3de6fbdafe = [
    {
        name: 'at_gd',
        type: 'string'
    },
    {
        name: 'xchangerId',
        type: 'string'
    },
    {
        name: 'bankierID',
        type: 'string'
    },
    {
        name: 'clickId',
        type: 'string'
    },
    {
        name: 'uap',
        type: 'string'
    }
];
const $346dde72007f870d$export$cf9fc973022c8ec9 = [
    {
        name: 'ref',
        type: 'string'
    },
    ...$346dde72007f870d$export$46c8ad09d7879223,
    ...$346dde72007f870d$export$27b8ff3de6fbdafe
];
const $346dde72007f870d$export$db7a0dab00964012 = [
    ...$346dde72007f870d$export$46c8ad09d7879223,
    ...$346dde72007f870d$export$27b8ff3de6fbdafe,
    {
        name: 'ref',
        type: 'string'
    },
    {
        name: 'refererCode',
        type: 'string'
    }
];
const $346dde72007f870d$export$ecec81a557091bf0 = [
    {
        name: 'promo_popup',
        type: 'boolean'
    },
    {
        name: 'promoPopup__showed',
        type: 'boolean'
    }
];

});

parcelRegister("6pOWp", function(module, exports) {

$parcel$export(module.exports, "getValidParamsToStore", function () { return $2a5b843d4c4e3925$export$715ae024758eeb8e; });
$parcel$export(module.exports, "storeSessionMarketingItemsAsCookies", function () { return $2a5b843d4c4e3925$export$a01506ac0399ddad; });
$parcel$export(module.exports, "default", function () { return $2a5b843d4c4e3925$export$2e2bcd8739ae039; });

var $j0XCl = parcelRequire("j0XCl");

var $gFmOc = parcelRequire("gFmOc");

var $bg4xJ = parcelRequire("bg4xJ");
function $2a5b843d4c4e3925$export$715ae024758eeb8e(allowedParamsIds, decodedParams) {
    const paramsToStore = decodedParams || (0, $bg4xJ.getParamsFromUrl)();
    return Object.keys(paramsToStore).reduce((acc, paramName)=>{
        const allowedParam = allowedParamsIds.find((ap)=>ap.name === paramName);
        const paramValue = paramsToStore[paramName];
        if (allowedParam && (0, $bg4xJ.validateParam)(allowedParam, paramValue)) acc[paramName] = paramValue;
        else console.warn(`Invalid or unauthorized parameter: ${paramName}`);
        return acc;
    }, {});
}
function $2a5b843d4c4e3925$export$a01506ac0399ddad(allowedParamsIds) {
    const items = $2a5b843d4c4e3925$var$sessionStorageService.getAllItems();
    Object.keys(items).forEach((key)=>{
        const allowedParam = allowedParamsIds.find((ap)=>ap.name === key);
        const paramName = items[key];
        if (allowedParam && (0, $bg4xJ.validateParam)(allowedParam, paramName)) (0, $gFmOc.default).setItem(key, paramName, (0, $gFmOc.default).maximalCookieTTL);
        else console.warn(`Invalid or unauthorized parameter: ${key}`);
    });
}
const $2a5b843d4c4e3925$var$sessionStorageService = {
    storage: typeof window !== 'undefined' ? window.sessionStorage : null,
    setItem (key, value) {
        const escapedKey = (0, $j0XCl.jsEscape)(key);
        const escapedValue = (0, $j0XCl.jsEscape)(value);
        this.storage.setItem(escapedKey, escapedValue);
    },
    getItem (key) {
        return this.storage.getItem((0, $j0XCl.jsEscape)(key));
    },
    removeItem (key) {
        this.storage.removeItem((0, $j0XCl.jsEscape)(key));
    },
    removeAll () {
        this.storage.clear();
    },
    removeItems (allowedParams) {
        const allItems = this.getAllItems();
        allowedParams.forEach((param)=>{
            if (allItems[param.name]) this.removeItem(param.name);
        });
    },
    saveCookiesFromURL: (allowedParamsIds, decodedParams)=>{
        const validParamsToStore = $2a5b843d4c4e3925$export$715ae024758eeb8e(allowedParamsIds, decodedParams);
        Object.keys(validParamsToStore).forEach((paramName)=>{
            if ((0, $bg4xJ.doesUrlContainParam)(paramName, validParamsToStore)) {
                const cookieName = paramName === 'xchangerId' ? 'xchanger_id' : paramName;
                $2a5b843d4c4e3925$var$sessionStorageService.setItem(cookieName, validParamsToStore[paramName]);
            }
        });
    },
    getAllItems () {
        const cookies = {};
        for (const [key, value] of Object.entries(sessionStorage))cookies[key] = value;
        return cookies;
    }
};
var $2a5b843d4c4e3925$export$2e2bcd8739ae039 = $2a5b843d4c4e3925$var$sessionStorageService;

});
parcelRegister("bg4xJ", function(module, exports) {

$parcel$export(module.exports, "isPanelUrl", function () { return $265222550428d748$export$20980cc1374e1b8c; });
$parcel$export(module.exports, "isInternalUrl", function () { return $265222550428d748$export$4006295459a20a0; });
$parcel$export(module.exports, "doesUrlContainParam", function () { return $265222550428d748$export$902ed42de98921ac; });
$parcel$export(module.exports, "getParamsFromUrl", function () { return $265222550428d748$export$9b6f748a4c74bb77; });
$parcel$export(module.exports, "getSingleParamFromUrl", function () { return $265222550428d748$export$b8eaffbd63e11c5f; });
$parcel$export(module.exports, "removeUrlParams", function () { return $265222550428d748$export$4f9c066ec897736f; });
$parcel$export(module.exports, "renameQueryParam", function () { return $265222550428d748$export$e16de3bdbb617fe2; });
$parcel$export(module.exports, "decodeUrlParams", function () { return $265222550428d748$export$f002049d3814fdfc; });
$parcel$export(module.exports, "createUrlWithParams", function () { return $265222550428d748$export$a8593f22bf2d4f51; });
$parcel$export(module.exports, "validateParam", function () { return $265222550428d748$export$304e24f68705812f; });

var $7iiIP = parcelRequire("7iiIP");

var $e8uY7 = parcelRequire("e8uY7");
const $265222550428d748$export$20980cc1374e1b8c = (url)=>url.hostname.includes('user.') || url.hostname.includes('panel.') || url.hostname.includes('biz.');
const $265222550428d748$export$4006295459a20a0 = async (url)=>{
    const origin = url.origin;
    const { static_pl: static_pl, static_com: static_com } = await (0, $e8uY7.getDomainsFromAPI)();
    const staticOrigin = static_pl ? new URL(static_pl).origin : null;
    const staticComOrigin = static_com ? new URL(static_com).origin : null;
    return origin === staticOrigin || origin === staticComOrigin || $265222550428d748$export$20980cc1374e1b8c(url);
};
const $265222550428d748$export$902ed42de98921ac = (key, urlParamsObject)=>{
    urlParamsObject = urlParamsObject || $265222550428d748$export$9b6f748a4c74bb77();
    return !!urlParamsObject[key];
};
const $265222550428d748$export$9b6f748a4c74bb77 = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    return Array.from(urlParams.keys()).length > 0 ? Object.fromEntries(urlParams.entries()) : {};
};
const $265222550428d748$export$b8eaffbd63e11c5f = (key)=>{
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(key) ? urlParams.get(key) : null;
};
const $265222550428d748$export$4f9c066ec897736f = (url, paramsToRemove)=>{
    const urlObj = new URL(url);
    const searchParams = urlObj.searchParams;
    paramsToRemove.forEach((param)=>searchParams.delete(param));
    return urlObj.origin + urlObj.pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '') + urlObj.hash;
};
function $265222550428d748$export$e16de3bdbb617fe2(fromParam, toParam) {
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;
    if (params.has(fromParam)) {
        const value = params.get(fromParam);
        params.delete(fromParam);
        params.set(toParam, value || '');
        const newUrl = `${currentUrl.pathname}?${params.toString()}${currentUrl.hash}`;
        window.history.replaceState({}, '', newUrl);
    }
}
const $265222550428d748$export$f002049d3814fdfc = (url)=>{
    try {
        const { search: search, hash: hash } = new URL(url);
        const searchParams = Object.fromEntries(new URLSearchParams(search).entries());
        const paramsString = hash.startsWith('#/?') ? hash.slice(2) : '';
        const encodedParams = paramsString ? new URLSearchParams(paramsString).get('data') : null;
        let decodedParams = {};
        if (encodedParams) {
            decodedParams = JSON.parse(decodeURIComponent(encodedParams));
            decodedParams = Array.isArray(decodedParams) ? Object.assign({}, ...decodedParams) : decodedParams;
        }
        return {
            ...searchParams,
            ...decodedParams
        };
    } catch (error) {
        console.error('Error decoding URL params:', error);
        return {};
    }
};
const $265222550428d748$export$a8593f22bf2d4f51 = (cookiesToParam, url)=>{
    const newUrl = new URL(url);
    const queryParams = new URLSearchParams(Object.entries(cookiesToParam).map(([key, value])=>[
            key,
            String(value)
        ]));
    if (!$265222550428d748$export$20980cc1374e1b8c(newUrl)) {
        if (queryParams.has('language') || queryParams.has('lang')) {
            queryParams.delete('lang');
            queryParams.set('language', (0, $7iiIP.getLangFromUrl)(newUrl.pathname));
        }
        newUrl.search = queryParams.toString();
        return newUrl.toString();
    }
    newUrl.searchParams.delete('lang');
    if (queryParams.has('language')) {
        newUrl.searchParams.set('lang', queryParams.get('language'));
        queryParams.delete('language');
    } else newUrl.searchParams.set('lang', (0, $7iiIP.getCurrentLanguage)());
    const remainingParams = queryParams.toString();
    if (remainingParams) {
        const hash = newUrl.hash || '#/';
        const separator = hash.includes('?') ? '&' : '?';
        newUrl.hash = `${hash}${separator}${remainingParams}`;
    } else if (!newUrl.hash) newUrl.hash = '#/';
    return newUrl.toString();
};
const $265222550428d748$export$1457c30cc3cb2c05 = (registryUrl, params = {})=>$265222550428d748$export$a8593f22bf2d4f51(params, new URL(registryUrl));
function $265222550428d748$export$304e24f68705812f(param, value) {
    if (param.type === 'boolean') try {
        return JSON.parse(value) === true || JSON.parse(value) === false;
    } catch (e) {
        return false;
    }
    if (param.type === 'string') {
        if (typeof value !== 'string' || value === 'true' || value === 'false') return false;
        if (param.name === 'lang' && param.allowedValues) {
            const allowedLanguages = Object.values((0, $7iiIP.SupportedLanguages));
            return allowedLanguages.includes(value);
        }
        return true;
    }
    return false;
}

});
parcelRegister("e8uY7", function(module, exports) {

$parcel$export(module.exports, "getDomainsFromAPI", function () { return $1862bb7b881b7cbf$export$ece6aa4cf7ebf9e4; });

var $k0eal = parcelRequire("k0eal");
const $1862bb7b881b7cbf$export$ece6aa4cf7ebf9e4 = async ()=>{
    return (0, $k0eal.promiseWrapper)(`${window.location.origin}/wp-json/support/domains`, 'GET');
};

});
parcelRegister("k0eal", function(module, exports) {

$parcel$export(module.exports, "isHttpError", function () { return $6e91e54d378b3a63$export$97b788730ba59845; });
$parcel$export(module.exports, "promiseWrapper", function () { return $6e91e54d378b3a63$export$fb9752378c4199d7; });
const $6e91e54d378b3a63$export$407cd31b5bcdc779 = (status, statusText, data)=>Object.assign(new Error(`Request failed with status code ${status}`), {
        name: 'HttpError',
        response: {
            status: status,
            statusText: statusText,
            data: data
        }
    });
const $6e91e54d378b3a63$export$97b788730ba59845 = (error)=>error instanceof Error && error.name === 'HttpError';
const $6e91e54d378b3a63$export$262c4a35fb53be19 = ()=>Object.assign(new Error('Network error or CORS issue'), {
        name: 'NetworkError',
        isNetworkError: true
    });
const $6e91e54d378b3a63$export$476aa014e2fd89d5 = (error)=>error instanceof Error && error.name === 'NetworkError';
const $6e91e54d378b3a63$export$11fdf30e2badbcb6 = (error, status)=>$6e91e54d378b3a63$export$97b788730ba59845(error) && error.response.status === status;
const $6e91e54d378b3a63$export$fb9752378c4199d7 = (url, method, data, options, abortSignal)=>new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.open(method, url);
        const onAbort = ()=>{
            xhr.abort();
            reject(new DOMException('Request cancelled', 'AbortError'));
        };
        abortSignal?.addEventListener('abort', onAbort, {
            once: true
        });
        const detachAbortListener = ()=>abortSignal?.removeEventListener('abort', onAbort);
        if (method === 'POST' || method === 'PUT') xhr.setRequestHeader('Content-type', options?.contentType || 'application/json');
        if (options?.headers) Object.entries(options.headers).forEach(([key, value])=>{
            xhr.setRequestHeader(key, value);
        });
        if (options?.withCredentials) xhr.withCredentials = true;
        xhr.onload = ()=>{
            detachAbortListener();
            let responseData = xhr.response;
            //TODO: we should base parsing on this header, but first we need to correct the endpoints served from wp
            // const isJsonResponse = (xhr.getResponseHeader('Content-Type') ?? '').includes('application/json')
            //
            // if (isJsonResponse && xhr.response) {
            //   try {
            //     responseData = JSON.parse(xhr.response)
            //   } catch {
            //     // Content-Type claims JSON but body isn't valid JSON — keep the raw response.
            //   }
            // }
            // Until then: don't trust `Content-Type` — the cached `/wp-json/*` routes serve JSON as
            // `application/octet-stream` / `text/html`. Parse whatever parses, keep the rest raw.
            if (typeof responseData === 'string' && responseData) try {
                responseData = JSON.parse(responseData);
            } catch  {
            // Not JSON (or a malformed body) — keep the raw response.
            }
            if (xhr.status >= 200 && xhr.status < 300) resolve(responseData);
            else reject($6e91e54d378b3a63$export$407cd31b5bcdc779(xhr.status, xhr.statusText, responseData));
        };
        xhr.onerror = ()=>{
            detachAbortListener();
            reject($6e91e54d378b3a63$export$262c4a35fb53be19());
        };
        xhr.send(data ? options?.noJson ? data.toString() : JSON.stringify(data) : null);
    });

});





parcelRegister("gXaPs", function(module, exports) {
// shim for using process in browser
var $c57a8e741463be4d$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $c57a8e741463be4d$var$cachedSetTimeout;
var $c57a8e741463be4d$var$cachedClearTimeout;
function $c57a8e741463be4d$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $c57a8e741463be4d$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $c57a8e741463be4d$var$cachedSetTimeout = setTimeout;
        else $c57a8e741463be4d$var$cachedSetTimeout = $c57a8e741463be4d$var$defaultSetTimout;
    } catch (e) {
        $c57a8e741463be4d$var$cachedSetTimeout = $c57a8e741463be4d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $c57a8e741463be4d$var$cachedClearTimeout = clearTimeout;
        else $c57a8e741463be4d$var$cachedClearTimeout = $c57a8e741463be4d$var$defaultClearTimeout;
    } catch (e) {
        $c57a8e741463be4d$var$cachedClearTimeout = $c57a8e741463be4d$var$defaultClearTimeout;
    }
})();
function $c57a8e741463be4d$var$runTimeout(fun) {
    if ($c57a8e741463be4d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($c57a8e741463be4d$var$cachedSetTimeout === $c57a8e741463be4d$var$defaultSetTimout || !$c57a8e741463be4d$var$cachedSetTimeout) && setTimeout) {
        $c57a8e741463be4d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c57a8e741463be4d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $c57a8e741463be4d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $c57a8e741463be4d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $c57a8e741463be4d$var$runClearTimeout(marker) {
    if ($c57a8e741463be4d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($c57a8e741463be4d$var$cachedClearTimeout === $c57a8e741463be4d$var$defaultClearTimeout || !$c57a8e741463be4d$var$cachedClearTimeout) && clearTimeout) {
        $c57a8e741463be4d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c57a8e741463be4d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $c57a8e741463be4d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $c57a8e741463be4d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $c57a8e741463be4d$var$queue = [];
var $c57a8e741463be4d$var$draining = false;
var $c57a8e741463be4d$var$currentQueue;
var $c57a8e741463be4d$var$queueIndex = -1;
function $c57a8e741463be4d$var$cleanUpNextTick() {
    if (!$c57a8e741463be4d$var$draining || !$c57a8e741463be4d$var$currentQueue) return;
    $c57a8e741463be4d$var$draining = false;
    if ($c57a8e741463be4d$var$currentQueue.length) $c57a8e741463be4d$var$queue = $c57a8e741463be4d$var$currentQueue.concat($c57a8e741463be4d$var$queue);
    else $c57a8e741463be4d$var$queueIndex = -1;
    if ($c57a8e741463be4d$var$queue.length) $c57a8e741463be4d$var$drainQueue();
}
function $c57a8e741463be4d$var$drainQueue() {
    if ($c57a8e741463be4d$var$draining) return;
    var timeout = $c57a8e741463be4d$var$runTimeout($c57a8e741463be4d$var$cleanUpNextTick);
    $c57a8e741463be4d$var$draining = true;
    var len = $c57a8e741463be4d$var$queue.length;
    while(len){
        $c57a8e741463be4d$var$currentQueue = $c57a8e741463be4d$var$queue;
        $c57a8e741463be4d$var$queue = [];
        while(++$c57a8e741463be4d$var$queueIndex < len)if ($c57a8e741463be4d$var$currentQueue) $c57a8e741463be4d$var$currentQueue[$c57a8e741463be4d$var$queueIndex].run();
        $c57a8e741463be4d$var$queueIndex = -1;
        len = $c57a8e741463be4d$var$queue.length;
    }
    $c57a8e741463be4d$var$currentQueue = null;
    $c57a8e741463be4d$var$draining = false;
    $c57a8e741463be4d$var$runClearTimeout(timeout);
}
$c57a8e741463be4d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $c57a8e741463be4d$var$queue.push(new $c57a8e741463be4d$var$Item(fun, args));
    if ($c57a8e741463be4d$var$queue.length === 1 && !$c57a8e741463be4d$var$draining) $c57a8e741463be4d$var$runTimeout($c57a8e741463be4d$var$drainQueue);
};
// v8 likes predictible objects
function $c57a8e741463be4d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$c57a8e741463be4d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$c57a8e741463be4d$var$process.title = 'browser';
$c57a8e741463be4d$var$process.browser = true;
$c57a8e741463be4d$var$process.env = {};
$c57a8e741463be4d$var$process.argv = [];
$c57a8e741463be4d$var$process.version = ''; // empty string to avoid regexp issues
$c57a8e741463be4d$var$process.versions = {};
function $c57a8e741463be4d$var$noop() {}
$c57a8e741463be4d$var$process.on = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.addListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.once = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.off = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.removeListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.removeAllListeners = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.emit = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.prependListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.prependOnceListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.listeners = function(name) {
    return [];
};
$c57a8e741463be4d$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$c57a8e741463be4d$var$process.cwd = function() {
    return '/';
};
$c57a8e741463be4d$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$c57a8e741463be4d$var$process.umask = function() {
    return 0;
};

});


parcelRegister("21DfC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $735476bfba0f5402$export$2e2bcd8739ae039; });
var $735476bfba0f5402$export$2e2bcd8739ae039 = {
    highcharts: {
        decimalPoint: ',',
        downloadJPEG: 'Pobierz obraz JPEG',
        downloadPDF: 'Pobierz dokument PDF',
        downloadPNG: 'Pobierz obraz PNG',
        downloadSVG: 'Pobierz obraz SVG',
        exportButtonTitle: 'Eksport',
        forexRate: "Kurs \u015Bredni FOREX",
        loading: "\u0141adowanie...",
        months: [
            "Stycze\u0144",
            'Luty',
            'Marzec',
            "Kwiecie\u0144",
            'Maj',
            'Czerwiec',
            'Lipiec',
            "Sierpie\u0144",
            "Wrzesie\u0144",
            "Pa\u017Adziernik",
            'Listopad',
            "Grudzie\u0144"
        ],
        printButtonTitle: 'Drukowanie',
        rangeSelectorFrom: 'Od',
        rangeSelectorTo: 'Do',
        rangeSelectorZoom: "Przybli\u017Cenie",
        rateTypes: {
            ask: "Najlepsza oferta sprzeda\u017Cy",
            bid: 'Najlepsza oferta kupna',
            forex: "\u015Aredni kurs na \u015Bwiecie"
        },
        resetZoom: 'Reset',
        resetZoomTitle: 'Reset',
        shortMonths: [
            'Sty',
            'Lut',
            'Mar',
            'Kwi',
            'Maj',
            'Cze',
            'Lip',
            'Sie',
            'Wrz',
            "Pa\u017A",
            'Lis',
            'Gru'
        ],
        thousandsSep: ' ',
        weekdays: [
            'Niedziela',
            "Poniedzia\u0142ek",
            'Wtorek',
            "\u015Aroda",
            'Czwartek',
            "Pi\u0105tek",
            'Sobota'
        ],
        wtBestAsk: "Najlepsza oferta sprzeda\u017Cy",
        wtBestBid: 'Najlepsza oferta kupna',
        seriesError: "Musi by\u0107 zaznaczona co najmniej jedna opcja"
    },
    calculator: {
        title: "Oblicz oszcz\u0119dno\u015B\u0107 w Walutomacie",
        forBuy: 'za',
        unsupportedPair: "Aktualnie nie oferujemy kurs\xf3w dla wybranej pary walutowej.",
        spinnerError: {
            generic: "Wyst\u0105pi\u0142 problem podczas pobierania danych",
            toManyRequests: 'Kalkulator jest aktualnie niedost\u0119pny. Spr\xf3buj ponownie p\xf3\u017Aniej lub skontaktuj si\u0119 z <a href="https://www.walutomat.pl/kontakt/">Biurem Obs\u0142ugi Klienta</a>.'
        },
        commissionWT: 'Prowizja Walutomatu',
        ctaButton: "Wymie\u0144",
        amountText: "Warto\u015B\u0107",
        minAmount: 'Minimalna kwota wymiany to {{amount}} {{currency}}.',
        genericMinAmount: 'Kwota wymiany jest zbyt niska.'
    },
    dashboard: {
        canEditPost: "Mo\u017Cesz edytowa\u0107 wpis",
        postExists: "Wpis o takim tytule ju\u017C istnieje",
        postNotExists: 'Wpis o takim tytule nie istnieje',
        emptyPostTitle: "Dodaj tytu\u0142 wpisu",
        error: "Co\u015B posz\u0142o nie tak :("
    },
    preactSelect: {
        search: 'Szukaj...',
        searchNoResults: "Brak wynik\xf3w"
    },
    transferCalculator: {
        exchangeRates: 'Kurs wymiany',
        details: "Szczeg\xf3\u0142y",
        amountYouSend: "Kwota, kt\xf3r\u0105 wp\u0142acam",
        countryYouSendMoney: "Kraj, do kt\xf3rego wy\u015Blesz pieni\u0105dze",
        foreignTransferFee: "Op\u0142ata za przelew zagraniczny",
        foreignTransferType: 'Typ przelewu zagranicznego',
        exchangeAmount: 'Kwota wymiany',
        amountRecipientReceive: "Kwota, kt\xf3r\u0105 otrzyma odbiorca",
        notSellCurrency: "Sprzeda\u017C waluty jest niedost\u0119pna.",
        noCurrenciesSupportedInfo: "Para walut nieobs\u0142ugiwana",
        noCountrySupportedInfo: "Nie obs\u0142ugujemy wybranej pary w danym kraju.",
        amountTooLowForFees: "Wpisana kwota jest zbyt niska \u2013 po odj\u0119ciu wszystkich op\u0142at odbiorca nic nie otrzyma.",
        enterAmount: "Wpisz kwot\u0119",
        commissionWT: 'Prowizja Walutomatu',
        equivalentFee: "R\xf3wnowarto\u015B\u0107",
        commissionAmount: "{{fee_percent}}% ca\u0142ej kwoty",
        ctaButton: "Wy\u015Blij pieni\u0105dze"
    },
    timer: {
        update: 'Aktualizacja za:',
        timeUnit: 'sek.'
    },
    networkErrorStatus: {
        slow: "Problem z pobraniem kurs\xf3w walut. Wolne po\u0142\u0105czenie z internetem",
        noNetwork: "Problem z pobraniem kurs\xf3w walut. Sprawd\u017A czy masz po\u0142\u0105czenie z internetem",
        default: "Wyst\u0105pi\u0142y problemy techniczne. Skontatuj si\u0119 z obs\u0142ug\u0105 klienta"
    },
    transferTypes: {
        elixir: {
            header: "Zwyk\u0142y",
            subtext: "Pieni\u0105dze dotr\u0105 w ci\u0105gu 2 - 3 dni roboczych.",
            subtextNoAdditionalCosts: "Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextPayoutInPoland: "Przy przelewach na terenie Polski banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextSelf: "Pieni\u0105dze dotr\u0105 w ci\u0105gu 2 - 3 dni roboczych.",
            subtextWarning: "Uwaga: banki mog\u0105 pobra\u0107 dodatkow\u0105 op\u0142at\u0119, kt\xf3ra zale\u017Cy od waluty i kraju docelowego."
        },
        internal: {
            header: "Zwyk\u0142y",
            subtext: "Pieni\u0105dze dotr\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
            subtextNoAdditionalCosts: "Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextPayoutInPoland: "Przy przelewach na terenie Polski banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextSelf: "Pieni\u0105dze dotr\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
            subtextWarning: "Uwaga: banki mog\u0105 pobra\u0107 dodatkow\u0105 op\u0142at\u0119, kt\xf3ra zale\u017Cy od waluty i kraju docelowego."
        },
        internal_bre: {
            header: "Zwyk\u0142y",
            subtext: "Pieni\u0105dze dotr\u0105 w ci\u0105gu 2 - 3 dni roboczych.",
            subtextNoAdditionalCosts: "Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextPayoutInPoland: "Przy przelewach na terenie Polski banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextSelf: "Pieni\u0105dze dotr\u0105 w ci\u0105gu 2 - 3 dni roboczych.",
            subtextWarning: "Uwaga: banki mog\u0105 pobra\u0107 dodatkow\u0105 op\u0142at\u0119, kt\xf3ra zale\u017Cy od waluty i kraju docelowego."
        },
        sepa: {
            header: "Zwyk\u0142y",
            subtext: "Pieni\u0105dze dotr\u0105 w ci\u0105gu 1 - 2 dni roboczych.",
            subtextNoAdditionalCosts: "Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextPayoutInPoland: "Przy przelewach na terenie Polski banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextSelf: "Pieni\u0105dze dotr\u0105 w ci\u0105gu 1 - 2 dni roboczych.",
            subtextWarning: "Uwaga: banki mog\u0105 pobra\u0107 dodatkow\u0105 op\u0142at\u0119, kt\xf3ra zale\u017Cy od waluty i kraju docelowego."
        },
        sorbnet: {
            header: "Przy\u015Bpieszony",
            subtext: "Pieni\u0105dze dotr\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
            subtextNoAdditionalCosts: "Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextPayoutInPoland: "Przy przelewach na terenie Polski banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextSelf: "Pieni\u0105dze dotr\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
            subtextWarning: "Uwaga: banki mog\u0105 pobra\u0107 dodatkow\u0105 op\u0142at\u0119, kt\xf3ra zale\u017Cy od waluty i kraju docelowego."
        },
        spot: {
            header: "Zwyk\u0142y",
            subtext: "Pieni\u0105dze dotr\u0105 za 2 - 3 dni robocze.",
            subtextNoAdditionalCosts: "Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextPayoutInPoland: "Przy przelewach na terenie Polski banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextSelf: "Pieni\u0105dze dotr\u0105 za 2 - 3 dni robocze.",
            subtextWarning: "Uwaga: banki mog\u0105 pobra\u0107 dodatkow\u0105 op\u0142at\u0119, kt\xf3ra zale\u017Cy od waluty i kraju docelowego."
        },
        swift_usd: {
            header: "Zwyk\u0142y",
            subtext: "Pieni\u0105dze dotr\u0105 w ci\u0105gu 2 - 3 dni roboczych.",
            subtextNoAdditionalCosts: "Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextPayoutInPoland: "Przy przelewach na terenie Polski banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextSelf: "Pieni\u0105dze dotr\u0105 w ci\u0105gu 2 - 3 dni roboczych.",
            subtextWarning: "Uwaga: banki mog\u0105 pobra\u0107 dodatkow\u0105 op\u0142at\u0119, kt\xf3ra zale\u017Cy od waluty i kraju docelowego."
        },
        today: {
            header: "Przy\u015Bpieszony",
            subtext: "Pieni\u0105dze dotr\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
            subtextNoAdditionalCosts: "Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextPayoutInPoland: "Przy przelewach na terenie Polski banki zazwyczaj nie pobieraj\u0105 \u017Cadnych dodatkowych op\u0142at za przelew.",
            subtextSelf: "Pieni\u0105dze dotr\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
            subtextWarning: "Uwaga: banki mog\u0105 pobra\u0107 dodatkow\u0105 op\u0142at\u0119, kt\xf3ra zale\u017Cy od waluty i kraju docelowego."
        },
        today_our: {
            header: "Przy\u015Bpieszony OUR",
            subtext: "Pieni\u0105dze dotr\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego. Gwarancja, \u017Ce odbiorca otrzyma ca\u0142\u0105 kwot\u0119 i banki nie pobior\u0105 po drodze \u017Cadnych dodatkowych op\u0142at.",
            subtextNoAdditionalCosts: ' ',
            subtextPayoutInPoland: ' ',
            subtextSelf: "Pieni\u0105dze dotr\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego. Gwarancja, \u017Ce otrzymasz ca\u0142\u0105 kwot\u0119 i banki nie pobior\u0105 po drodze \u017Cadnych dodatkowych op\u0142at.",
            subtextWarning: ' '
        },
        sepa_instant: {
            header: 'Natychmiastowy',
            subtext: "Pieni\u0105dze dotr\u0105 w oko\u0142o minut\u0119.",
            subtextNoAdditionalCosts: ' ',
            subtextPayoutInPoland: ' ',
            subtextSelf: "Pieni\u0105dze dotr\u0105 w oko\u0142o minut\u0119.",
            subtextWarning: "Przelew natychmiastowy jest mo\u017Cliwy jedynie do kwoty {{maxAmount}}."
        },
        local: {
            header: "Zwyk\u0142y",
            subtext: "Pieni\u0105dze dotr\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
            subtextNoAdditionalCosts: ' ',
            subtextPayoutInPoland: ' ',
            subtextSelf: "Pieni\u0105dze dotr\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
            subtextWarning: ' '
        }
    },
    countries: {
        AD: 'Andora',
        AE: 'Zjednoczone Emiraty Arabskie',
        AF: 'Afganistan',
        AG: 'Antigua i Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Antyle Holenderskie',
        AO: 'Angola',
        AQ: 'Antarktyka',
        AR: 'Argentyna',
        AS: "Samoa Ameryka\u0144skie",
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AX: 'Wyspy Alandzkie',
        AZ: "Azerbejd\u017Can",
        BA: "Bo\u015Bnia i Hercegowina",
        BB: 'Barbados',
        BD: 'Bangladesz',
        BE: 'Belgia',
        BF: 'Burkina Faso',
        BG: "Bu\u0142garia",
        BH: 'Bahrajn',
        BI: 'Burundi',
        BJ: 'Benin',
        BL: "Saint-Barth\xe9lemy",
        BM: 'Bermudy',
        BN: 'Brunei Darussalam',
        BO: 'Boliwia',
        BQ: 'Bonaire',
        BR: 'Brazylia',
        BS: 'Bahamy',
        BT: 'Bhutan',
        BV: 'Wyspa Bouveta',
        BW: 'Botswana',
        BY: "Bia\u0142oru\u015B",
        BZ: 'Belize',
        CA: 'Kanada',
        CC: 'Wyspy Kokosowe',
        CD: 'Demokratyczna Republika Konga',
        CF: "Republika \u015Arodkowoafryka\u0144ska",
        CG: 'Kongo',
        CH: 'Szwajcaria',
        CI: "Wybrze\u017Ce Ko\u015Bci S\u0142oniowej",
        CK: 'Wyspy Cooka',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'Chiny',
        CO: 'Kolumbia',
        CR: 'Kostaryka',
        CU: 'Kuba',
        CV: "Republika Zielonego Przyl\u0105dka",
        CW: "Cura\xe7ao",
        CX: "Wyspa Bo\u017Cego Narodzenia",
        CY: 'Cypr',
        CZ: 'Czechy',
        DE: 'Niemcy',
        DJ: "D\u017Cibuti",
        DK: 'Dania',
        DM: 'Dominika',
        DO: 'Dominikana',
        DZ: 'Algieria',
        EC: 'Ekwador',
        EE: 'Estonia',
        EG: 'Egipt',
        EH: 'Sahara Zachodnia',
        ER: 'Erytrea',
        ES: 'Hiszpania',
        ET: 'Etiopia',
        FI: 'Finlandia',
        FJ: "Fid\u017Ci",
        FK: 'Falklandy',
        FM: 'Mikronezja',
        FO: 'Wyspy Owcze',
        FR: 'Francja',
        GA: 'Gabon',
        GB: 'Wielka Brytania',
        GD: 'Grenada',
        GE: 'Gruzja',
        GF: 'Gujana Francuska',
        GG: 'Guernsey',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Grenlandia',
        GM: 'Gambia',
        GN: 'Gwinea',
        GP: 'Gwadelupa',
        GQ: "Gwinea R\xf3wnikowa",
        GR: 'Grecja',
        GS: "Georgia Po\u0142udniowa i Sandwich Po\u0142udniowy",
        GT: 'Gwatemala',
        GU: 'Guam',
        GW: 'Gwinea Bissau',
        GY: 'Gujana',
        HK: 'Hongkong',
        HM: 'Wyspy Heard i McDonalda',
        HN: 'Honduras',
        HR: 'Chorwacja',
        HT: 'Haiti',
        HU: "W\u0119gry",
        ID: 'Indonezja',
        IE: 'Irlandia',
        IL: 'Izrael',
        IM: 'Wyspa Man',
        IN: 'Indie',
        IO: 'Brytyjskie Terytorium Oceanu Indyjskiego',
        IQ: 'Irak',
        IR: 'Iran',
        IS: 'Islandia',
        IT: "W\u0142ochy",
        JE: 'Jersey',
        JM: 'Jamajka',
        JO: 'Jordania',
        JP: 'Japonia',
        KE: 'Kenia',
        KG: 'Kirgistan',
        KH: "Kambod\u017Ca",
        KI: 'Kiribati',
        KM: 'Komory',
        KN: 'Saint Kitts i Nevis',
        KP: "Korea P\xf3\u0142nocna",
        KR: "Korea Po\u0142udniowa",
        KW: 'Kuwejt',
        KY: 'Kajmany',
        KZ: 'Kazachstan',
        LA: 'Laos',
        LB: 'Liban',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litwa',
        LU: 'Luksemburg',
        LV: "\u0141otwa",
        LY: 'Libia',
        MA: 'Maroko',
        MC: 'Monako',
        MD: "Mo\u0142dawia",
        ME: "Czarnog\xf3ra",
        MF: 'Saint-Martin',
        MG: 'Madagaskar',
        MH: 'Wyspy Marshalla',
        MK: "Macedonia P\xf3\u0142nocna",
        ML: 'Mali',
        MM: 'Mjanma',
        MN: 'Mongolia',
        MO: 'Makau',
        MP: "Mariany P\xf3\u0142nocne",
        MQ: 'Martynika',
        MR: 'Mauretania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Malediwy',
        MW: 'Malawi',
        MX: 'Meksyk',
        MY: 'Malezja',
        MZ: 'Mozambik',
        NA: 'Namibia',
        NC: 'Nowa Kaledonia',
        NE: 'Niger',
        NF: 'Norfolk',
        NG: 'Nigeria',
        NI: 'Nikaragua',
        NL: 'Holandia',
        NO: 'Norwegia',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nowa Zelandia',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polinezja Francuska',
        PG: 'Papua-Nowa Gwinea',
        PH: 'Filipiny',
        PK: 'Pakistan',
        PL: 'Polska',
        PM: 'Saint-Pierre i Miquelon',
        PN: 'Pitcairn',
        PR: 'Portoryko',
        PS: 'Palestyna',
        PT: 'Portugalia',
        PW: 'Palau',
        PY: 'Paragwaj',
        QA: 'Katar',
        RE: 'Reunion',
        RO: 'Rumunia',
        RS: 'Serbia',
        RU: 'Rosja',
        RW: 'Rwanda',
        SA: 'Arabia Saudyjska',
        SB: 'Wyspy Salomona',
        SC: 'Seszele',
        SD: 'Sudan',
        SE: 'Szwecja',
        SG: 'Singapur',
        SH: "Wyspa \u015Awi\u0119tej Heleny, Wyspa Wniebowst\u0105pienia i Tristan da Cunha",
        SI: "S\u0142owenia",
        SJ: 'Svalbard i Jan Mayen',
        SK: "S\u0142owacja",
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Surinam',
        SS: "Sudan Po\u0142udniowy",
        ST: "Wyspy \u015Awi\u0119tego Tomasza i Ksi\u0105\u017C\u0119ca",
        SV: 'Salwador',
        SX: 'Sint Maarten',
        SY: 'Syria',
        SZ: 'Eswatini',
        TC: 'Turks i Caicos',
        TD: 'Czad',
        TF: "Francuskie Terytoria Po\u0142udniowe i Antarktyczne",
        TG: 'Togo',
        TH: 'Tajlandia',
        TJ: "Tad\u017Cykistan",
        TK: 'Tokelau',
        TL: 'Timor Wschodni',
        TM: 'Turkmenistan',
        TN: 'Tunezja',
        TO: 'Tonga',
        TR: 'Turcja',
        TT: 'Trynidad i Tobago',
        TV: 'Tuvalu',
        TW: 'Tajwan',
        TZ: 'Tanzania',
        UA: 'Ukraina',
        UG: 'Uganda',
        UM: "Dalekie Wyspy Mniejsze Stan\xf3w Zjednoczonych",
        US: 'Stany Zjednoczone',
        UY: 'Urugwaj',
        UZ: 'Uzbekistan',
        VA: 'Watykan',
        VC: 'Saint Vincent i Grenadyny',
        VE: 'Wenezuela',
        VG: 'Brytyjskie Wyspy Dziewicze',
        VI: "Wyspy Dziewicze Stan\xf3w Zjednoczonych",
        VN: 'Wietnam',
        VU: 'Vanuatu',
        WF: 'Wallis i Futuna',
        WS: 'Samoa',
        XK: 'Kosowo',
        YE: 'Jemen',
        YT: 'Majotta',
        ZA: "Republika Po\u0142udniowej Afryki",
        ZM: 'Zambia',
        ZW: 'Zimbabwe'
    },
    currencies: {
        AED: 'Dirham ZEA',
        ARS: "Peso argenty\u0144skie",
        AUD: 'Dolar australijski',
        BDT: 'Taka bengalska',
        BGN: "Lew bu\u0142garski",
        BRL: 'Real brazylijski',
        CAD: 'Dolar kanadyjski',
        CHF: 'Frank szwajcarski',
        CLP: 'Peso chilijskie',
        CNY: "Juan chi\u0144ski",
        COP: 'Peso kolumbijskie',
        CZK: 'Korona czeska',
        DKK: "Korona du\u0144ska",
        EGP: 'Funt egipski',
        EUR: 'Euro',
        FJD: "Dolar fid\u017Ci",
        GBP: 'Funt brytyjski',
        GHS: "Cedi gha\u0144skie",
        HKD: "Dolar hongko\u0144ski",
        HRK: 'Kuna chorwacka',
        HUF: "Forint w\u0119gierski",
        ILS: 'Nowy szekel izraelski',
        INR: 'Rupia indyjska',
        JOD: "Dinar jorda\u0144ski",
        JPY: "Jen japo\u0144ski",
        KWD: 'Dinar kuwejcki',
        LSL: 'Loti lesotyjskie',
        MAD: "Dirham maroka\u0144ski",
        MXN: "Peso meksyka\u0144skie",
        NOK: 'Korona norweska',
        NPR: 'Rupia nepalska',
        NZD: 'Dolar nowozelandzki',
        OMR: "Rial oma\u0144ski",
        PEN: "Sol peruwia\u0144ski",
        PGK: "Kina papua\u0144ska",
        PLN: "Polski z\u0142oty",
        RON: "Leja rumu\u0144ska",
        RUB: 'Rubel rosyjski',
        SAR: 'Rial saudyjski',
        SEK: 'Korona szwedzka',
        SGD: 'Dolar singapurski',
        SZL: 'Lilangeni',
        THB: 'Bat tajlandzki',
        TRY: 'Lira turecka',
        USD: "Dolar ameryka\u0144ski",
        UYU: 'Peso urugwajskie',
        WST: "Tala samoa\u0144ska",
        ZAR: "Rand po\u0142udniowoafryka\u0144ski"
    },
    widgetCalculator: {
        title: "Wymieniaj korzystnie walut\u0119, zlecaj przelewy zagraniczne, p\u0142a\u0107 kart\u0105.",
        actualRate: 'Aktualny kurs',
        buySelect: "Kupuj\u0119",
        sellSelect: "Sprzedaj\u0119",
        exchangeAmountSellLabel: 'Otrzymasz',
        exchangeAmountBuyLabel: "Wp\u0142a\u0107",
        commission: 'Prowizja promocyjna ({{commission}}%)'
    },
    formValidation: {
        emptyField: "Pole nie mo\u017Ce by\u0107 puste",
        requiredField: 'Pole jest wymagane',
        requireAllFields: "Wszystkie pola musz\u0105 by\u0107 uzupe\u0142nione",
        passwordToShort: "Has\u0142o musi mie\u0107 8 znak\xf3w",
        emailNotValid: "Pole musi zawiera\u0107 poprawny email",
        emailReserved: "Adres e-mail jest ju\u017C zaj\u0119ty",
        emailUnregistered: "Nie znale\u017Ali\u015Bmy Twojego adresu e-mail w bazie naszych Klient\xf3w.",
        markField: "Zaznacz co najmniej jeden z checkbox\xf3w",
        serverUnknownError: "B\u0142\u0105d komunikacji z serwerem",
        invalidCharacters: 'Pole zawiera niepoprawne znaki',
        phoneNotValid: 'Numer telefonu jest niepoprawny',
        checkBoxBelow: "Zaznacz prosz\u0119 pole poni\u017Cej, aby wys\u0142a\u0107 wiadomo\u015B\u0107",
        promocodeInvalid: 'Niepoprawny kod promocyjny',
        newsletterAlreadySubscribed: "Ten adres e-mail jest ju\u017C zapisany do newslettera.",
        captchaError: "Weryfikacja nie powiod\u0142a si\u0119. Spr\xf3buj ponownie."
    },
    cardTests: {
        emailUnregistered: 'Nie znale\u017Ali\u015Bmy Twojego adresu e-mail w bazie naszych Klient\xf3w. <a class="error-link" href="{{href}}">Za\u0142\xf3\u017C darmowe konto</a> i zapisz si\u0119 na testy karty Walutomatu.',
        emailAlreadyUsed: "Ten adres e-mail jest ju\u017C w naszej bazie zapis\xf3w na testy."
    },
    password: {
        show: "poka\u017C",
        hide: 'ukryj'
    },
    howItWorks: {
        showButton: "Zobacz wi\u0119cej",
        hideButton: 'Zobacz mniej'
    },
    rateCalculator: {
        baseInputLabel: 'Mam',
        counterInputLabel: 'Otrzymam',
        counterInputTooltip: "Uwzgl\u0119dnia prowizj\u0119 {{commission}}%",
        ctaAlert: 'Ustaw alert'
    },
    esim: {
        searchPlaceholder: 'Wyszukaj kraj lub region...',
        searchAriaLabel: 'Wyszukaj kraj lub region',
        searchMinChars: "Wpisz <b>co najmniej 3 znaki</b>, aby wy\u015Bwietli\u0107 wyniki.",
        searchNoResults: "<b>Brak wynik\xf3w.</b> Nie znale\u017Ali\u015Bmy szukanego kraju.",
        searchError: "<b>Wyst\u0105pi\u0142 b\u0142\u0105d.</b> Nie uda\u0142o si\u0119 za\u0142adowa\u0107 listy ofert."
    },
    trackingEvent: {
        buttonGooglePlay: 'Pobierz z Google Play',
        buttonAppStore: 'Pobierz z App Store'
    }
};

});

parcelRegister("5xn28", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84253e5151cc10a5$export$2e2bcd8739ae039; });
var $84253e5151cc10a5$export$2e2bcd8739ae039 = {
    highcharts: {
        decimalPoint: ',',
        downloadJPEG: 'Download a JPG image',
        downloadPDF: 'Download a PDF document',
        downloadPNG: 'Download a PNG image',
        downloadSVG: 'Download an SVG image',
        exportButtonTitle: 'Export',
        forexRate: 'Average FOREX rate',
        loading: 'Loading...',
        months: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        printButtonTitle: 'Print',
        rangeSelectorFrom: 'From',
        rangeSelectorTo: 'To',
        rangeSelectorZoom: 'Zoom',
        rateTypes: {
            ask: 'The best sale offer',
            bid: 'The best buy offer',
            forex: 'Average exchange rate in the world'
        },
        resetZoom: 'Reset',
        resetZoomTitle: 'Reset',
        shortMonths: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        thousandsSep: ' ',
        weekdays: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        wtBestAsk: 'The best sale offer',
        wtBestBid: 'The best buy offer',
        seriesError: 'At least one option must be selected'
    },
    calculator: {
        title: 'Calculate savings in Walutomat',
        forBuy: 'for',
        unsupportedPair: 'We currently do not offer rates for the selected currency pair.',
        spinnerError: {
            generic: 'There was a problem with downloading data',
            toManyRequests: 'The calculator is currently unavailable. Please try again later or contact <a href="https://www.walutomat.com/en/contact/">Customer Service</a>.'
        },
        commissionWT: 'Walutomat commission',
        ctaButton: 'Exchange',
        amountText: 'Amount',
        minAmount: 'The minimum exchange amount is {{amount}} {{currency}}.',
        genericMinAmount: 'The exchange amount is too low.'
    },
    transferCalculator: {
        exchangeRates: 'Exchange rate',
        details: 'Details',
        amountYouSend: 'Amount you send',
        countryYouSendMoney: "Country you\u2019re sending money to",
        foreignTransferFee: 'Foreign transfer fee',
        foreignTransferType: 'Foreign transfer type',
        exchangeAmount: 'Exchange amount',
        amountRecipientReceive: 'Amount the recipient receives',
        notSellCurrency: 'Currency sale is unavailable.',
        noCurrenciesSupportedInfo: 'Currency pair not supported',
        noCountrySupportedInfo: 'We do not support the selected pair in the chosen country.',
        amountTooLowForFees: "The entered amount is too low \u2014 after all fees the recipient would receive nothing.",
        enterAmount: 'Enter amount',
        commissionWT: 'Walutomat commission',
        equivalentFee: 'Equivalent',
        commissionAmount: '{{fee_percent}}% of the total amount',
        ctaButton: 'Send money'
    },
    timer: {
        update: 'Refreshing in:',
        timeUnit: 'sec.'
    },
    networkErrorStatus: {
        slow: 'Problem retrieving exchange rates. Slow internet connection',
        noNetwork: 'Problem retrieving exchange rates. Check your internet connection',
        default: 'Technical issues occurred. Please contact customer support'
    },
    transferTypes: {
        elixir: {
            header: 'Standard',
            subtext: 'The money will arrive within 2 - 3 working days.',
            subtextNoAdditionalCosts: 'When transferring {{currency}} to {{country}} banks usually do not charge any additional transfer fees.',
            subtextPayoutInPoland: 'Banks usually do not collect any additional transfer fees for transfers in Poland.',
            subtextSelf: 'The money will arrive within 2 - 3 working days.',
            subtextWarning: 'Important: banks may charge an additional fee which depends on the currency and the destination country.'
        },
        internal: {
            header: 'Standard',
            subtext: 'The money will arrive on the next working day at the latest.',
            subtextNoAdditionalCosts: 'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
            subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
            subtextSelf: 'The money will arrive on the next working day at the latest.',
            subtextWarning: 'Important: banks may charge an additional fee which depends on the currency and the destination country.'
        },
        internal_bre: {
            header: 'Standard',
            subtext: 'The money will arrive within 2 - 3 working days.',
            subtextNoAdditionalCosts: 'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
            subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
            subtextSelf: 'The money will arrive within 2 - 3 working days.',
            subtextWarning: 'Important: banks may charge an additional fee which depends on the currency and the destination country.'
        },
        sepa: {
            header: 'Standard',
            subtext: 'The money will arrive within 1 - 2 working days.',
            subtextNoAdditionalCosts: 'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
            subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
            subtextSelf: 'The money will arrive within 1 - 2 working days.',
            subtextWarning: 'Important: banks may charge an additional fee which depends on the currency and the destination country.'
        },
        sorbnet: {
            header: 'Express transfer',
            subtext: 'The money will arrive on the next working day at the latest.',
            subtextNoAdditionalCosts: 'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
            subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
            subtextSelf: 'The money will arrive on the next working day at the latest.',
            subtextWarning: 'Important: banks may charge an additional fee which depends on the currency and the destination country.'
        },
        spot: {
            header: 'Standard',
            subtext: 'The money will arrive within 2 - 3 working days.',
            subtextNoAdditionalCosts: 'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
            subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
            subtextSelf: 'The money will arrive within 2 - 3 working days.',
            subtextWarning: 'Important: banks may charge an additional fee which depends on the currency and the destination country.'
        },
        'swift usd': {
            header: 'Standard',
            subtext: 'The money will arrive within 2 - 3 working days.',
            subtextNoAdditionalCosts: 'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
            subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
            subtextSelf: 'The money will arrive within 2 - 3 working days.',
            subtextWarning: 'Important: banks may charge an additional fee which depends on the currency and the destination country.'
        },
        today: {
            header: 'Express transfer',
            subtext: 'The money will arrive on the next working day at the latest.',
            subtextNoAdditionalCosts: 'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
            subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
            subtextSelf: 'The money will arrive on the next working day at the latest.',
            subtextWarning: 'Important: banks may charge an additional fee which depends on the currency and the destination country.'
        },
        today_our: {
            header: 'Express transfer (OUR)',
            subtext: 'The money will arrive on the next working day at the latest. A guarantee that the recipient will receive the full amount and the banks will not charge any additional fees along the way.',
            subtextNoAdditionalCosts: '',
            subtextPayoutInPoland: '',
            subtextSelf: 'Money will be received on the next business day at the latest. The warranty that the You will receive the entire amount and the banks will not collect any additional fees on the way.',
            subtextWarning: ''
        },
        sepa_instant: {
            header: 'Instant',
            subtext: 'The money will arrive in about 1 minute.',
            subtextNoAdditionalCosts: '',
            subtextPayoutInPoland: '',
            subtextSelf: 'The money will arrive in about 1 minute.',
            subtextWarning: 'Instant transfers are limited to {{maxAmount}}.'
        },
        local: {
            header: 'Express transfer',
            subtext: 'The money will arrive on the next working day at the latest.',
            subtextNoAdditionalCosts: '',
            subtextPayoutInPoland: '',
            subtextSelf: 'The money will arrive on the next working day at the latest.',
            subtextWarning: ''
        },
        local_express: {
            header: 'Instant',
            subtext: 'The money will arrive in about 30 minutes, no later than the next business day.',
            subtextNoAdditionalCosts: '',
            subtextPayoutInPoland: '',
            subtextSelf: 'The money will arrive in about 30 minutes, no later than the next business day.',
            subtextWarning: 'Instant transfers are limited to {{maxAmount}}.'
        }
    },
    countries: {
        AD: 'Andorra',
        AE: 'United Arab Emirates',
        AF: 'Afghanistan',
        AG: 'Antigua and Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Netherlands Antilles',
        AO: 'Angola',
        AQ: 'Antarctica',
        AR: 'Argentina',
        AS: 'American Samoa',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AX: "\xc5land Islands",
        AZ: 'Azerbaijan',
        BA: 'Bosnia and Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgium',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BL: "Saint-Barth\xe9lemy",
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivia',
        BQ: 'Bonaire',
        BR: 'Brazil',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet Island',
        BW: 'Botswana',
        BY: 'Belarus',
        BZ: 'Belize',
        CA: 'Canada',
        CC: 'Cocos Islands',
        CD: 'Democratic Republic of the Congo',
        CF: 'Central African Republic',
        CG: 'Congo',
        CH: 'Switzerland',
        CI: "C\xf4te d'Ivoire",
        CK: 'Cook Islands',
        CL: 'Chile',
        CM: 'Cameroon',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cabo Verde',
        CW: "Cura\xe7ao",
        CX: 'Christmas Island',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DE: 'Germany',
        DJ: 'Djibouti',
        DK: 'Denmark',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egypt',
        EH: 'Western Sahara',
        ER: 'Eritrea',
        ES: 'Spain',
        ET: 'Ethiopia',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falkland Islands',
        FM: 'Micronesia',
        FO: 'Faroe Islands',
        FR: 'France',
        GA: 'Gabon',
        GB: 'United Kingdom',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'French Guiana',
        GG: 'Guernsey',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Greenland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe',
        GQ: 'Equatorial Guinea',
        GR: 'Greece',
        GS: 'South Georgia and the South Sandwich Islands',
        GT: 'Guatemala',
        GU: 'Guam',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: "Heard and McDonald's Islands",
        HN: 'Honduras',
        HR: 'Croatia',
        HT: 'Haiti',
        HU: 'Hungary',
        ID: 'Indonesia',
        IE: 'Ireland',
        IL: 'Israel',
        IM: 'Isle of Man',
        IN: 'India',
        IO: 'British Indian Ocean Territory',
        IQ: 'Iraq',
        IR: 'Iran',
        IS: 'Iceland',
        IT: 'Italy',
        JE: 'Jersey',
        JM: 'Jamaica',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenya',
        KG: 'Kyrgyzstan',
        KH: 'Cambodia',
        KI: 'Kiribati',
        KM: 'Comoro Islands',
        KN: 'Saint Kitts and Nevis',
        KP: 'North Korea',
        KR: 'South Korea',
        KW: 'Kuwait',
        KY: 'Cayman Islands',
        KZ: 'Kazakhstan',
        LA: 'Laos',
        LB: 'Lebanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        LV: 'Latvia',
        LY: 'Libya',
        MA: 'Morocco',
        MC: 'Monaco',
        MD: 'Moldova',
        ME: 'Montenegro',
        MF: 'Saint-Martin',
        MG: 'Madagascar',
        MH: 'Marshall Islands',
        MK: 'North Macedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macau',
        MP: 'Northern Mariana Islands',
        MQ: 'Martinique',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldives',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Malaysia',
        MZ: 'Mozambique',
        NA: 'Namibia',
        NC: 'New Caledonia',
        NE: 'Niger',
        NF: 'Norfolk',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Netherlands',
        NO: 'Norway',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'New Zealand',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'French Polynesia',
        PG: 'Papua New Guinea',
        PH: 'Philippines',
        PK: 'Pakistan',
        PL: 'Poland',
        PM: 'Saint-Pierre and Miquelon',
        PN: 'Pitcairn',
        PR: 'Puerto Rico',
        PS: 'Palestine',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Reunion',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russia',
        RW: 'Rwanda',
        SA: 'Saudi Arabia',
        SB: 'Solomon Islands',
        SC: 'Seychelles',
        SD: 'Sudan',
        SE: 'Sweden',
        SG: 'Singapore',
        SH: 'Saint Helena, Ascension and Tristan da Cunha',
        SI: 'Slovenia',
        SJ: 'Svalbard and Jan Mayen',
        SK: 'Slovakia',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        SS: 'South Sudan',
        ST: "S\xe3o Tom\xe9 and Pr\xedncipe",
        SV: 'El Salvador',
        SX: 'Sint Maarten',
        SY: 'Syria',
        SZ: 'Eswatini',
        TC: 'Turks and Caicos Islands',
        TD: 'Chad',
        TF: 'French Southern and Antarctic Lands',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tajikistan',
        TK: 'Tokelau',
        TL: 'Timor-Leste',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'Tonga',
        TR: 'Turkey',
        TT: 'Trinidad and Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'United States Minor Outlying Islands',
        US: 'United States',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Vatican',
        VC: 'Saint Vincent and the Grenadines',
        VE: 'Venezuela',
        VG: 'British Virgin Islands',
        VI: 'United States Virgin Islands',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis and Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'South Africa',
        ZM: 'Zambia',
        ZW: 'Zimbabwe'
    },
    currencies: {
        ALL: 'All currencies',
        BGN: 'Bulgarian lev',
        CHF: 'Swiss franc',
        CZK: 'Czech koruna',
        DKK: 'Danish krone',
        EUR: 'Euro',
        GBP: 'Pound sterling',
        NOK: 'Norwegian krone',
        PLN: 'Polish zloty',
        RON: 'Romanian leu',
        SEK: 'Swedish krona',
        USD: 'US dollar',
        ZAR: 'South African rand',
        TRY: 'Turkish lira',
        SGD: 'Singapore dollar',
        RUB: 'Russian ruble',
        NZD: 'New Zealand dollar',
        MXN: 'Mexican peso',
        HKD: 'Hong Kong dollar',
        CAD: 'Canadian dollar',
        AUD: 'Australian dollar',
        HUF: 'Hungarian forint',
        CNY: 'Chinese yuan',
        ILS: 'Israeli new shekel',
        JPY: 'Japanese yen',
        ARS: 'Argentine peso',
        BRL: 'Brazilian real',
        CLP: 'Chilean peso',
        COP: 'Colombian peso',
        UYU: 'Uruguayan peso',
        PEN: 'Peruvian sol',
        AED: 'UAE dirham',
        BDT: 'Bangladeshi taka',
        EGP: 'Egyptian pound',
        FJD: 'Fijian dollar',
        GHS: 'Ghanaian cedi',
        INR: 'Indian rupee',
        JOD: 'Jordanian dinar',
        KWD: 'Kuwaiti dinar',
        LSL: 'Lesotho loti',
        MAD: 'Moroccan dirham',
        NAD: 'Namibian dollar',
        NPR: 'Nepalese rupee',
        OMR: 'Omani rial',
        PGK: 'Papua New Guinea kina',
        PKR: 'Pakistani rupee',
        SAR: 'Saudi riyal',
        SZL: 'Swazi lilangeni',
        THB: 'Thai baht',
        WST: 'Samoan tala',
        allCurrenciesLabel: 'All',
        mainCurrenciesLabel: 'Major currencies:',
        restCurrenciesLabel: 'Remaining:',
        converted: {
            BGN: 'Bulgarian lev',
            CHF: 'Swiss franc',
            CZK: 'Czech koruna',
            DKK: 'Danish krone',
            EUR: 'Euro',
            GBP: 'Pound sterling',
            NOK: 'Norwegian krone',
            PLN: 'Polish zloty',
            RON: 'Romanian leu',
            SEK: 'Swedish krona',
            USD: 'US dollar',
            ZAR: 'South African rand',
            TRY: 'Turkish lira',
            SGD: 'Singapore dollar',
            RUB: 'Russian ruble',
            NZD: 'New Zealand dollar',
            MXN: 'Mexican peso',
            HKD: 'Hong Kong dollar',
            CAD: 'Canadian dollar',
            AUD: 'Australian dollar',
            HUF: 'Hungarian forint',
            ARS: 'Argentine peso',
            BRL: 'Brazilian real',
            CLP: 'Chilean peso',
            COP: 'Colombian peso',
            UYU: 'Uruguayan peso',
            PEN: 'Peruvian sol',
            AED: 'UAE dirham',
            BDT: 'Bangladeshi taka',
            CNY: 'Chinese yuan',
            EGP: 'Egyptian pound',
            FJD: 'Fijian dollar',
            GHS: 'Ghanaian cedi',
            INR: 'Indian rupee',
            JOD: 'Jordanian dinar',
            KWD: 'Kuwaiti dinar',
            LSL: 'Lesotho loti',
            MAD: 'Moroccan dirham',
            NAD: 'Namibian dollar',
            NPR: 'Nepalese rupee',
            OMR: 'Omani rial',
            PGK: 'Papua New Guinea kina',
            PKR: 'Pakistani rupee',
            SAR: 'Saudi riyal',
            SZL: 'Swazi lilangeni',
            THB: 'Thai baht',
            WST: 'Samoan tala'
        }
    },
    dashboard: {
        canEditPost: "Mo\u017Cesz edytowa\u0107 wpis",
        postExists: "Wpis o takim tytule ju\u017C istnieje",
        postNotExists: 'Wpis o takim tytule nie istnieje',
        emptyPostTitle: "Dodaj tytu\u0142 wpisu",
        error: "Co\u015B posz\u0142o nie tak :("
    },
    preactSelect: {
        search: 'Search...',
        searchNoResults: 'No results found'
    },
    widgetCalculator: {
        title: "Check rates and{{nbsp}}exchange currency in{{nbsp}}Walutomat \u2013 quickly and{{nbsp}}conveniently.",
        actualRate: 'Current exchange rate',
        buySelect: 'Buy',
        sellSelect: 'Sell',
        exchangeAmountSellLabel: 'You will receive',
        exchangeAmountBuyLabel: 'Deposit',
        commission: 'Promotional commission ({{commission}}%)'
    },
    formValidation: {
        emptyField: 'The field cannot be empty',
        requiredField: 'The field is required',
        requireAllFields: 'All fields must be completed',
        passwordToShort: 'The password must be 8 characters long',
        emailNotValid: 'The field must contain a valid email address',
        emailReserved: 'The email address is already taken',
        emailUnregistered: 'The email address was not found in our customer database.',
        markField: 'Select at least one of the checkboxes',
        serverUnknownError: 'Server communication error',
        invalidCharacters: 'Field contains invalid characters',
        phoneNotValid: 'The phone number is incorrect',
        checkBoxBelow: 'Please tick the box below to send a message',
        promocodeInvalid: 'Invalid promotion code',
        newsletterAlreadySubscribed: 'This email is already subscribed to the newsletter.',
        captchaError: 'Verification failed. Please try again.'
    },
    password: {
        show: 'show',
        hide: 'hide'
    },
    howItWorks: {
        showButton: 'Show more',
        hideButton: 'Show less'
    },
    rateCalculator: {
        baseInputLabel: 'I have',
        counterInputLabel: 'I will receive',
        counterInputTooltip: 'Includes {{commission}}% commission',
        ctaAlert: 'Set currency alert'
    },
    esim: {
        searchPlaceholder: 'Search for a country or region...',
        searchAriaLabel: 'Search for a country or region',
        searchMinChars: 'Enter <b>at least 3 characters</b> to see results.',
        searchNoResults: '<b>No results found.</b> We could not find the country you searched for.',
        searchError: '<b>Something went wrong.</b> Failed to load the offer list.'
    },
    trackingEvent: {
        buttonGooglePlay: 'Download from Google Play',
        buttonAppStore: 'Download from the App Store'
    }
};

});

parcelRegister("f0qt3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d122b5bdfc26109$export$2e2bcd8739ae039; });
var $2d122b5bdfc26109$export$2e2bcd8739ae039 = {
    highcharts: {
        decimalPoint: ',',
        downloadJPEG: 'Pobierz obraz JPEG',
        downloadPDF: 'Pobierz dokument PDF',
        downloadPNG: 'Pobierz obraz PNG',
        downloadSVG: 'Pobierz obraz SVG',
        exportButtonTitle: 'Eksport',
        forexRate: "Kurs \u015Bredni FOREX",
        loading: "\u0141adowanie...",
        months: [
            "Stycze\u0144",
            'Luty',
            'Marzec',
            "Kwiecie\u0144",
            'Maj',
            'Czerwiec',
            'Lipiec',
            "Sierpie\u0144",
            "Wrzesie\u0144",
            "Pa\u017Adziernik",
            'Listopad',
            "Grudzie\u0144"
        ],
        printButtonTitle: 'Drukowanie',
        rangeSelectorFrom: 'Od',
        rangeSelectorTo: 'Do',
        rangeSelectorZoom: "Przybli\u017Cenie",
        rateTypes: {
            ask: "Najlepsza oferta sprzeda\u017Cy",
            bid: 'Najlepsza oferta kupna',
            forex: "\u015Aredni kurs na \u015Bwiecie"
        },
        resetZoom: 'Reset',
        resetZoomTitle: 'Reset',
        shortMonths: [
            'Sty',
            'Lut',
            'Mar',
            'Kwi',
            'Maj',
            'Cze',
            'Lip',
            'Sie',
            'Wrz',
            "Pa\u017A",
            'Lis',
            'Gru'
        ],
        thousandsSep: ' ',
        weekdays: [
            'Niedziela',
            "Poniedzia\u0142ek",
            'Wtorek',
            "\u015Aroda",
            'Czwartek',
            "Pi\u0105tek",
            'Sobota'
        ],
        wtBestAsk: "Najlepsza oferta sprzeda\u017Cy",
        wtBestBid: 'Najlepsza oferta kupna',
        seriesError: "\u041D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u0443 \u043E\u043F\u0446\u0456\u044E"
    },
    calculator: {
        title: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u0439\u0442\u0435 \u0441\u0432\u043E\u0457 \u0437\u0430\u043E\u0449\u0430\u0434\u0436\u0435\u043D\u043D\u044F \u0443 Walutomat",
        forBuy: "\u0437\u0430",
        unsupportedPair: "\u041D\u0430 \u0434\u0430\u043D\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043C\u0438 \u043D\u0435 \u043D\u0430\u0434\u0430\u0454\u043C\u043E \u043A\u0443\u0440\u0441\u0438 \u0434\u043B\u044F \u0432\u0438\u0431\u0440\u0430\u043D\u043E\u0457 \u043F\u0430\u0440\u0438 \u0432\u0430\u043B\u044E\u0442.",
        spinnerError: {
            generic: "\u041F\u0456\u0434 \u0447\u0430\u0441 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445 \u0432\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
            toManyRequests: '\u041D\u0430\u0440\u0430\u0437\u0456 \u043A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0442\u043E\u0440 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437 \u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u0430\u0431\u043E \u0437\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E <a href="https://www.walutomat.com/uk/kontakt/">\u0441\u043B\u0443\u0436\u0431\u0438 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432</a>.'
        },
        commissionWT: "\u041A\u043E\u043C\u0456\u0441\u0456\u044F Walutomat",
        ctaButton: "\u041E\u0431\u043C\u0456\u043D\u044F\u0442\u0438",
        amountText: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
        minAmount: "\u041C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u0430 \u0441\u0443\u043C\u0430 \u043E\u0431\u043C\u0456\u043D\u0443 \u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C {{amount}} {{currency}}.",
        genericMinAmount: "\u0421\u0443\u043C\u0430 \u043E\u0431\u043C\u0456\u043D\u0443 \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u043C\u0430\u043B\u0430."
    },
    transferCalculator: {
        exchangeRates: "\u041A\u0443\u0440\u0441 \u043E\u0431\u043C\u0456\u043D\u0443",
        details: "\u0414\u0435\u0442\u0430\u043B\u0456",
        amountYouSend: "\u0421\u0443\u043C\u0430, \u044F\u043A\u0443 \u044F \u0441\u043F\u043B\u0430\u0447\u0443\u044E",
        countryYouSendMoney: "\u041A\u0440\u0430\u0457\u043D\u0430, \u0434\u043E \u044F\u043A\u043E\u0457 \u0432\u0438 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u0454\u0442\u0435 \u0433\u0440\u043E\u0448\u0456",
        foreignTransferFee: "\u041A\u043E\u043C\u0456\u0441\u0456\u044F \u0437\u0430 \u043C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u0438\u0439 \u043F\u0435\u0440\u0435\u043A\u0430\u0437",
        foreignTransferType: "\u0422\u0438\u043F \u043C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0443",
        exchangeAmount: "\u0421\u0443\u043C\u0430 \u043E\u0431\u043C\u0456\u043D\u0443",
        amountRecipientReceive: "\u0421\u0443\u043C\u0430, \u044F\u043A\u0443 \u043E\u0442\u0440\u0438\u043C\u0430\u0454 \u043E\u0434\u0435\u0440\u0436\u0443\u0432\u0430\u0447",
        notSellCurrency: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0432\u0430\u043B\u044E\u0442\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430.",
        noCurrenciesSupportedInfo: "\u041F\u0430\u0440\u0430 \u0432\u0430\u043B\u044E\u0442 \u043D\u0435 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454\u0442\u044C\u0441\u044F",
        noCountrySupportedInfo: "\u041C\u0438 \u043D\u0435 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0454\u043C\u043E \u043E\u0431\u0440\u0430\u043D\u0443 \u043F\u0430\u0440\u0443 \u0432 \u0434\u0430\u043D\u0456\u0439 \u043A\u0440\u0430\u0457\u043D\u0456.",
        amountTooLowForFees: "\u0412\u0432\u0435\u0434\u0435\u043D\u0430 \u0441\u0443\u043C\u0430 \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u043C\u0430\u043B\u0430 \u2014 \u043F\u0456\u0441\u043B\u044F \u0432\u0438\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0441\u0456\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u043E\u0434\u0435\u0440\u0436\u0443\u0432\u0430\u0447 \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u043E\u0442\u0440\u0438\u043C\u0430\u0454.",
        enterAmount: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0441\u0443\u043C\u0443",
        commissionWT: "\u041A\u043E\u043C\u0456\u0441\u0456\u044F Walutomat",
        equivalentFee: "\u0415\u043A\u0432\u0456\u0432\u0430\u043B\u0435\u043D\u0442",
        commissionAmount: "{{fee_percent}}%  \u0432\u0456\u0434 \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u043E\u0457 \u0441\u0443\u043C\u0438"
    },
    timer: {
        update: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0437\u0430:",
        timeUnit: "\u0441\u0435\u043A."
    },
    dashboard: {
        canEditPost: "Mo\u017Cesz edytowa\u0107 wpis",
        postExists: "Wpis o takim tytule ju\u017C istnieje",
        postNotExists: 'Wpis o takim tytule nie istnieje',
        emptyPostTitle: "Dodaj tytu\u0142 wpisu",
        error: "Co\u015B posz\u0142o nie tak :("
    },
    preactSelect: {
        search: "\u041F\u043E\u0448\u0443\u043A...",
        searchNoResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E"
    },
    widgetCalculator: {
        title: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440 \u043A\u0443\u0440\u0441\u0438 \u0442\u0430{{nbsp}}\u043E\u0431\u043C\u0456\u043D\u044F\u0439 \u0432\u0430\u043B\u044E\u0442\u0443 \u0443{{nbsp}}Walutomat \u2013 \u0448\u0432\u0438\u0434\u043A\u043E \u0442\u0430{{nbsp}}\u0432\u0438\u0433\u0456\u0434\u043D\u043E.",
        actualRate: "\u0410\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0438\u0439 \u043A\u0443\u0440\u0441",
        buySelect: "\u041A\u0443\u043F\u0443\u044E",
        sellSelect: "\u041F\u0440\u043E\u0434\u0430\u044E",
        exchangeAmountSellLabel: "\u0412\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u0454\u0442\u0435",
        exchangeAmountBuyLabel: "\u0412\u043D\u0435\u0441\u0456\u0442\u044C",
        commission: "\u041F\u0440\u043E\u043C\u043E-\u043A\u043E\u043C\u0456\u0441\u0456\u044F ({{commission}}%)"
    },
    formValidation: {
        emptyField: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435 \u043F\u043E\u043B\u0435",
        requiredField: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435 \u043F\u043E\u043B\u0435",
        requireAllFields: "\u0423\u0441\u0456 \u043F\u043E\u043B\u044F \u043C\u0430\u044E\u0442\u044C \u0431\u0443\u0442\u0438 \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u0456",
        passwordToShort: "\u041F\u0430\u0440\u043E\u043B\u044C \u043F\u043E\u0432\u0438\u043D\u0435\u043D \u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u043D\u0435 \u043C\u0435\u043D\u0448\u0435 8 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
        emailNotValid: "\u043F\u043E\u043B\u0435 \u043C\u0430\u0454 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0438\u0439 \u0430\u0434\u0440\u0435\u0441 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
        emailReserved: "\u0414\u0430\u043D\u0438\u0439 email \u0432\u0436\u0435 \u0437\u0430\u0439\u043D\u044F\u0442\u0438\u0439",
        emailUnregistered: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0448\u043B\u0438 \u0432\u0430\u0448\u043E\u0433\u043E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0433\u043E \u0430\u0434\u0440\u0435\u0441\u0438 \u0432 \u0431\u0430\u0437\u0456 \u043D\u0430\u0448\u0438\u0445 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432.",
        markField: "\u041F\u043E\u0437\u043D\u0430\u0447\u0442\u0435 \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u0438\u043D \u0437 \u043F\u0440\u0430\u043F\u043E\u0440\u0446\u0456\u0432",
        serverUnknownError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0432'\u044F\u0437\u043A\u0443 \u0437 \u0441\u0435\u0440\u0432\u0435\u0440\u043E\u043C.",
        invalidCharacters: "\u041F\u043E\u043B\u0435 \u043C\u0456\u0441\u0442\u0438\u0442\u044C \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u0456 \u0441\u0438\u043C\u0432\u043E\u043B\u0438",
        phoneNotValid: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 \u0454 \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u043C",
        checkBoxBelow: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u043E\u0437\u043D\u0430\u0447\u0442\u0435 \u043F\u043E\u043B\u0435 \u043D\u0438\u0436\u0447\u0435, \u0449\u043E\u0431 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        promocodeInvalid: "\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0438\u0439 \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434",
        newsletterAlreadySubscribed: "\u0426\u044F \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 \u0432\u0436\u0435 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u0430 \u043D\u0430 \u0440\u043E\u0437\u0441\u0438\u043B\u043A\u0443 \u043D\u043E\u0432\u0438\u043D.",
        captchaError: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u043D\u0435 \u0432\u0434\u0430\u043B\u0430\u0441\u044F. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437."
    },
    password: {
        show: "\u041F\u041E\u041A\u0410\u0417\u0410\u0422\u0418",
        hide: "\u043F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438"
    },
    howItWorks: {
        showButton: "\u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
        hideButton: "\u043F\u043E\u043A\u0430\u0437\u0443\u0432\u0430\u0442\u0438 \u043C\u0435\u043D\u0448\u0435"
    },
    rateCalculator: {
        baseInputLabel: 'Mam',
        counterInputLabel: 'Otrzymam',
        counterInputTooltip: "Uwzgl\u0119dnia prowizj\u0119 {{commission}}%",
        ctaAlert: 'Ustaw alert'
    },
    transferTypes: {
        elixir: {
            header: "\u0417\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 2 - 3 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
            subtextNoAdditionalCosts: "\u041F\u0440\u0438 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0456 {{currency}} \u0434\u043E {{country}} \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u0437\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437.",
            subtextPayoutInPoland: "\u0417\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 \u041F\u043E\u043B\u044C\u0449\u0456 \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0436\u043E\u0434\u043D\u0438\u0445 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 2 - 3 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
            subtextWarning: "\u0423\u0432\u0430\u0433\u0430: \u0431\u0430\u043D\u043A\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0441\u0442\u044F\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u043A\u043E\u043C\u0456\u0441\u0456\u044E, \u044F\u043A\u0430 \u0437\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0432\u0456\u0434 \u0432\u0430\u043B\u044E\u0442\u0438 \u0442\u0430 \u043A\u0440\u0430\u0457\u043D\u0438 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F."
        },
        internal: {
            header: "\u0417\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
            subtextNoAdditionalCosts: "\u041F\u0440\u0438 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0456 {{currency}} \u0434\u043E {{country}} \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u0437\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437.",
            subtextPayoutInPoland: "\u0417\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 \u041F\u043E\u043B\u044C\u0449\u0456 \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0436\u043E\u0434\u043D\u0438\u0445 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
            subtextWarning: "\u0423\u0432\u0430\u0433\u0430: \u0431\u0430\u043D\u043A\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0441\u0442\u044F\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u043A\u043E\u043C\u0456\u0441\u0456\u044E, \u044F\u043A\u0430 \u0437\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0432\u0456\u0434 \u0432\u0430\u043B\u044E\u0442\u0438 \u0442\u0430 \u043A\u0440\u0430\u0457\u043D\u0438 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F."
        },
        internal_bre: {
            header: "\u0417\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 2 - 3 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
            subtextNoAdditionalCosts: "\u041F\u0440\u0438 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0456 {{currency}} \u0434\u043E {{country}} \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u0437\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437.",
            subtextPayoutInPoland: "\u0417\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 \u041F\u043E\u043B\u044C\u0449\u0456 \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0436\u043E\u0434\u043D\u0438\u0445 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 2 - 3 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
            subtextWarning: "\u0423\u0432\u0430\u0433\u0430: \u0431\u0430\u043D\u043A\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0441\u0442\u044F\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u043A\u043E\u043C\u0456\u0441\u0456\u044E, \u044F\u043A\u0430 \u0437\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0432\u0456\u0434 \u0432\u0430\u043B\u044E\u0442\u0438 \u0442\u0430 \u043A\u0440\u0430\u0457\u043D\u0438 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F."
        },
        sepa: {
            header: "\u0417\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 1 - 2 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
            subtextNoAdditionalCosts: "\u041F\u0440\u0438 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0456 {{currency}} \u0434\u043E {{country}} \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u0437\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437.",
            subtextPayoutInPoland: "\u0417\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 \u041F\u043E\u043B\u044C\u0449\u0456 \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0436\u043E\u0434\u043D\u0438\u0445 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 1 - 2 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
            subtextWarning: "\u0423\u0432\u0430\u0433\u0430: \u0431\u0430\u043D\u043A\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0441\u0442\u044F\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u043A\u043E\u043C\u0456\u0441\u0456\u044E, \u044F\u043A\u0430 \u0437\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0432\u0456\u0434 \u0432\u0430\u043B\u044E\u0442\u0438 \u0442\u0430 \u043A\u0440\u0430\u0457\u043D\u0438 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F."
        },
        sorbnet: {
            header: "\u0415\u043A\u0441\u043F\u0440\u0435\u0441-\u043F\u0435\u0440\u0435\u043A\u0430\u0437",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
            subtextNoAdditionalCosts: "\u041F\u0440\u0438 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0456 {{currency}} \u0434\u043E {{country}} \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u0437\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437.",
            subtextPayoutInPoland: "\u0417\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 \u041F\u043E\u043B\u044C\u0449\u0456 \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0436\u043E\u0434\u043D\u0438\u0445 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
            subtextWarning: "\u0423\u0432\u0430\u0433\u0430: \u0431\u0430\u043D\u043A\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0441\u0442\u044F\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u043A\u043E\u043C\u0456\u0441\u0456\u044E, \u044F\u043A\u0430 \u0437\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0432\u0456\u0434 \u0432\u0430\u043B\u044E\u0442\u0438 \u0442\u0430 \u043A\u0440\u0430\u0457\u043D\u0438 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F."
        },
        spot: {
            header: "\u0417\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 2 - 3 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
            subtextNoAdditionalCosts: "\u041F\u0440\u0438 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0456 {{currency}} \u0434\u043E {{country}} \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u0437\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437.",
            subtextPayoutInPoland: "\u0417\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 \u041F\u043E\u043B\u044C\u0449\u0456 \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0436\u043E\u0434\u043D\u0438\u0445 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 2 - 3 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
            subtextWarning: "\u0423\u0432\u0430\u0433\u0430: \u0431\u0430\u043D\u043A\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0441\u0442\u044F\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u043A\u043E\u043C\u0456\u0441\u0456\u044E, \u044F\u043A\u0430 \u0437\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0432\u0456\u0434 \u0432\u0430\u043B\u044E\u0442\u0438 \u0442\u0430 \u043A\u0440\u0430\u0457\u043D\u0438 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F."
        },
        swift_usd: {
            header: "\u0417\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 2 - 3 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
            subtextNoAdditionalCosts: "\u041F\u0440\u0438 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0456 {{currency}} \u0434\u043E {{country}} \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u0437\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437.",
            subtextPayoutInPoland: "\u0417\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 \u041F\u043E\u043B\u044C\u0449\u0456 \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0436\u043E\u0434\u043D\u0438\u0445 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 2 - 3 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
            subtextWarning: "\u0423\u0432\u0430\u0433\u0430: \u0431\u0430\u043D\u043A\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0441\u0442\u044F\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u043A\u043E\u043C\u0456\u0441\u0456\u044E, \u044F\u043A\u0430 \u0437\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0432\u0456\u0434 \u0432\u0430\u043B\u044E\u0442\u0438 \u0442\u0430 \u043A\u0440\u0430\u0457\u043D\u0438 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F."
        },
        today: {
            header: "\u0415\u043A\u0441\u043F\u0440\u0435\u0441-\u043F\u0435\u0440\u0435\u043A\u0430\u0437",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
            subtextNoAdditionalCosts: "\u041F\u0440\u0438 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0456 {{currency}} \u0434\u043E {{country}} \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u0437\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437.",
            subtextPayoutInPoland: "\u0417\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 \u041F\u043E\u043B\u044C\u0449\u0456 \u0431\u0430\u043D\u043A\u0438 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u044E\u0442\u044C \u0436\u043E\u0434\u043D\u0438\u0445 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
            subtextWarning: "\u0423\u0432\u0430\u0433\u0430: \u0431\u0430\u043D\u043A\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0441\u0442\u044F\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u043A\u043E\u043C\u0456\u0441\u0456\u044E, \u044F\u043A\u0430 \u0437\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0432\u0456\u0434 \u0432\u0430\u043B\u044E\u0442\u0438 \u0442\u0430 \u043A\u0440\u0430\u0457\u043D\u0438 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F."
        },
        today_our: {
            header: "\u0415\u043A\u0441\u043F\u0440\u0435\u0441-\u043F\u0435\u0440\u0435\u043A\u0430\u0437 (OUR)",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F. \u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F \u0442\u043E\u0433\u043E, \u0449\u043E \u043E\u0434\u0435\u0440\u0436\u0443\u0432\u0430\u0447 \u043E\u0442\u0440\u0438\u043C\u0430\u0454 \u043F\u043E\u0432\u043D\u0443 \u0441\u0443\u043C\u0443, \u0430 \u0431\u0430\u043D\u043A\u0438 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u0432\u0430\u0442\u0438\u043C\u0443\u0442\u044C \u0436\u043E\u0434\u043D\u0438\u0445 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u043F\u043E \u0434\u043E\u0440\u043E\u0437\u0456.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F. \u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F \u0442\u043E\u0433\u043E, \u0449\u043E \u043E\u0434\u0435\u0440\u0436\u0443\u0432\u0430\u0447 \u043E\u0442\u0440\u0438\u043C\u0430\u0454 \u043F\u043E\u0432\u043D\u0443 \u0441\u0443\u043C\u0443, \u0430 \u0431\u0430\u043D\u043A\u0438 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u0432\u0430\u0442\u0438\u043C\u0443\u0442\u044C \u0436\u043E\u0434\u043D\u0438\u0445 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u043F\u043E \u0434\u043E\u0440\u043E\u0437\u0456.",
            subtextNoAdditionalCosts: '',
            subtextPayoutInPoland: '',
            subtextWarning: ''
        },
        sepa_instant: {
            header: "\u041C\u0438\u0442\u0442\u0454\u0432\u0438\u0439",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 1 \u0445\u0432\u0438\u043B\u0438\u043D\u0443.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 1 \u0445\u0432\u0438\u043B\u0438\u043D\u0443.",
            subtextWarning: "\u041C\u0438\u0442\u0442\u0454\u0432\u0438\u0439 \u043F\u0435\u0440\u0435\u043A\u0430\u0437 \u043C\u043E\u0436\u043B\u0438\u0432\u0438\u0439 \u0442\u0456\u043B\u044C\u043A\u0438 \u0434\u043E \u0441\u0443\u043C\u0438 {{maxAmount}}.",
            subtextNoAdditionalCosts: '',
            subtextPayoutInPoland: ''
        },
        local: {
            header: "\u0415\u043A\u0441\u043F\u0440\u0435\u0441-\u043F\u0435\u0440\u0435\u043A\u0430\u0437",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
            subtextNoAdditionalCosts: '',
            subtextPayoutInPoland: '',
            subtextWarning: ''
        },
        local_express: {
            header: "\u041C\u0438\u0442\u0442\u0454\u0432\u0438\u0439",
            subtext: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0447\u0435\u0440\u0435\u0437 30 \u0445\u0432\u0438\u043B\u0438\u043D, \u043D\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
            subtextSelf: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0447\u0435\u0440\u0435\u0437 30 \u0445\u0432\u0438\u043B\u0438\u043D, \u043D\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
            subtextNoAdditionalCosts: '',
            subtextPayoutInPoland: '',
            subtextWarning: "\u041C\u0438\u0442\u0442\u0454\u0432\u0438\u0439 \u043F\u0435\u0440\u0435\u043A\u0430\u0437 \u043C\u043E\u0436\u043B\u0438\u0432\u0438\u0439 \u0442\u0456\u043B\u044C\u043A\u0438 \u0434\u043E \u0441\u0443\u043C\u0438 {{maxAmount}}."
        },
        trustedAccountInfo: "\u0412\u0438\u043F\u043B\u0430\u0442\u0438 \u043D\u0430 \u0446\u0435\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u043D\u0435 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u0432\u0430\u0442\u0438 SMS-\u043A\u043E\u0434\u043E\u043C \u0430\u0431\u043E \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u043C (\u0446\u0435 \u043C\u043E\u0436\u043D\u0430 \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u0432 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F\u0445 \u0431\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u043E\u0433\u043E \u0440\u0430\u0445\u0443\u043D\u043A\u0443).",
        walletWidgetTransferAll: "\u0412\u0438\u043F\u043B\u0430\u0442\u0438\u0442\u0438 \u0432\u0441\u0435"
    },
    countries: {
        AD: "\u0410\u043D\u0434\u043E\u0440\u0440\u0430",
        AE: "\u041E\u0431'\u0454\u0434\u043D\u0430\u043D\u0456 \u0410\u0440\u0430\u0431\u0441\u044C\u043A\u0456 \u0415\u043C\u0456\u0440\u0430\u0442\u0438",
        AF: "\u0410\u0444\u0433\u0430\u043D\u0456\u0441\u0442\u0430\u043D",
        AG: "\u0410\u043D\u0442\u0438\u0433\u0443\u0430 \u0456 \u0411\u0430\u0440\u0431\u0443\u0434\u0430",
        AI: "\u0410\u043D\u0433\u0456\u043B\u044C\u044F",
        AL: "\u0410\u043B\u0431\u0430\u043D\u0456\u044F",
        AM: "\u0412\u0456\u0440\u043C\u0435\u043D\u0456\u044F",
        AN: "\u041D\u0456\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u0441\u044C\u043A\u0456 \u0410\u043D\u0442\u0438\u043B\u044C\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        AO: "\u0410\u043D\u0433\u043E\u043B\u0430",
        AQ: "\u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0434\u0430",
        AR: "\u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0430",
        AS: "\u0410\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0435 \u0421\u0430\u043C\u043E\u0430",
        AT: "\u0410\u0432\u0441\u0442\u0440\u0456\u044F",
        AU: "\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u044F",
        AW: "\u0410\u0440\u0443\u0431\u0430",
        AX: "\u0410\u043B\u0430\u043D\u0434\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        AZ: "\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D",
        BA: "\u0411\u043E\u0441\u043D\u0456\u044F \u0456 \u0413\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430",
        BB: "\u0411\u0430\u0440\u0431\u0430\u0434\u043E\u0441",
        BD: "\u0411\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448",
        BE: "\u0411\u0435\u043B\u044C\u0433\u0456\u044F",
        BF: "\u0411\u0443\u0440\u043A\u0456\u043D\u0430-\u0424\u0430\u0441\u043E",
        BG: "\u0411\u043E\u043B\u0433\u0430\u0440\u0456\u044F",
        BH: "\u0411\u0430\u0445\u0440\u0435\u0439\u043D",
        BI: "\u0411\u0443\u0440\u0443\u043D\u0434\u0456",
        BJ: "\u0411\u0435\u043D\u0456\u043D",
        BL: "\u0421\u0435\u043D-\u0411\u0430\u0440\u0442\u0435\u043B\u0435\u043C\u0456",
        BM: "\u0411\u0435\u0440\u043C\u0443\u0434\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        BN: "\u0411\u0440\u0443\u043D\u0435\u0439-\u0414\u0430\u0440\u0443\u0441\u0441\u0430\u043B\u0430\u043C",
        BO: "\u0411\u043E\u043B\u0456\u0432\u0456\u044F",
        BQ: "\u0411\u043E\u043D\u0430\u0439\u0440\u0435",
        BR: "\u0411\u0440\u0430\u0437\u0438\u043B\u0456\u044F",
        BS: "\u0411\u0430\u0433\u0430\u043C\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        BT: "\u0411\u0443\u0442\u0430\u043D",
        BV: "\u041E\u0441\u0442\u0440\u0456\u0432 \u0411\u0443\u0432\u0435",
        BW: "\u0411\u043E\u0442\u0441\u0432\u0430\u043D\u0430",
        BY: "\u0411\u0456\u043B\u043E\u0440\u0443\u0441\u044C",
        BZ: "\u0411\u0435\u043B\u0456\u0437",
        CA: "\u041A\u0430\u043D\u0430\u0434\u0430",
        CC: "\u041A\u043E\u043A\u043E\u0441\u043E\u0432\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        CD: "\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u043D\u0430 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430 \u041A\u043E\u043D\u0433\u043E",
        CF: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0430 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430",
        CG: "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430 \u041A\u043E\u043D\u0433\u043E",
        CH: "\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0456\u044F",
        CI: "\u041A\u043E\u0442-\u0434'\u0406\u0432\u0443\u0430\u0440",
        CK: "\u041E\u0441\u0442\u0440\u043E\u0432\u0438 \u041A\u0443\u043A\u0430",
        CL: "\u0427\u0438\u043B\u0456",
        CM: "\u041A\u0430\u043C\u0435\u0440\u0443\u043D",
        CN: "\u041A\u0438\u0442\u0430\u0439",
        CO: "\u041A\u043E\u043B\u0443\u043C\u0431\u0456\u044F",
        CR: "\u041A\u043E\u0441\u0442\u0430-\u0420\u0438\u043A\u0430",
        CU: "\u041A\u0443\u0431\u0430",
        CV: "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430 \u041A\u0430\u0431\u043E-\u0412\u0435\u0440\u0434\u0435",
        CW: "\u041A\u044E\u0440\u0430\u0441\u0430\u043E",
        CX: "\u041E\u0441\u0442\u0440\u0456\u0432 \u0420\u0456\u0437\u0434\u0432\u0430",
        CY: "\u041A\u0456\u043F\u0440",
        CZ: "\u0427\u0435\u0445\u0456\u044F",
        DE: "\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430",
        DJ: "\u0414\u0436\u0438\u0431\u0443\u0442\u0456",
        DK: "\u0414\u0430\u043D\u0456\u044F",
        DM: "\u0414\u043E\u043C\u0456\u043D\u0456\u043A\u0430",
        DO: "\u0414\u043E\u043C\u0456\u043D\u0456\u043A\u0430\u043D\u0441\u044C\u043A\u0430 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430 ",
        DZ: "\u0410\u043B\u0436\u0438\u0440",
        EC: "\u0415\u043A\u0432\u0430\u0434\u043E\u0440",
        EE: "\u0415\u0441\u0442\u043E\u043D\u0456\u044F",
        EG: "\u0404\u0433\u0438\u043F\u0435\u0442",
        EH: "\u0417\u0430\u0445\u0456\u0434\u043D\u0430 \u0421\u0430\u0445\u0430\u0440\u0430",
        ER: "\u0415\u0440\u0438\u0442\u0440\u0435\u044F",
        ES: "\u0406\u0441\u043F\u0430\u043D\u0456\u044F",
        ET: "\u0415\u0444\u0456\u043E\u043F\u0456\u044F",
        FI: "\u0424\u0456\u043D\u043B\u044F\u043D\u0434\u0456\u044F",
        FJ: "\u0424\u0456\u0434\u0436\u0456",
        FK: "\u0424\u043E\u043B\u043A\u043B\u0435\u043D\u0434\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        FM: "\u041C\u0456\u043A\u0440\u043E\u043D\u0435\u0437\u0456\u044F",
        FO: "\u0424\u0430\u0440\u0435\u0440\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        FR: "\u0424\u0440\u0430\u043D\u0446\u0456\u044F",
        GA: "\u0413\u0430\u0431\u043E\u043D",
        GB: "\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F",
        GD: "\u0413\u0440\u0435\u043D\u0430\u0434\u0430",
        GE: "\u0413\u0440\u0443\u0437\u0456\u044F",
        GF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u044C\u043A\u0430 \u0413\u0432\u0456\u0430\u043D\u0430",
        GG: "\u0413\u0435\u0440\u043D\u0441\u0456",
        GH: "\u0413\u0430\u043D\u0430",
        GI: "\u0413\u0456\u0431\u0440\u0430\u043B\u0442\u0430\u0440",
        GL: "\u0413\u0440\u0435\u043D\u043B\u0430\u043D\u0434\u0456\u044F",
        GM: "\u0413\u0430\u043C\u0431\u0456\u044F",
        GN: "\u0413\u0432\u0456\u043D\u0435\u044F",
        GP: "\u0413\u0432\u0430\u0434\u0435\u043B\u0443\u043F\u0430",
        GQ: "\u0415\u043A\u0432\u0430\u0442\u043E\u0440\u0456\u0430\u043B\u044C\u043D\u0430 \u0413\u0432\u0456\u043D\u0435\u044F",
        GR: "\u0413\u0440\u0435\u0446\u0456\u044F",
        GS: "\u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0430 \u0414\u0436\u043E\u0440\u0434\u0436\u0456\u044F \u0456 \u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0456 \u0421\u0430\u043D\u0434\u0432\u0456\u0447\u0435\u0432\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438",
        GT: "\u0413\u0432\u0430\u0442\u0435\u043C\u0430\u043B\u0430",
        GU: "\u0413\u0443\u0430\u043C",
        GW: "\u0413\u0432\u0456\u043D\u0435\u044F-\u0411\u0456\u0441\u0430\u0443",
        GY: "\u0413\u0430\u044F\u043D\u0430",
        HK: "\u0413\u043E\u043D\u043A\u043E\u043D\u0433",
        HM: "\u041E\u0441\u0442\u0440\u0456\u0432 \u0413\u0435\u0440\u0434 \u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438 \u041C\u0430\u043A\u0434\u043E\u043D\u0430\u043B\u044C\u0434",
        HN: "\u0413\u043E\u043D\u0434\u0443\u0440\u0430\u0441",
        HR: "\u0425\u043E\u0440\u0432\u0430\u0442\u0456\u044F",
        HT: "\u0413\u0430\u0457\u0442\u0456",
        HU: "\u0423\u0433\u043E\u0440\u0449\u0438\u043D\u0430",
        ID: "\u0406\u043D\u0434\u043E\u043D\u0435\u0437\u0456\u044F",
        IE: "\u0406\u0440\u043B\u0430\u043D\u0434\u0456\u044F",
        IL: "\u0406\u0437\u0440\u0430\u0457\u043B\u044C",
        IM: "\u041E\u0441\u0442\u0440\u0456\u0432 \u041C\u0435\u043D",
        IN: "\u0406\u043D\u0434\u0456\u044F",
        IO: "\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u044C\u043A\u0430 \u0442\u0435\u0440\u0438\u0442\u043E\u0440\u0456\u044F \u0432 \u0406\u043D\u0434\u0456\u0439\u0441\u044C\u043A\u043E\u043C\u0443 \u043E\u043A\u0435\u0430\u043D\u0456",
        IQ: "\u0406\u0440\u0430\u043A",
        IR: "\u0406\u0440\u0430\u043D",
        IS: "\u0406\u0441\u043B\u0430\u043D\u0434\u0456\u044F",
        IT: "\u0406\u0442\u0430\u043B\u0456\u044F",
        JE: "\u0414\u0436\u0435\u0440\u0441\u0456",
        JM: "\u042F\u043C\u0430\u0439\u043A\u0430",
        JO: "\u0419\u043E\u0440\u0434\u0430\u043D\u0456\u044F",
        JP: "\u042F\u043F\u043E\u043D\u0456\u044F",
        KE: "\u041A\u0435\u043D\u0456\u044F",
        KG: "\u041A\u0438\u0440\u0433\u0438\u0437\u0441\u0442\u0430\u043D",
        KH: "\u041A\u0430\u043C\u0431\u043E\u0434\u0436\u0430",
        KI: "\u041A\u0456\u0440\u0438\u0431\u0430\u0442\u0456",
        KM: "\u041A\u043E\u043C\u043E\u0440\u0441\u044C\u043A\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438",
        KN: "\u0421\u0435\u043D\u0442-\u041A\u0456\u0442\u0442\u0441 \u0456 \u041D\u0435\u0432\u0456\u0441",
        KP: "\u041F\u0456\u0432\u043D\u0456\u0447\u043D\u0430 \u041A\u043E\u0440\u0435\u044F",
        KR: "\u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0430 \u041A\u043E\u0440\u0435\u044F",
        KW: "\u041A\u0443\u0432\u0435\u0439\u0442",
        KY: "\u041A\u0430\u0439\u043C\u0430\u043D\u043E\u0432\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438",
        KZ: "\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D",
        LA: "\u041B\u0430\u043E\u0441",
        LB: "\u041B\u0456\u0432\u0430\u043D",
        LC: "\u0421\u0435\u043D\u0442-\u041B\u044E\u0441\u0456\u044F",
        LI: "\u041B\u0456\u0445\u0442\u0435\u043D\u0448\u0442\u0435\u0439\u043D",
        LK: "\u0428\u0440\u0456-\u041B\u0430\u043D\u043A\u0430",
        LR: "\u041B\u0456\u0431\u0435\u0440\u0456\u044F",
        LS: "\u041B\u0435\u0441\u043E\u0442\u043E",
        LT: "\u041B\u0438\u0442\u0432\u0430",
        LU: "\u041B\u044E\u043A\u0441\u0435\u043C\u0431\u0443\u0440\u0433",
        LV: "\u041B\u0430\u0442\u0432\u0456\u044F",
        LY: "\u041B\u0456\u0432\u0456\u044F",
        MA: "\u041C\u0430\u0440\u043E\u043A\u043A\u043E",
        MC: "\u041C\u043E\u043D\u0430\u043A\u043E",
        MD: "\u041C\u043E\u043B\u0434\u043E\u0432\u0430",
        ME: "\u0427\u043E\u0440\u043D\u043E\u0433\u043E\u0440\u0456\u044F",
        MF: "\u0421\u0435\u043D-\u041C\u0430\u0440\u0442\u0435\u043D",
        MG: "\u041C\u0430\u0434\u0430\u0433\u0430\u0441\u043A\u0430\u0440",
        MH: "\u041C\u0430\u0440\u0448\u0430\u043B\u043B\u043E\u0432\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438",
        MK: "\u041F\u0456\u0432\u043D\u0456\u0447\u043D\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0456\u044F",
        ML: "\u041C\u0430\u043B\u0456",
        MM: "\u041C'\u044F\u043D\u043C\u0430",
        MN: "\u041C\u043E\u043D\u0433\u043E\u043B\u0456\u044F",
        MO: "\u0421\u043F\u0435\u0446\u0456\u0430\u043B\u044C\u043D\u0438\u0439 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u0438\u0439 \u0440\u0430\u0439\u043E\u043D \u041C\u0430\u043A\u0430\u043E",
        MP: "\u041F\u0456\u0432\u043D\u0456\u0447\u043D\u0456 \u041C\u0430\u0440\u0456\u0430\u043D\u0441\u044C\u043A\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438",
        MQ: "\u041C\u0430\u0440\u0442\u0438\u043D\u0456\u043A\u0430",
        MR: "\u041C\u0430\u0432\u0440\u0438\u0442\u0430\u043D\u0456\u044F",
        MS: "\u041C\u043E\u043D\u0442\u0441\u0435\u0440\u0440\u0430\u0442",
        MT: "\u041C\u0430\u043B\u044C\u0442\u0430",
        MU: "\u041C\u0430\u0432\u0440\u0438\u043A\u0456\u0439",
        MV: "\u041C\u0430\u043B\u044C\u0434\u0456\u0432\u0438",
        MW: "\u041C\u0430\u043B\u0430\u0432\u0456",
        MX: "\u041C\u0435\u043A\u0441\u0438\u043A\u0430",
        MY: "\u041C\u0430\u043B\u0430\u0439\u0437\u0456\u044F",
        MZ: "\u041C\u043E\u0437\u0430\u043C\u0431\u0456\u043A",
        NA: "\u041D\u0430\u043C\u0456\u0431\u0456\u044F",
        NC: "\u041D\u043E\u0432\u0430 \u041A\u0430\u043B\u0435\u0434\u043E\u043D\u0456\u044F",
        NE: "\u041D\u0456\u0433\u0435\u0440",
        NF: "\u041D\u043E\u0440\u0444\u043E\u043B\u043A",
        NG: "\u041D\u0456\u0433\u0435\u0440\u0456\u044F",
        NI: "\u041D\u0456\u043A\u0430\u0440\u0430\u0433\u0443\u0430",
        NL: "\u041D\u0456\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u0438",
        NO: "\u041D\u043E\u0440\u0432\u0435\u0433\u0456\u044F",
        NP: "\u041D\u0435\u043F\u0430\u043B",
        NR: "\u041D\u0430\u0443\u0440\u0443",
        NU: "\u041D\u0456\u0443\u0435",
        NZ: "\u041D\u043E\u0432\u0430 \u0417\u0435\u043B\u0430\u043D\u0434\u0456\u044F",
        OM: "\u041E\u043C\u0430\u043D",
        PA: "\u041F\u0430\u043D\u0430\u043C\u0430",
        PE: "\u041F\u0435\u0440\u0443",
        PF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u044C\u043A\u0430 \u041F\u043E\u043B\u0456\u043D\u0435\u0437\u0456\u044F",
        PG: "\u041F\u0430\u043F\u0443\u0430 \u041D\u043E\u0432\u0430 \u0413\u0432\u0456\u043D\u0435\u044F",
        PH: "\u0424\u0456\u043B\u0456\u043F\u043F\u0456\u043D\u0438",
        PK: "\u041F\u0430\u043A\u0438\u0441\u0442\u0430\u043D",
        PL: "\u041F\u043E\u043B\u044C\u0449\u0430",
        PM: "\u0421\u0435\u043D-\u041F'\u0454\u0440 \u0456 \u041C\u0456\u043A\u0435\u043B\u043E\u043D",
        PN: "\u041F\u0456\u0442\u043A\u0435\u0440\u043D",
        PR: "\u041F\u0443\u0435\u0440\u0442\u043E-\u0420\u0438\u043A\u043E",
        PS: "\u041F\u0430\u043B\u0435\u0441\u0442\u0438\u043D\u0430",
        PT: "\u041F\u043E\u0440\u0442\u0443\u0433\u0430\u043B\u0456\u044F",
        PW: "\u041F\u0430\u043B\u0430\u0443",
        PY: "\u041F\u0430\u0440\u0430\u0433\u0432\u0430\u0439",
        QA: "\u041A\u0430\u0442\u0430\u0440",
        RE: "\u0420\u0435\u044E\u043D\u044C\u0439\u043E\u043D",
        RO: "\u0420\u0443\u043C\u0443\u043D\u0456\u044F",
        RS: "\u0421\u0435\u0440\u0431\u0456\u044F",
        RU: "\u0420\u043E\u0441\u0456\u044F",
        RW: "\u0420\u0443\u0430\u043D\u0434\u0430",
        SA: "\u0421\u0430\u0443\u0434\u0456\u0432\u0441\u044C\u043A\u0430 \u0410\u0440\u0430\u0432\u0456\u044F",
        SB: "\u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438",
        SC: "\u0421\u0435\u0439\u0448\u0435\u043B\u044C\u0441\u044C\u043A\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438",
        SD: "\u0421\u0443\u0434\u0430\u043D",
        SE: "\u0428\u0432\u0435\u0446\u0456\u044F",
        SG: "\u0421\u0456\u043D\u0433\u0430\u043F\u0443\u0440",
        SH: "\u041E\u0441\u0442\u0440\u0456\u0432 \u0421\u0432\u044F\u0442\u043E\u0457 \u0404\u043B\u0435\u043D\u0438",
        SI: "\u0421\u043B\u043E\u0432\u0435\u043D\u0456\u044F",
        SJ: "\u0421\u0432\u0430\u043B\u044C\u0431\u0430\u0440\u0434 \u0456 \u042F\u043D-\u041C\u0430\u0454\u043D",
        SK: "\u0421\u043B\u043E\u0432\u0430\u0447\u0447\u0438\u043D\u0430",
        SL: "\u0421\u044C\u0454\u0440\u0440\u0430-\u041B\u0435\u043E\u043D\u0435",
        SM: "\u0421\u0430\u043D-\u041C\u0430\u0440\u0438\u043D\u043E",
        SN: "\u0421\u0435\u043D\u0435\u0433\u0430\u043B",
        SO: "\u0421\u043E\u043C\u0430\u043B\u0456",
        SR: "\u0421\u0443\u0440\u0438\u043D\u0430\u043C",
        SS: "\u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0438\u0439 \u0421\u0443\u0434\u0430\u043D",
        ST: "\u0421\u0430\u043D-\u0422\u043E\u043C\u0435 \u0456 \u041F\u0440\u0438\u043D\u0441\u0456\u043F\u0456",
        SV: "\u0421\u0430\u043B\u044C\u0432\u0430\u0434\u043E\u0440",
        SX: "\u0421\u0456\u043D\u0442-\u041C\u0430\u0440\u0442\u0435\u043D",
        SY: "\u0421\u0438\u0440\u0456\u044F",
        SZ: "\u0415\u0441\u0432\u0430\u0442\u0456\u043D\u0456",
        TC: "\u0422\u0435\u0440\u043A\u0441 \u0456 \u041A\u0430\u0439\u043A\u043E\u0441",
        TD: "\u0427\u0430\u0434",
        TF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u044C\u043A\u0456 \u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0456 \u0456 \u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0447\u043D\u0456 \u0422\u0435\u0440\u0438\u0442\u043E\u0440\u0456\u0457",
        TG: "\u0422\u043E\u0433\u043E",
        TH: "\u0422\u0430\u0457\u043B\u0430\u043D\u0434",
        TJ: "\u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D",
        TK: "\u0422\u043E\u043A\u0435\u043B\u0430\u0443",
        TL: "\u0422\u0456\u043C\u043E\u0440-\u041B\u0435\u0441\u0442\u0435",
        TM: "\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0456\u0441\u0442\u0430\u043D",
        TN: "\u0422\u0443\u043D\u0456\u0441",
        TO: "\u0422\u043E\u043D\u0433\u0430",
        TR: "\u0422\u0443\u0440\u0435\u0447\u0447\u0438\u043D\u0430",
        TT: "\u0422\u0440\u0438\u043D\u0456\u0434\u0430\u0434 \u0456 \u0422\u043E\u0431\u0430\u0433\u043E",
        TV: "\u0422\u0443\u0432\u0430\u043B\u0443",
        TW: "\u0422\u0430\u0439\u0432\u0430\u043D\u044C",
        TZ: "\u0422\u0430\u043D\u0437\u0430\u043D\u0456\u044F",
        UA: "\u0423\u043A\u0440\u0430\u0457\u043D\u0430",
        UG: "\u0423\u0433\u0430\u043D\u0434\u0430",
        UM: "\u0417\u043E\u0432\u043D\u0456\u0448\u043D\u0456 \u043C\u0430\u043B\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438 \u0421\u0428\u0410",
        US: "\u0421\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0456 \u0428\u0442\u0430\u0442\u0438 \u0410\u043C\u0435\u0440\u0438\u043A\u0438",
        UY: "\u0423\u0440\u0443\u0433\u0432\u0430\u0439",
        UZ: "\u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D",
        VA: "\u0412\u0430\u0442\u0438\u043A\u0430\u043D",
        VC: "\u0421\u0435\u043D\u0442-\u0412\u0456\u043D\u0441\u0435\u043D\u0442 \u0456 \u0413\u0440\u0435\u043D\u0430\u0434\u0438\u043D\u0438",
        VE: "\u0412\u0435\u043D\u0435\u0441\u0443\u0435\u043B\u0430",
        VG: "\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u044C\u043A\u0456 \u0412\u0456\u0440\u0433\u0456\u043D\u0441\u044C\u043A\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438",
        VI: "\u0410\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0456 \u0412\u0456\u0440\u0433\u0456\u043D\u0441\u044C\u043A\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438        ",
        VN: "\u0412'\u0454\u0442\u043D\u0430\u043C",
        VU: "\u0412\u0430\u043D\u0443\u0430\u0442\u0443",
        WF: "\u0412\u043E\u043B\u043B\u0456\u0441 \u0456 \u0424\u0443\u0442\u0443\u043D\u0430",
        WS: "\u0421\u0430\u043C\u043E\u0430",
        XK: "\u041A\u043E\u0441\u043E\u0432\u043E",
        YE: "\u0404\u043C\u0435\u043D",
        YT: "\u041C\u0430\u0439\u043E\u0442\u0442\u0430",
        ZA: "\u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0430 \u0410\u0444\u0440\u0438\u043A\u0430",
        ZM: "\u0417\u0430\u043C\u0431\u0456\u044F",
        ZW: "\u0417\u0456\u043C\u0431\u0430\u0431\u0432\u0435"
    },
    currencies: {
        ALL: "\u0412\u0441\u0456 \u0432\u0430\u043B\u044E\u0442\u0438",
        BGN: "\u0411\u043E\u043B\u0433\u0430\u0440\u0441\u044C\u043A\u0438\u0439 \u043B\u0435\u0432",
        CHF: "\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0441\u044C\u043A\u0438\u0439 \u0444\u0440\u0430\u043D\u043A",
        CZK: "\u0427\u0435\u0441\u044C\u043A\u0430 \u043A\u0440\u043E\u043D\u0430",
        DKK: "\u0414\u0430\u043D\u0441\u044C\u043A\u0430 \u043A\u0440\u043E\u043D\u0430",
        EUR: "\u0404\u0432\u0440\u043E",
        GBP: "\u0424\u0443\u043D\u0442 \u0441\u0442\u0435\u0440\u043B\u0456\u043D\u0433\u0456\u0432",
        NOK: "\u041D\u043E\u0440\u0432\u0435\u0437\u044C\u043A\u0430 \u043A\u0440\u043E\u043D\u0430",
        PLN: "\u041F\u043E\u043B\u044C\u0441\u044C\u043A\u0438\u0439 \u0437\u043B\u043E\u0442\u0438\u0439",
        RON: "\u0420\u0443\u043C\u0443\u043D\u0441\u044C\u043A\u0438\u0439 \u043B\u0435\u0439",
        SEK: "\u0428\u0432\u0435\u0434\u0441\u044C\u043A\u0430 \u043A\u0440\u043E\u043D\u0430",
        USD: "\u0414\u043E\u043B\u0430\u0440 \u0421\u0428\u0410",
        ZAR: "\u041F\u0456\u0432\u0434\u0435\u043D\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0440\u0430\u043D\u0434",
        TRY: "\u0422\u0443\u0440\u0435\u0446\u044C\u043A\u0430 \u043B\u0456\u0440\u0430",
        SGD: "\u0421\u0456\u043D\u0433\u0430\u043F\u0443\u0440\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        RUB: "\u0420\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u0440\u0443\u0431\u043B\u044C",
        NZD: "\u041D\u043E\u0432\u043E\u0437\u0435\u043B\u0430\u043D\u0434\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        MXN: "\u041C\u0435\u043A\u0441\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0441\u043E",
        HKD: "\u0413\u043E\u043D\u043A\u043E\u043D\u0433\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        CAD: "\u041A\u0430\u043D\u0430\u0434\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        AUD: "\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        HUF: "\u0423\u0433\u043E\u0440\u0441\u044C\u043A\u0438\u0439 \u0444\u043E\u0440\u0438\u043D\u0442",
        CNY: "\u041A\u0438\u0442\u0430\u0439\u0441\u044C\u043A\u0438\u0439 \u044E\u0430\u043D\u044C",
        ILS: "\u0406\u0437\u0440\u0430\u0457\u043B\u044C\u0441\u044C\u043A\u0438\u0439 \u043D\u043E\u0432\u0438\u0439 \u0448\u0435\u043A\u0435\u043B\u044C",
        JPY: "\u042F\u043F\u043E\u043D\u0441\u044C\u043A\u0430 \u0454\u043D\u0430",
        ARS: "\u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0441\u043E",
        BRL: "\u0411\u0440\u0430\u0437\u0438\u043B\u044C\u0441\u044C\u043A\u0438\u0439 \u0440\u0435\u0430\u043B",
        CLP: "\u0427\u0438\u043B\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0441\u043E",
        COP: "\u041A\u043E\u043B\u0443\u043C\u0431\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0441\u043E",
        UYU: "\u0423\u0440\u0443\u0433\u0432\u0430\u0439\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0441\u043E",
        PEN: "\u041F\u0435\u0440\u0443\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0441\u043E\u043B\u044C",
        AED: "\u0434\u0438\u0440\u0445\u0430\u043C \u041E\u0410\u0415",
        BDT: "\u0431\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448\u0441\u044C\u043A\u0430 \u0442\u0430\u043A\u0430",
        EGP: "\u0454\u0433\u0438\u043F\u0435\u0442\u0441\u044C\u043A\u0438\u0439 \u0444\u0443\u043D\u0442",
        FJD: "\u0444\u0456\u0434\u0436\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        GHS: "\u0433\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0441\u0435\u0434\u0456",
        INR: "\u0456\u043D\u0434\u0456\u0439\u0441\u044C\u043A\u0430 \u0440\u0443\u043F\u0456\u044F",
        JOD: "\u0439\u043E\u0440\u0434\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0434\u0438\u043D\u0430\u0440",
        KWD: "\u041A\u0443\u0432\u0435\u0439\u0442\u0441\u044C\u043A\u0438\u0439 \u0434\u0438\u043D\u0430\u0440",
        LSL: "\u041B\u0435\u0441\u043E\u0442\u043E \u043B\u043E\u0442\u0456",
        MAD: "\u043C\u0430\u0440\u043E\u043A\u043A\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0434\u0438\u0440\u0445\u0430\u043C",
        NAD: "\u041D\u0430\u043C\u0456\u0431\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        NPR: "\u041D\u0435\u043F\u0430\u043B\u044C\u0441\u044C\u043A\u0430 \u0440\u0443\u043F\u0456\u044F",
        OMR: "\u043E\u043C\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0440\u0456\u0430\u043B",
        PGK: "\u041F\u0430\u043F\u0443\u0430-\u041D\u043E\u0432\u0430 \u0413\u0432\u0456\u043D\u0435\u044F \u043A\u0456\u043D\u0430",
        PKR: "\u043F\u0430\u043A\u0438\u0441\u0442\u0430\u043D\u0441\u044C\u043A\u0430 \u0440\u0443\u043F\u0456\u044F",
        SAR: "\u0421\u0430\u0443\u0434\u0456\u0432\u0441\u044C\u043A\u0438\u0439 \u0440\u0456\u0430\u043B",
        SZL: "\u0421\u0432\u0430\u0437\u0456\u043B\u0435\u043D\u0434\u0441\u044C\u043A\u0438\u0439 \u043B\u0456\u0432\u0435\u043D\u0433\u0435\u043D\u044C",
        THB: "\u0442\u0430\u0439\u0441\u044C\u043A\u0438\u0439 \u0431\u0430\u0442",
        WST: "\u0421\u0430\u043C\u043E\u0430\u043D\u0441\u044C\u043A\u0430 \u0442\u0430\u043B\u0430",
        allCurrenciesLabel: "\u0412\u0441\u0456",
        mainCurrenciesLabel: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0432\u0430\u043B\u044E\u0442\u0438",
        restCurrenciesLabel: "\u0406\u043D\u0448\u0456:",
        converted: {
            BGN: "\u0431\u043E\u043B\u0433\u0430\u0440\u0441\u044C\u043A\u043E\u0433\u043E \u043B\u0435\u0432\u0430",
            CHF: "\u0448\u0432\u0435\u0439\u0446\u0430\u0440\u0441\u044C\u043A\u043E\u0433\u043E \u0444\u0440\u0430\u043D\u043A\u0430",
            CZK: "\u0447\u0435\u0441\u044C\u043A\u043E\u0457 \u043A\u0440\u043E\u043D\u0438",
            DKK: "\u0434\u0430\u043D\u0441\u044C\u043A\u043E\u0457 \u043A\u0440\u043E\u043D\u0438",
            EUR: "\u0454\u0432\u0440\u043E",
            GBP: "\u0444\u0443\u043D\u0442\u0430 \u0441\u0442\u0435\u0440\u043B\u0456\u043D\u0433\u0456\u0432",
            NOK: "\u043D\u043E\u0440\u0432\u0435\u0437\u044C\u043A\u043E\u0457 \u043A\u0440\u043E\u043D\u0438",
            PLN: "\u043F\u043E\u043B\u044C\u0441\u044C\u043A\u043E\u0433\u043E \u0437\u043B\u043E\u0442\u043E\u0433\u043E",
            RON: "\u0440\u0443\u043C\u0443\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u043B\u0435\u044F",
            SEK: "\u0448\u0432\u0435\u0434\u0441\u044C\u043A\u043E\u0457 \u043A\u0440\u043E\u043D\u0438",
            USD: "\u0434\u043E\u043B\u0430\u0440\u0430 \u0421\u0428\u0410",
            ZAR: "\u043F\u0456\u0432\u0434\u0435\u043D\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u0440\u0430\u043D\u0434\u0430",
            TRY: "\u0442\u0443\u0440\u0435\u0446\u044C\u043A\u043E\u0457 \u043B\u0456\u0440\u0438",
            SGD: "\u0441\u0456\u043D\u0433\u0430\u043F\u0443\u0440\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u0430\u0440\u0430",
            RUB: "\u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u043E\u0433\u043E \u0440\u0443\u0431\u043B\u044F",
            NZD: "\u043D\u043E\u0432\u043E\u0437\u0435\u043B\u0430\u043D\u0434\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u0430\u0440\u0430",
            MXN: "\u043C\u0435\u043A\u0441\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u043F\u0435\u0441\u043E",
            HKD: "\u0433\u043E\u043D\u043A\u043E\u043D\u0433\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u0430\u0440\u0430",
            CAD: "\u043A\u0430\u043D\u0430\u0434\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u0430\u0440\u0430",
            AUD: "\u0430\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u0439\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u0430\u0440\u0430",
            HUF: "\u0443\u0433\u043E\u0440\u0441\u044C\u043A\u043E\u0433\u043E \u0444\u043E\u0440\u0438\u043D\u0442\u0430",
            ARS: "\u0430\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u043F\u0435\u0441\u043E",
            BRL: "\u0431\u0440\u0430\u0437\u0438\u043B\u044C\u0441\u044C\u043A\u043E\u0433\u043E \u0440\u0435\u0430\u043B\u0430",
            CLP: "\u0447\u0438\u043B\u0456\u0439\u0441\u044C\u043A\u043E\u0433\u043E \u043F\u0435\u0441\u043E",
            COP: "\u043A\u043E\u043B\u0443\u043C\u0431\u0456\u0439\u0441\u044C\u043A\u043E\u0433\u043E \u043F\u0435\u0441\u043E",
            UYU: "\u0443\u0440\u0443\u0433\u0432\u0430\u0439\u0441\u044C\u043A\u043E\u0433\u043E \u043F\u0435\u0441\u043E",
            PEN: "\u043F\u0435\u0440\u0443\u0430\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u0441\u043E\u043B\u044F",
            AED: "\u0434\u0438\u0440\u0445\u0430\u043C \u041E\u0410\u0415",
            BDT: "\u0431\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448\u0441\u044C\u043A\u0430 \u0442\u0430\u043A\u0430",
            CNY: "\u043A\u0438\u0442\u0430\u0439\u0441\u044C\u043A\u0438\u0439 \u044E\u0430\u043D\u044C",
            EGP: "\u0454\u0433\u0438\u043F\u0435\u0442\u0441\u044C\u043A\u0438\u0439 \u0444\u0443\u043D\u0442",
            FJD: "\u0444\u0456\u0434\u0436\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
            GHS: "\u0433\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0441\u0435\u0434\u0456",
            INR: "\u0456\u043D\u0434\u0456\u0439\u0441\u044C\u043A\u0430 \u0440\u0443\u043F\u0456\u044F",
            JOD: "\u0439\u043E\u0440\u0434\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0434\u0438\u043D\u0430\u0440",
            KWD: "\u041A\u0443\u0432\u0435\u0439\u0442\u0441\u044C\u043A\u0438\u0439 \u0434\u0438\u043D\u0430\u0440",
            LSL: "\u041B\u0435\u0441\u043E\u0442\u043E \u043B\u043E\u0442\u0456",
            MAD: "\u043C\u0430\u0440\u043E\u043A\u043A\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0434\u0438\u0440\u0445\u0430\u043C",
            NAD: "\u041D\u0430\u043C\u0456\u0431\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
            NPR: "\u041D\u0435\u043F\u0430\u043B\u044C\u0441\u044C\u043A\u0430 \u0440\u0443\u043F\u0456\u044F",
            OMR: "\u043E\u043C\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0440\u0456\u0430\u043B",
            PGK: "\u041F\u0430\u043F\u0443\u0430-\u041D\u043E\u0432\u0430 \u0413\u0432\u0456\u043D\u0435\u044F \u043A\u0456\u043D\u0430",
            PKR: "\u043F\u0430\u043A\u0438\u0441\u0442\u0430\u043D\u0441\u044C\u043A\u0430 \u0440\u0443\u043F\u0456\u044F",
            SAR: "\u0421\u0430\u0443\u0434\u0456\u0432\u0441\u044C\u043A\u0438\u0439 \u0440\u0456\u0430\u043B",
            SZL: "\u0421\u0432\u0430\u0437\u0456\u043B\u0435\u043D\u0434\u0441\u044C\u043A\u0438\u0439 \u043B\u0456\u0432\u0435\u043D\u0433\u0435\u043D\u044C",
            THB: "\u0442\u0430\u0439\u0441\u044C\u043A\u0438\u0439 \u0431\u0430\u0442",
            WST: "\u0421\u0430\u043C\u043E\u0430\u043D\u0441\u044C\u043A\u0430 \u0442\u0430\u043B\u0430"
        }
    },
    esim: {
        searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u043A\u0440\u0430\u0457\u043D\u0438 \u0430\u0431\u043E \u0440\u0435\u0433\u0456\u043E\u043D\u0443...",
        searchAriaLabel: "\u041F\u043E\u0448\u0443\u043A \u043A\u0440\u0430\u0457\u043D\u0438 \u0430\u0431\u043E \u0440\u0435\u0433\u0456\u043E\u043D\u0443",
        searchMinChars: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C <b>\u0449\u043E\u043D\u0430\u0439\u043C\u0435\u043D\u0448\u0435 3 \u0441\u0438\u043C\u0432\u043E\u043B\u0438</b> \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432.",
        searchNoResults: "<b>\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.</b> \u0428\u0443\u043A\u0430\u043D\u0430 \u043A\u0440\u0430\u0457\u043D\u0430 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u0430.",
        searchError: "<b>\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430.</b> \u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u043F\u0438\u0441\u043E\u043A \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0439."
    },
    trackingEvent: {
        buttonGooglePlay: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437 Google Play",
        buttonAppStore: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437 App Store"
    }
};

});

parcelRegister("2GJ0A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ef42e389357ca79$export$2e2bcd8739ae039; });
var $0ef42e389357ca79$export$2e2bcd8739ae039 = {
    highcharts: {
        decimalPoint: ',',
        downloadJPEG: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C JPG \u0444\u0430\u0439\u043B",
        downloadPDF: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C PDF \u0444\u0430\u0439\u043B",
        downloadPNG: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C PNG \u0444\u0430\u0439\u043B",
        downloadSVG: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C SVG \u0444\u0430\u0439\u043B",
        exportButtonTitle: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        forexRate: "\u041A\u0443\u0440\u0441 \u0432\u0430\u043B\u044E\u0442 FOREX",
        loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
        months: [
            "\u042F\u043D\u0432\u0430\u0440\u044C",
            "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
            "\u041C\u0430\u0440\u0442",
            "\u0410\u043F\u0440\u0435\u043B\u044C",
            "\u041C\u0430\u0439",
            "\u0418\u044E\u043D\u044C",
            "\u0418\u044E\u043B\u044C",
            "\u0410\u0432\u0433\u0443\u0441\u0442",
            "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
            "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
            "\u041D\u043E\u044F\u0431\u0440\u044C",
            "\u0414\u0435\u043A\u0430\u0431\u0440\u044C"
        ],
        printButtonTitle: "\u041F\u0435\u0447\u0430\u0442\u0430\u0442\u044C",
        rangeSelectorFrom: "\u0421",
        rangeSelectorTo: "\u0414\u043E",
        rangeSelectorZoom: "\u041F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u044C",
        rateTypes: {
            ask: "\u041B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0435",
            bid: "\u041B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u043E \u043F\u043E\u043A\u0443\u043F\u043A\u0435",
            forex: "\u0421\u0440\u0435\u0434\u043D\u0438\u0439 \u043A\u0443\u0440\u0441 \u0432 \u043C\u0438\u0440\u0435"
        },
        resetZoom: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C",
        resetZoomTitle: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C",
        shortMonths: [
            "\u042F\u043D\u0432",
            "\u0424\u0435\u0432",
            "\u041C\u0430\u0440",
            "\u0410\u043F\u0440",
            "\u041C\u0430\u0439",
            "\u0418\u044E\u043D",
            "\u0418\u044E\u043B",
            "\u0410\u0432\u0433",
            "\u0421\u0435\u043D",
            "\u041E\u043A\u0442",
            "\u041D\u043E\u044F",
            "\u0414\u0435\u043A"
        ],
        thousandsSep: ' ',
        weekdays: [
            "\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
            "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
            "\u0412\u0442\u043E\u0440\u043D\u0438\u043A",
            "\u0421\u0440\u0435\u0434\u0430",
            "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
            "\u041F\u044F\u0442\u043D\u0438\u0446\u0430",
            "\u0421\u0443\u0431\u0431\u043E\u0442\u0430"
        ],
        wtBestAsk: "\u041B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0435",
        wtBestBid: "\u041B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u043E \u043F\u043E\u043A\u0443\u043F\u043A\u0435",
        seriesError: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u0443 \u043E\u043F\u0446\u0438\u044E"
    },
    calculator: {
        title: "\u0420\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u044D\u043A\u043E\u043D\u043E\u043C\u0438\u044E \u0432 Walutomat",
        forBuy: "\u0434\u043B\u044F",
        unsupportedPair: "\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043C\u044B \u043D\u0435 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C \u043A\u0443\u0440\u0441\u044B \u0434\u043B\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0439 \u0432\u0430\u043B\u044E\u0442\u043D\u043E\u0439 \u043F\u0430\u0440\u044B.",
        spinnerError: {
            generic: "\u0412\u043E\u0437\u043D\u0438\u043A\u043B\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0441 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u043E\u0439 \u0434\u0430\u043D\u043D\u044B\u0445",
            toManyRequests: '\u041A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0442\u043E\u0440 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 <a href="https://www.walutomat.com/ru/kontakt/">\u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432</a>.'
        },
        commissionWT: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F Walutomat",
        ctaButton: "\u041E\u0431\u043C\u0435\u043D\u044F\u0442\u044C",
        amountText: "\u0421\u0443\u043C\u043C\u0430"
    },
    dashboard: {
        canEditPost: "Mo\u017Cesz edytowa\u0107 wpis",
        postExists: "Wpis o takim tytule ju\u017C istnieje",
        postNotExists: 'Wpis o takim tytule nie istnieje',
        emptyPostTitle: "Dodaj tytu\u0142 wpisu",
        error: "Co\u015B posz\u0142o nie tak :("
    },
    widgetCalculator: {
        title: "\u041F\u0440\u043E\u0432\u0435\u0440\u044C \u043A\u0443\u0440\u0441\u044B \u0438{{nbsp}}\u043E\u0431\u043C\u0435\u043D\u044F\u0439 \u0432\u0430\u043B\u044E\u0442\u0443 \u0432{{nbsp}}Walutomat \u2013 \u0431\u044B\u0441\u0442\u0440\u043E \u0438{{nbsp}}\u0432\u044B\u0433\u043E\u0434\u043D\u043E.",
        actualRate: "\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u043E\u0431\u043C\u0435\u043D\u043D\u044B\u0439 \u043A\u0443\u0440\u0441",
        buySelect: "\u041F\u043E\u043A\u0443\u043F\u0430\u044E",
        sellSelect: "\u041F\u0440\u043E\u0434\u0430\u044E",
        exchangeAmountSellLabel: "\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435",
        exchangeAmountBuyLabel: "\u0412\u043D\u0435\u0441\u0438\u0442\u0435",
        commission: "\u041F\u0440\u043E\u043C\u043E-\u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044F ({{commission}}%)"
    },
    formValidation: {
        emptyField: "\u041F\u043E\u043B\u0435, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F",
        requiredField: "\u041F\u043E\u043B\u0435, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F",
        requireAllFields: "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u0434\u043E\u043B\u0436\u043D\u044B \u0431\u044B\u0442\u044C \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u044B",
        passwordToShort: "\u041F\u043E\u043B\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0438\u0437 8 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
        emailNotValid: "A\u0434\u0440\u0435\u0441 email \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439",
        emailReserved: "\u0414\u0430\u043D\u043D\u044B\u0439 email \u0443\u0436\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442",
        emailUnregistered: "\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0432 \u043D\u0430\u0448\u0435\u0439 \u0431\u0430\u0437\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432.",
        markField: "\u041E\u0442\u043C\u0435\u0442\u044C\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0438\u0437 \u0444\u043B\u0430\u0436\u043A\u043E\u0432",
        serverUnknownError: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u0432\u044F\u0437\u0438 \u0441 \u0441\u0435\u0440\u0432\u0435\u0440\u043E\u043C",
        invalidCharacters: "\u041F\u043E\u043B\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u044B",
        phoneNotValid: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u043D\u0435\u0432\u0435\u0440\u0435\u043D",
        checkBoxBelow: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0442\u043C\u0435\u0442\u044C\u0442\u0435 \u043F\u043E\u043B\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
        promocodeInvalid: "\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434 \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u043E\u0439 \u0430\u043A\u0446\u0438\u0438",
        newsletterAlreadySubscribed: "\u042D\u0442\u043E\u0442 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0443\u0436\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D \u043D\u0430 \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u043E\u0432\u043E\u0441\u0442\u0435\u0439.",
        captchaError: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043D\u0435 \u043F\u0440\u043E\u0448\u043B\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451 \u0440\u0430\u0437."
    },
    password: {
        show: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C",
        hide: "\u0441\u043A\u0440\u044B\u0432\u0430\u0442\u044C"
    },
    howItWorks: {
        showButton: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435",
        hideButton: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435"
    },
    rateCalculator: {
        baseInputLabel: 'Mam',
        counterInputLabel: 'Otrzymam',
        counterInputTooltip: "Uwzgl\u0119dnia prowizj\u0119 {{commission}}%",
        ctaAlert: 'Ustaw alert'
    },
    esim: {
        searchPlaceholder: "\u041F\u043E\u0438\u0441\u043A \u0441\u0442\u0440\u0430\u043D\u044B \u0438\u043B\u0438 \u0440\u0435\u0433\u0438\u043E\u043D\u0430...",
        searchAriaLabel: "\u041F\u043E\u0438\u0441\u043A \u0441\u0442\u0440\u0430\u043D\u044B \u0438\u043B\u0438 \u0440\u0435\u0433\u0438\u043E\u043D\u0430",
        searchMinChars: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 <b>\u043D\u0435 \u043C\u0435\u043D\u0435\u0435 3 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432</b> \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432.",
        searchNoResults: "<b>\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E.</b> \u0418\u0441\u043A\u043E\u043C\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430.",
        searchError: "<b>\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430.</b> \u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439."
    },
    countries: {
        AD: "\u0410\u043D\u0434\u043E\u0440\u0440\u0430",
        AE: "\u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u044B\u0435 \u0410\u0440\u0430\u0431\u0441\u043A\u0438\u0435 \u042D\u043C\u0438\u0440\u0430\u0442\u044B",
        AF: "\u0410\u0444\u0433\u0430\u043D\u0438\u0441\u0442\u0430\u043D",
        AG: "\u0410\u043D\u0442\u0438\u0433\u0443\u0430 \u0438 \u0411\u0430\u0440\u0431\u0443\u0434\u0430",
        AI: "\u0410\u043D\u0433\u0438\u043B\u044C\u044F",
        AL: "\u0410\u043B\u0431\u0430\u043D\u0438\u044F",
        AM: "\u0410\u0440\u043C\u0435\u043D\u0438\u044F",
        AN: "\u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0435 \u0410\u043D\u0442\u0438\u043B\u044C\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        AO: "\u0410\u043D\u0433\u043E\u043B\u0430",
        AQ: "\u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0434\u0430",
        AR: "\u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0430",
        AS: "\u0410\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u043E\u0435 \u0421\u0430\u043C\u043E\u0430",
        AT: "\u0410\u0432\u0441\u0442\u0440\u0438\u044F",
        AU: "\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0438\u044F",
        AW: "\u0410\u0440\u0443\u0431\u0430",
        AX: "\u0410\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        AZ: "\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D",
        BA: "\u0411\u043E\u0441\u043D\u0438\u044F \u0438 \u0413\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430",
        BB: "\u0411\u0430\u0440\u0431\u0430\u0434\u043E\u0441",
        BD: "\u0411\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448",
        BE: "\u0411\u0435\u043B\u044C\u0433\u0438\u044F",
        BF: "\u0411\u0443\u0440\u043A\u0438\u043D\u0430-\u0424\u0430\u0441\u043E",
        BG: "\u0411\u043E\u043B\u0433\u0430\u0440\u0438\u044F",
        BH: "\u0411\u0430\u0445\u0440\u0435\u0439\u043D",
        BI: "\u0411\u0443\u0440\u0443\u043D\u0434\u0438",
        BJ: "\u0411\u0435\u043D\u0438\u043D",
        BL: "\u0421\u0435\u043D-\u0411\u0430\u0440\u0442\u0435\u043B\u0435\u043C\u0438",
        BM: "\u0411\u0435\u0440\u043C\u0443\u0434\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        BN: "\u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u0411\u0440\u0443\u043D\u0435\u0439-\u0414\u0430\u0440\u0443\u0441\u0441\u0430\u043B\u0430\u043C",
        BO: "\u0411\u043E\u043B\u0438\u0432\u0438\u044F",
        BQ: "\u0411\u043E\u043D\u0430\u0439\u0440\u0435",
        BR: "\u0411\u0440\u0430\u0437\u0438\u043B\u0438\u044F",
        BS: "\u0411\u0430\u0433\u0430\u043C\u044B",
        BT: "\u0411\u0443\u0442\u0430\u043D",
        BV: "\u041E\u0441\u0442\u0440\u043E\u0432 \u0411\u0443\u0432\u0435",
        BW: "\u0411\u043E\u0442\u0441\u0432\u0430\u043D\u0430",
        BY: "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C",
        BZ: "\u0411\u0435\u043B\u0438\u0437",
        CA: "\u041A\u0430\u043D\u0430\u0434\u0430",
        CC: "\u041A\u043E\u043A\u043E\u0441\u043E\u0432\u044B\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        CD: "\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043D\u0433\u043E",
        CF: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
        CG: "\u041A\u043E\u043D\u0433\u043E",
        CH: "\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0438\u044F",
        CI: "\u041A\u043E\u0442-\u0434'\u0418\u0432\u0443\u0430\u0440",
        CK: "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u041A\u0443\u043A\u0430",
        CL: "\u0427\u0438\u043B\u0438",
        CM: "\u041A\u0430\u043C\u0435\u0440\u0443\u043D",
        CN: "\u041A\u0438\u0442\u0430\u0439",
        CO: "\u041A\u043E\u043B\u0443\u043C\u0431\u0438\u044F",
        CR: "\u041A\u043E\u0441\u0442\u0430-\u0420\u0438\u043A\u0430",
        CU: "\u041A\u0443\u0431\u0430",
        CV: "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0430\u0431\u043E-\u0412\u0435\u0440\u0434\u0435",
        CW: "\u041A\u044E\u0440\u0430\u0441\u0430\u043E",
        CX: "\u041E\u0441\u0442\u0440\u043E\u0432 \u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0430",
        CY: "\u041A\u0438\u043F\u0440",
        CZ: "\u0427\u0435\u0445\u0438\u044F",
        DE: "\u0413\u0435\u0440\u043C\u0430\u043D\u0438\u044F",
        DJ: "\u0414\u0436\u0438\u0431\u0443\u0442\u0438",
        DK: "\u0414\u0430\u043D\u0438\u044F",
        DM: "\u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0430",
        DO: "\u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
        DZ: "\u0410\u043B\u0436\u0438\u0440",
        EC: "\u042D\u043A\u0432\u0430\u0434\u043E\u0440",
        EE: "\u042D\u0441\u0442\u043E\u043D\u0438\u044F",
        EG: "\u0415\u0433\u0438\u043F\u0435\u0442",
        EH: "\u0417\u0430\u043F\u0430\u0434\u043D\u0430\u044F \u0421\u0430\u0445\u0430\u0440\u0430",
        ER: "\u042D\u0440\u0438\u0442\u0440\u0435\u044F",
        ES: "\u0418\u0441\u043F\u0430\u043D\u0438\u044F",
        ET: "\u042D\u0444\u0438\u043E\u043F\u0438\u044F",
        FI: "\u0424\u0438\u043D\u043B\u044F\u043D\u0434\u0438\u044F",
        FJ: "\u0424\u0438\u0434\u0436\u0438",
        FK: "\u0424\u043E\u043B\u043A\u043B\u0435\u043D\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        FM: "\u041C\u0438\u043A\u0440\u043E\u043D\u0435\u0437\u0438\u044F",
        FO: "\u0424\u0430\u0440\u0435\u0440\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        FR: "\u0424\u0440\u0430\u043D\u0446\u0438\u044F",
        GA: "\u0413\u0430\u0431\u043E\u043D",
        GB: "\u0412\u0435\u043B\u0438\u043A\u043E\u0431\u0440\u0438\u0442\u0430\u043D\u0438\u044F",
        GD: "\u0413\u0440\u0435\u043D\u0430\u0434\u0430",
        GE: "\u0413\u0440\u0443\u0437\u0438\u044F",
        GF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u0413\u0432\u0438\u0430\u043D\u0430",
        GG: "\u0413\u0435\u0440\u043D\u0441\u0438",
        GH: "\u0413\u0430\u043D\u0430",
        GI: "\u0413\u0438\u0431\u0440\u0430\u043B\u0442\u0430\u0440",
        GL: "\u0413\u0440\u0435\u043D\u043B\u0430\u043D\u0434\u0438\u044F",
        GM: "\u0413\u0430\u043C\u0431\u0438\u044F",
        GN: "\u0413\u0432\u0438\u043D\u0435\u044F",
        GP: "\u0413\u0432\u0430\u0434\u0435\u043B\u0443\u043F\u0430",
        GQ: "\u042D\u043A\u0432\u0430\u0442\u043E\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0413\u0432\u0438\u043D\u0435\u044F",
        GR: "\u0413\u0440\u0435\u0446\u0438\u044F",
        GS: "\u042E\u0436\u043D\u0430\u044F \u0413\u0435\u043E\u0440\u0433\u0438\u044F \u0438 \u042E\u0436\u043D\u044B\u0435 \u0421\u0430\u043D\u0434\u0432\u0438\u0447\u0435\u0432\u044B \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        GT: "\u0413\u0432\u0430\u0442\u0435\u043C\u0430\u043B\u0430",
        GU: "\u0413\u0443\u0430\u043C",
        GW: "\u0413\u0432\u0438\u043D\u0435\u044F-\u0411\u0438\u0441\u0430\u0443",
        GY: "\u0413\u0430\u0439\u0430\u043D\u0430",
        HK: "\u0413\u043E\u043D\u043A\u043E\u043D\u0433",
        HM: "\u041E\u0441\u0442\u0440\u043E\u0432 \u0425\u0435\u0440\u0434 \u0438 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u041C\u0430\u043A\u0434\u043E\u043D\u0430\u043B\u044C\u0434",
        HN: "\u0413\u043E\u043D\u0434\u0443\u0440\u0430\u0441",
        HR: "\u0425\u043E\u0440\u0432\u0430\u0442\u0438\u044F",
        HT: "\u0413\u0430\u0438\u0442\u0438",
        HU: "\u0412\u0435\u043D\u0433\u0440\u0438\u044F",
        ID: "\u0418\u043D\u0434\u043E\u043D\u0435\u0437\u0438\u044F",
        IE: "\u0418\u0440\u043B\u0430\u043D\u0434\u0438\u044F",
        IL: "\u0418\u0437\u0440\u0430\u0438\u043B\u044C",
        IM: "\u041E\u0441\u0442\u0440\u043E\u0432 \u041C\u044D\u043D",
        IN: "\u0418\u043D\u0434\u0438\u044F",
        IO: "\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u043A\u0430\u044F \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u0432 \u0418\u043D\u0434\u0438\u0439\u0441\u043A\u043E\u043C \u043E\u043A\u0435\u0430\u043D\u0435",
        IQ: "\u0418\u0440\u0430\u043A",
        IR: "\u0418\u0440\u0430\u043D",
        IS: "\u0418\u0441\u043B\u0430\u043D\u0434\u0438\u044F",
        IT: "\u0418\u0442\u0430\u043B\u0438\u044F",
        JE: "\u0414\u0436\u0435\u0440\u0441\u0438",
        JM: "\u042F\u043C\u0430\u0439\u043A\u0430",
        JO: "\u0418\u043E\u0440\u0434\u0430\u043D\u0438\u044F",
        JP: "\u042F\u043F\u043E\u043D\u0438\u044F",
        KE: "\u041A\u0435\u043D\u0438\u044F",
        KG: "\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D",
        KH: "\u041A\u0430\u043C\u0431\u043E\u0434\u0436\u0430",
        KI: "\u041A\u0438\u0440\u0438\u0431\u0430\u0442\u0438",
        KM: "\u041A\u043E\u043C\u043E\u0440\u044B",
        KN: "\u0421\u0435\u043D\u0442-\u041A\u0438\u0442\u0441 \u0438 \u041D\u0435\u0432\u0438\u0441",
        KP: "\u0421\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u041A\u043E\u0440\u0435\u044F",
        KR: "\u042E\u0436\u043D\u0430\u044F \u041A\u043E\u0440\u0435\u044F",
        KW: "\u041A\u0443\u0432\u0435\u0439\u0442",
        KY: "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u041A\u0430\u0439\u043C\u0430\u043D",
        KZ: "\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D",
        LA: "\u041B\u0430\u043E\u0441",
        LB: "\u041B\u0438\u0432\u0430\u043D",
        LC: "\u0421\u0435\u043D\u0442-\u041B\u044E\u0441\u0438\u044F",
        LI: "\u041B\u0438\u0445\u0442\u0435\u043D\u0448\u0442\u0435\u0439\u043D",
        LK: "\u0428\u0440\u0438-\u041B\u0430\u043D\u043A\u0430",
        LR: "\u041B\u0438\u0431\u0435\u0440\u0438\u044F",
        LS: "\u041B\u0435\u0441\u043E\u0442\u043E",
        LT: "\u041B\u0438\u0442\u0432\u0430",
        LU: "\u041B\u044E\u043A\u0441\u0435\u043C\u0431\u0443\u0440\u0433",
        LV: "\u041B\u0430\u0442\u0432\u0438\u044F",
        LY: "\u041B\u0438\u0432\u0438\u044F",
        MA: "\u041C\u0430\u0440\u043E\u043A\u043A\u043E",
        MC: "\u041C\u043E\u043D\u0430\u043A\u043E",
        MD: "\u041C\u043E\u043B\u0434\u043E\u0432\u0430",
        ME: "\u0427\u0435\u0440\u043D\u043E\u0433\u043E\u0440\u0438\u044F",
        MF: "\u0421\u0435\u043D-\u041C\u0430\u0440\u0442\u0435\u043D",
        MG: "\u041C\u0430\u0434\u0430\u0433\u0430\u0441\u043A\u0430\u0440",
        MH: "\u041C\u0430\u0440\u0448\u0430\u043B\u043B\u043E\u0432\u044B \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        MK: "\u0421\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u044F",
        ML: "\u041C\u0430\u043B\u0438",
        MM: "\u041C\u044C\u044F\u043D\u043C\u0430",
        MN: "\u041C\u043E\u043D\u0433\u043E\u043B\u0438\u044F",
        MO: "\u041C\u0430\u043A\u0430\u043E",
        MP: "\u0421\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u041C\u0430\u0440\u0438\u0430\u043D\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        MQ: "\u041C\u0430\u0440\u0442\u0438\u043D\u0438\u043A\u0430",
        MR: "\u041C\u0430\u0432\u0440\u0438\u0442\u0430\u043D\u0438\u044F",
        MS: "\u041C\u043E\u043D\u0442\u0441\u0435\u0440\u0440\u0430\u0442",
        MT: "\u041C\u0430\u043B\u044C\u0442\u0430",
        MU: "\u041C\u0430\u0432\u0440\u0438\u043A\u0438\u0439",
        MV: "\u041C\u0430\u043B\u044C\u0434\u0438\u0432\u044B",
        MW: "\u041C\u0430\u043B\u0430\u0432\u0438",
        MX: "\u041C\u0435\u043A\u0441\u0438\u043A\u0430",
        MY: "\u041C\u0430\u043B\u0430\u0439\u0437\u0438\u044F",
        MZ: "\u041C\u043E\u0437\u0430\u043C\u0431\u0438\u043A",
        NA: "\u041D\u0430\u043C\u0438\u0431\u0438\u044F",
        NC: "\u041D\u043E\u0432\u0430\u044F \u041A\u0430\u043B\u0435\u0434\u043E\u043D\u0438\u044F",
        NE: "\u041D\u0438\u0433\u0435\u0440",
        NF: "\u041D\u043E\u0440\u0444\u043E\u043B\u043A",
        NG: "\u041D\u0438\u0433\u0435\u0440\u0438\u044F",
        NI: "\u041D\u0438\u043A\u0430\u0440\u0430\u0433\u0443\u0430",
        NL: "\u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u044B",
        NO: "\u041D\u043E\u0440\u0432\u0435\u0433\u0438\u044F",
        NP: "\u041D\u0435\u043F\u0430\u043B",
        NR: "\u041D\u0430\u0443\u0440\u0443",
        NU: "\u041D\u0438\u0443\u044D",
        NZ: "\u041D\u043E\u0432\u0430\u044F \u0417\u0435\u043B\u0430\u043D\u0434\u0438\u044F",
        OM: "\u041E\u043C\u0430\u043D",
        PA: "\u041F\u0430\u043D\u0430\u043C\u0430",
        PE: "\u041F\u0435\u0440\u0443",
        PF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u041F\u043E\u043B\u0438\u043D\u0435\u0437\u0438\u044F",
        PG: "\u041F\u0430\u043F\u0443\u0430-\u041D\u043E\u0432\u0430\u044F \u0413\u0432\u0438\u043D\u0435\u044F",
        PH: "\u0424\u0438\u043B\u0438\u043F\u043F\u0438\u043D\u044B",
        PK: "\u041F\u0430\u043A\u0438\u0441\u0442\u0430\u043D",
        PL: "\u041F\u043E\u043B\u044C\u0448\u0430",
        PM: "\u0421\u0435\u043D-\u041F\u044C\u0435\u0440 \u0438 \u041C\u0438\u043A\u0435\u043B\u043E\u043D",
        PN: "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u041F\u0438\u0442\u043A\u044D\u0440\u043D",
        PR: "\u041F\u0443\u044D\u0440\u0442\u043E-\u0420\u0438\u043A\u043E",
        PS: "\u041F\u0430\u043B\u0435\u0441\u0442\u0438\u043D\u0430",
        PT: "\u041F\u043E\u0440\u0442\u0443\u0433\u0430\u043B\u0438\u044F",
        PW: "\u041F\u0430\u043B\u0430\u0443",
        PY: "\u041F\u0430\u0440\u0430\u0433\u0432\u0430\u0439",
        QA: "\u041A\u0430\u0442\u0430\u0440",
        RE: "\u0420\u0435\u044E\u043D\u044C\u043E\u043D",
        RO: "\u0420\u0443\u043C\u044B\u043D\u0438\u044F",
        RS: "\u0421\u0435\u0440\u0431\u0438\u044F",
        RU: "\u0420\u043E\u0441\u0441\u0438\u044F",
        RW: "\u0420\u0443\u0430\u043D\u0434\u0430",
        SA: "\u0421\u0430\u0443\u0434\u043E\u0432\u0441\u043A\u0430\u044F \u0410\u0440\u0430\u0432\u0438\u044F",
        SB: "\u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u044B \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        SC: "\u0421\u0435\u0439\u0448\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        SD: "\u0421\u0443\u0434\u0430\u043D",
        SE: "\u0428\u0432\u0435\u0446\u0438\u044F",
        SG: "\u0421\u0438\u043D\u0433\u0430\u043F\u0443\u0440",
        SH: "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u0432\u044F\u0442\u043E\u0439 \u0415\u043B\u0435\u043D\u044B, \u0412\u043E\u0437\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0438 \u0422\u0440\u0438\u0441\u0442\u0430\u043D-\u0434\u0430-\u041A\u0443\u043D\u044C\u044F",
        SI: "\u0421\u043B\u043E\u0432\u0435\u043D\u0438\u044F",
        SJ: "\u0428\u043F\u0438\u0446\u0431\u0435\u0440\u0433\u0435\u043D \u0438 \u042F\u043D-\u041C\u0430\u0439\u0435\u043D",
        SK: "\u0421\u043B\u043E\u0432\u0430\u043A\u0438\u044F",
        SL: "\u0421\u044C\u0435\u0440\u0440\u0430-\u041B\u0435\u043E\u043D\u0435",
        SM: "\u0421\u0430\u043D-\u041C\u0430\u0440\u0438\u043D\u043E",
        SN: "\u0421\u0435\u043D\u0435\u0433\u0430\u043B",
        SO: "\u0421\u043E\u043C\u0430\u043B\u0438",
        SR: "\u0421\u0443\u0440\u0438\u043D\u0430\u043C",
        SS: "\u042E\u0436\u043D\u044B\u0439 \u0421\u0443\u0434\u0430\u043D",
        ST: "\u0421\u0430\u043D-\u0422\u043E\u043C\u0435 \u0438 \u041F\u0440\u0438\u043D\u0441\u0438\u043F\u0438",
        SV: "\u0421\u0430\u043B\u044C\u0432\u0430\u0434\u043E\u0440",
        SX: "\u0421\u0438\u043D\u0442-\u041C\u0430\u0440\u0442\u0435\u043D",
        SY: "\u0421\u0438\u0440\u0438\u044F",
        SZ: "\u042D\u0441\u0432\u0430\u0442\u0438\u043D\u0438",
        TC: "\u0422\u0435\u0440\u043A\u0441 \u0438 \u041A\u0430\u0439\u043A\u043E\u0441",
        TD: "\u0427\u0430\u0434",
        TF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0438\u0435 \u042E\u0436\u043D\u044B\u0435 \u0438 \u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438",
        TG: "\u0422\u043E\u0433\u043E",
        TH: "\u0422\u0430\u0438\u043B\u0430\u043D\u0434",
        TJ: "\u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D",
        TK: "\u0422\u043E\u043A\u0435\u043B\u0430\u0443",
        TL: "\u0412\u043E\u0441\u0442\u043E\u0447\u043D\u044B\u0439 \u0422\u0438\u043C\u043E\u0440",
        TM: "\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D",
        TN: "\u0422\u0443\u043D\u0438\u0441",
        TO: "\u0422\u043E\u043D\u0433\u0430",
        TR: "\u0422\u0443\u0440\u0446\u0438\u044F",
        TT: "\u0422\u0440\u0438\u043D\u0438\u0434\u0430\u0434 \u0438 \u0422\u043E\u0431\u0430\u0433\u043E",
        TV: "\u0422\u0443\u0432\u0430\u043B\u0443",
        TW: "\u0422\u0430\u0439\u0432\u0430\u043D\u044C",
        TZ: "\u0422\u0430\u043D\u0437\u0430\u043D\u0438\u044F",
        UA: "\u0423\u043A\u0440\u0430\u0438\u043D\u0430",
        UG: "\u0423\u0433\u0430\u043D\u0434\u0430",
        UM: "\u0412\u043D\u0435\u0448\u043D\u0438\u0435 \u043C\u0430\u043B\u044B\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u0428\u0410",
        US: "\u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u044B\u0435 \u0428\u0442\u0430\u0442\u044B \u0410\u043C\u0435\u0440\u0438\u043A\u0438",
        UY: "\u0423\u0440\u0443\u0433\u0432\u0430\u0439",
        UZ: "\u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D",
        VA: "\u0412\u0430\u0442\u0438\u043A\u0430\u043D",
        VC: "\u0421\u0435\u043D\u0442-\u0412\u0438\u043D\u0441\u0435\u043D\u0442 \u0438 \u0413\u0440\u0435\u043D\u0430\u0434\u0438\u043D\u044B",
        VE: "\u0412\u0435\u043D\u0435\u0441\u0443\u044D\u043B\u0430",
        VG: "\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u043A\u0438\u0435 \u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        VI: "\u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u0428\u0410",
        VN: "\u0412\u044C\u0435\u0442\u043D\u0430\u043C",
        VU: "\u0412\u0430\u043D\u0443\u0430\u0442\u0443",
        WF: "\u0423\u043E\u043B\u043B\u0438\u0441 \u0438 \u0424\u0443\u0442\u0443\u043D\u0430",
        WS: "\u0421\u0430\u043C\u043E\u0430",
        XK: "\u041A\u043E\u0441\u043E\u0432\u043E",
        YE: "\u0419\u0435\u043C\u0435\u043D",
        YT: "\u041C\u0430\u0439\u043E\u0442\u0442\u0430",
        ZA: "\u042E\u0436\u043D\u0430\u044F \u0410\u0444\u0440\u0438\u043A\u0430",
        ZM: "\u0417\u0430\u043C\u0431\u0438\u044F",
        ZW: "\u0417\u0438\u043C\u0431\u0430\u0431\u0432\u0435"
    },
    trackingEvent: {
        buttonGooglePlay: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0438\u0437 Google Play",
        buttonAppStore: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0438\u0437 App Store"
    }
};

});

parcelRegister("jmkw8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $764c75641a0fa46a$export$2e2bcd8739ae039; });
var $764c75641a0fa46a$export$2e2bcd8739ae039 = {
    highcharts: {
        decimalPoint: ',',
        downloadJPEG: 'Pobierz obraz JPEG',
        downloadPDF: 'Pobierz dokument PDF',
        downloadPNG: 'Pobierz obraz PNG',
        downloadSVG: 'Pobierz obraz SVG',
        exportButtonTitle: 'Eksport',
        forexRate: "Kurs \u015Bredni FOREX",
        loading: "\u0141adowanie...",
        months: [
            "Stycze\u0144",
            'Luty',
            'Marzec',
            "Kwiecie\u0144",
            'Maj',
            'Czerwiec',
            'Lipiec',
            "Sierpie\u0144",
            "Wrzesie\u0144",
            "Pa\u017Adziernik",
            'Listopad',
            "Grudzie\u0144"
        ],
        printButtonTitle: 'Drukowanie',
        rangeSelectorFrom: 'Od',
        rangeSelectorTo: 'Do',
        rangeSelectorZoom: "Przybli\u017Cenie",
        rateTypes: {
            ask: "Najlepsza oferta sprzeda\u017Cy",
            bid: 'Najlepsza oferta kupna',
            forex: "\u015Aredni kurs na \u015Bwiecie"
        },
        resetZoom: 'Reset',
        resetZoomTitle: 'Reset',
        shortMonths: [
            'Sty',
            'Lut',
            'Mar',
            'Kwi',
            'Maj',
            'Cze',
            'Lip',
            'Sie',
            'Wrz',
            "Pa\u017A",
            'Lis',
            'Gru'
        ],
        thousandsSep: ' ',
        weekdays: [
            'Niedziela',
            "Poniedzia\u0142ek",
            'Wtorek',
            "\u015Aroda",
            'Czwartek',
            "Pi\u0105tek",
            'Sobota'
        ],
        wtBestAsk: "Najlepsza oferta sprzeda\u017Cy",
        wtBestBid: 'Najlepsza oferta kupna',
        seriesError: "Mindestens eine Option muss ausgew\xe4hlt werden"
    },
    calculator: {
        title: 'Einsparungen im Walutomat berechnen',
        forBuy: "f\xfcr",
        unsupportedPair: "Wir bieten derzeit keine Kurse f\xfcr das ausgew\xe4hlte W\xe4hrungspaar an.",
        spinnerError: {
            generic: 'Beim Herunterladen der Daten ist ein Fehler aufgetreten',
            toManyRequests: 'Der Rechner ist derzeit nicht verf\xfcgbar. Versuchen Sie es sp\xe4ter noch einmal oder wenden Sie sich an den <a href="https://www.walutomat.com/de/kontakt/">Kundenservice</a>.'
        },
        commissionWT: 'Walutomat-Provision',
        ctaButton: 'Wechseln',
        amountText: 'Betrag'
    },
    dashboard: {
        canEditPost: "Mo\u017Cesz edytowa\u0107 wpis",
        postExists: "Wpis o takim tytule ju\u017C istnieje",
        postNotExists: 'Wpis o takim tytule nie istnieje',
        emptyPostTitle: "Dodaj tytu\u0142 wpisu",
        error: "Co\u015B posz\u0142o nie tak :("
    },
    widgetCalculator: {
        title: "\xdcberpr\xfcfen Sie die Kurse und{{nbsp}}tauschen Sie W\xe4hrungen in{{nbsp}}Walutomat \u2013 schnell und{{nbsp}}g\xfcnstig.",
        actualRate: 'Wechselkurs',
        buySelect: 'Ich kaufe',
        sellSelect: 'Verkaufen',
        exchangeAmountSellLabel: 'Sie erhalten',
        exchangeAmountBuyLabel: 'Einzahlung',
        commission: 'Werbe-Provision ({{commission}}%)'
    },
    formValidation: {
        emptyField: 'Das Feld darf nicht leer sein',
        requiredField: 'Das Feld ist Pflichtfeld',
        requireAllFields: "Alle Felder m\xfcssen ausgef\xfcllt werden",
        passwordToShort: 'Das Passwort muss 8 Zeichen lang sein',
        emailNotValid: "Das Feld muss eine g\xfcltige E-Mail Adresse enthalten",
        emailReserved: 'Die E-Mail-Adresse ist bereits vergeben',
        emailUnregistered: 'Die E-Mail-Adresse wurde nicht in unserer Kundendatenbank gefunden.',
        markField: "Markieren Sie mindestens eines der Kontrollk\xe4stchen",
        serverUnknownError: 'Kommunikationsfehler des Servers',
        invalidCharacters: "Feld enth\xe4lt ung\xfcltige Zeichen",
        phoneNotValid: 'Die Telefonnummer ist falsch',
        checkBoxBelow: 'Bitte kreuzen Sie das Feld unten an, um eine Nachricht zu senden',
        promocodeInvalid: "Ung\xfcltiger Promocode",
        newsletterAlreadySubscribed: "Diese E-Mail-Adresse ist bereits f\xfcr den Newsletter angemeldet."
    },
    password: {
        show: 'anzeigen',
        hide: 'ausblenden'
    },
    howItWorks: {
        showButton: 'Mehr anzeigen',
        hideButton: 'Weniger anzeigen'
    },
    rateCalculator: {
        baseInputLabel: 'Mam',
        counterInputLabel: 'Otrzymam',
        counterInputTooltip: "Uwzgl\u0119dnia prowizj\u0119 {{commission}}%",
        ctaAlert: 'Ustaw alert'
    },
    esim: {
        searchPlaceholder: 'Land oder Region suchen...',
        searchAriaLabel: 'Land oder Region suchen',
        searchMinChars: 'Geben Sie <b>mindestens 3 Zeichen</b> ein, um Ergebnisse anzuzeigen.',
        searchNoResults: '<b>Keine Ergebnisse.</b> Das gesuchte Land wurde nicht gefunden.',
        searchError: '<b>Ein Fehler ist aufgetreten.</b> Die Angebotsliste konnte nicht geladen werden.'
    },
    countries: {
        AD: 'Andorra',
        AE: 'Vereinigte Arabische Emirate',
        AF: 'Afghanistan',
        AG: 'Antigua und Barbuda',
        AI: 'Anguilla',
        AL: 'Albanien',
        AM: 'Armenien',
        AO: 'Angola',
        AQ: 'Antarktis',
        AR: 'Argentinien',
        AS: 'Amerikanisch-Samoa',
        AT: "\xd6sterreich",
        AU: 'Australien',
        AW: 'Aruba',
        AX: "\xc5landinseln",
        AZ: 'Aserbaidschan',
        BA: 'Bosnien und Herzegowina',
        BB: 'Barbados',
        BD: 'Bangladesch',
        BE: 'Belgien',
        BF: 'Burkina Faso',
        BG: 'Bulgarien',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BL: "Saint-Barth\xe9lemy",
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivien',
        BQ: 'Bonaire',
        BR: 'Brasilien',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvetinsel',
        BW: 'Botswana',
        BY: 'Belarus',
        BZ: 'Belize',
        CA: 'Kanada',
        CC: 'Cocos-Inseln',
        CD: 'Demokratische Republik Kongo',
        CF: 'Zentralafrikanische Republik',
        CG: 'Kongo',
        CH: 'Schweiz',
        CI: "Elfenbeink\xfcste",
        CK: 'Cook-Inseln',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'China',
        CO: 'Kolumbien',
        CR: 'Costa Rica',
        CU: 'Kuba',
        CV: 'Cabo Verde',
        CW: "Cura\xe7ao",
        CX: 'Weihnachtsinsel',
        CY: 'Zypern',
        CZ: 'Tschechische Republik',
        DE: 'Deutschland',
        DJ: 'Dschibuti',
        DK: "D\xe4nemark",
        DM: 'Dominica',
        DO: 'Dominikanische Republik',
        DZ: 'Algerien',
        EC: 'Ecuador',
        EE: 'Estland',
        EG: "\xc4gypten",
        EH: 'Westsahara',
        ER: 'Eritrea',
        ES: 'Spanien',
        ET: "\xc4thiopien",
        FI: 'Finnland',
        FJ: 'Fidschi',
        FK: 'Falklandinseln',
        FM: 'Mikronesien',
        FO: "F\xe4r\xf6er Inseln",
        FR: 'Frankreich',
        GA: 'Gabun',
        GB: "Vereinigtes K\xf6nigreich",
        GD: 'Grenada',
        GE: 'Georgien',
        GF: "Franz\xf6sisch-Guayana",
        GG: 'Guernsey',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: "Gr\xf6nland",
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe',
        GQ: "\xc4quatorialguinea",
        GR: 'Griechenland',
        GS: "S\xfcdgeorgien und die S\xfcdlichen Sandwichinseln",
        GT: 'Guatemala',
        GU: 'Guam',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hongkong',
        HM: 'Heard-Insel und McDonald-Inseln',
        HN: 'Honduras',
        HR: 'Kroatien',
        HT: 'Haiti',
        HU: 'Ungarn',
        ID: 'Indonesien',
        IE: 'Irland',
        IL: 'Israel',
        IM: 'Isle of Man',
        IN: 'Indien',
        IO: 'Britisches Territorium im Indischen Ozean',
        IQ: 'Irak',
        IR: 'Iran',
        IS: 'Island',
        IT: 'Italien',
        JE: 'Jersey',
        JM: 'Jamaika',
        JO: 'Jordanien',
        JP: 'Japan',
        KE: 'Kenia',
        KG: 'Kirgisistan',
        KH: 'Kambodscha',
        KI: 'Kiribati',
        KM: 'Komoren-Inseln',
        KN: 'St. Kitts und Nevis',
        KP: 'Nordkorea',
        KR: "S\xfcdkorea",
        KW: 'Kuwait',
        KY: 'Kaimaninseln',
        KZ: 'Kasachstan',
        LA: 'Laos',
        LB: 'Libanon',
        LC: 'St. Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litauen',
        LU: 'Luxemburg',
        LV: 'Lettland',
        LY: 'Libyen',
        MA: 'Marokko',
        MC: 'Monaco',
        MD: 'Moldawien',
        ME: 'Montenegro',
        MF: 'Saint-Martin',
        MG: 'Madagaskar',
        MH: 'Marshallinseln',
        MK: 'Nordmazedonien',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolei',
        MO: 'Macau',
        MP: "N\xf6rdliche Marianen",
        MQ: 'Martinique',
        MR: 'Mauretanien',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Malediven',
        MW: 'Malawi',
        MX: 'Mexiko',
        MY: 'Malaysia',
        MZ: 'Mosambik',
        NA: 'Namibia',
        NC: 'Neukaledonien',
        NE: 'Niger',
        NF: 'Norfolk',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Niederlande',
        NO: 'Norwegen',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Neuseeland',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: "Franz\xf6sisch-Polynesien",
        PG: 'Papua-Neuguinea',
        PH: 'Philippinen',
        PK: 'Pakistan',
        PL: 'Polen',
        PM: 'Saint-Pierre und Miquelon',
        PN: 'Pitcairn',
        PR: 'Puerto Rico',
        PS: "Pal\xe4stina",
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Katar',
        RE: "R\xe9union",
        RO: "Rum\xe4nien",
        RS: 'Serbien',
        RU: 'Russland',
        RW: 'Ruanda',
        SA: 'Saudi-Arabien',
        SB: 'Salomonen',
        SC: 'Seychellen',
        SD: 'Sudan',
        SE: 'Schweden',
        SG: 'Singapur',
        SH: 'St. Helena, Ascension und Tristan da Cunha',
        SI: 'Slowenien',
        SJ: 'Svalbard und Jan Mayen',
        SK: 'Slowakei',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        SS: "S\xfcdsudan",
        ST: "S\xe3o Tom\xe9 und Pr\xedncipe",
        SV: 'El Salvador',
        SX: 'Sint Maarten',
        SY: 'Syrien',
        SZ: 'Eswatini',
        TC: 'Turks- und Caicosinseln',
        TD: 'Tschad',
        TF: "Franz\xf6sische S\xfcd- und Antarktisgebiete",
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tadschikistan',
        TK: 'Tokelau',
        TL: 'Timor-Leste',
        TM: 'Turkmenistan',
        TN: 'Tunesien',
        TO: 'Tonga',
        TR: "T\xfcrkei",
        TT: 'Trinidad und Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tansania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'Kleinere abgelegene Inseln der Vereinigten Staaten',
        US: 'Vereinigte Staaten',
        UY: 'Uruguay',
        UZ: 'Usbekistan',
        VA: 'Vatikan',
        VC: 'St. Vincent und die Grenadinen',
        VE: 'Venezuela',
        VG: 'Britische Jungferninseln',
        VI: 'Amerikanischen Jungferninseln',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis und Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Jemen',
        YT: 'Mayotte',
        ZA: "S\xfcdafrika",
        ZM: 'Sambia',
        ZW: 'Simbabwe'
    }
};

});

parcelRegister("9JuL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e789d12175fd656$export$2e2bcd8739ae039; });
var $2e789d12175fd656$export$2e2bcd8739ae039 = {
    highcharts: {
        decimalPoint: ',',
        downloadJPEG: 'Pobierz obraz JPEG',
        downloadPDF: 'Pobierz dokument PDF',
        downloadPNG: 'Pobierz obraz PNG',
        downloadSVG: 'Pobierz obraz SVG',
        exportButtonTitle: 'Eksport',
        forexRate: "Kurs \u015Bredni FOREX",
        loading: "\u0141adowanie...",
        months: [
            "Stycze\u0144",
            'Luty',
            'Marzec',
            "Kwiecie\u0144",
            'Maj',
            'Czerwiec',
            'Lipiec',
            "Sierpie\u0144",
            "Wrzesie\u0144",
            "Pa\u017Adziernik",
            'Listopad',
            "Grudzie\u0144"
        ],
        printButtonTitle: 'Drukowanie',
        rangeSelectorFrom: 'Od',
        rangeSelectorTo: 'Do',
        rangeSelectorZoom: "Przybli\u017Cenie",
        rateTypes: {
            ask: "Najlepsza oferta sprzeda\u017Cy",
            bid: 'Najlepsza oferta kupna',
            forex: "\u015Aredni kurs na \u015Bwiecie"
        },
        resetZoom: 'Reset',
        resetZoomTitle: 'Reset',
        shortMonths: [
            'Sty',
            'Lut',
            'Mar',
            'Kwi',
            'Maj',
            'Cze',
            'Lip',
            'Sie',
            'Wrz',
            "Pa\u017A",
            'Lis',
            'Gru'
        ],
        thousandsSep: ' ',
        weekdays: [
            'Niedziela',
            "Poniedzia\u0142ek",
            'Wtorek',
            "\u015Aroda",
            'Czwartek',
            "Pi\u0105tek",
            'Sobota'
        ],
        wtBestAsk: "Najlepsza oferta sprzeda\u017Cy",
        wtBestBid: 'Najlepsza oferta kupna',
        seriesError: "Je potrebn\xe9 vybra\u0165 aspo\u0148 jednu mo\u017Enos\u0165"
    },
    calculator: {
        title: "V\xfdpo\u010Det \xfaspor v aplikaci Walutomat",
        forBuy: 'pro',
        unsupportedPair: "V sou\u010Dasn\xe9 dob\u011B nenab\xedz\xedme kurzy pro vybran\xfd m\u011Bnov\xfd p\xe1r.",
        spinnerError: {
            generic: "P\u0159i stahov\xe1n\xed dat do\u0161lo k probl\xe9mu",
            toManyRequests: 'Kalkul\xe1tor je moment\xe1lne nedostupn\xfd. Sk\xfaste to nesk\xf4r alebo kontaktujte <a href="https://www.walutomat.com/sk/kontakt/">Z\xe1kazn\xedcky Servis</a>.'
        },
        commissionWT: "Prov\xedzia Walutomat",
        ctaButton: "Vymeni\u0165",
        amountText: "\u010C\xe1stka"
    },
    dashboard: {
        canEditPost: "Mo\u017Cesz edytowa\u0107 wpis",
        postExists: "Wpis o takim tytule ju\u017C istnieje",
        postNotExists: 'Wpis o takim tytule nie istnieje',
        emptyPostTitle: "Dodaj tytu\u0142 wpisu",
        error: "Co\u015B posz\u0142o nie tak :("
    },
    widgetCalculator: {
        title: "Skontrolujte kurzy a{{nbsp}}preme\u0148te menu v{{nbsp}}Walutomat \u2013 r\xfdchlo a{{nbsp}}v\xfdhodne.",
        actualRate: "Aktu\xe1lny kurz",
        buySelect: 'Kupujem',
        sellSelect: "Pred\xe1vam",
        exchangeAmountSellLabel: 'Dostanete',
        exchangeAmountBuyLabel: "Vlo\u017Ete",
        commission: "Propaga\u010Dn\xe1 prov\xedzia ({{commission}}%)"
    },
    formValidation: {
        emptyField: "Pole nem\xf4\u017Ee by\u0165 pr\xe1zdne",
        requiredField: "Pole je povinn\xe9",
        requireAllFields: "V\u0161etky polia musia by\u0165 vyplnen\xe9",
        passwordToShort: "Heslo mus\xed ma\u0165 8 znakov",
        emailNotValid: "Pole mus\xed obsahova\u0165 platn\xfa e-mailov\xfa adresu",
        emailReserved: "E-mailov\xe1 adresa je u\u017E obsaden\xe1",
        emailUnregistered: "Va\u0161u e-mailov\xfa adresu sme nena\u0161li v na\u0161ej datab\xe1ze z\xe1kazn\xedkov.",
        markField: "Vyberte aspo\u0148 jedno z pol\xed\u010D",
        serverUnknownError: "Chyba komunik\xe1cie so serverom",
        invalidCharacters: "Pole obsahuje neplatn\xe9 znaky",
        phoneNotValid: "Telef\xf3nne \u010D\xedslo je nespr\xe1vne",
        checkBoxBelow: "Pros\xedm, za\u0161krtnite pol\xed\u010Dko ni\u017E\u0161ie, aby ste mohli posla\u0165 spr\xe1vu",
        promocodeInvalid: "Neplatn\xfd propaga\u010Dn\xfd k\xf3d",
        newsletterAlreadySubscribed: "Tento e-mail je u\u017E prihl\xe1sen\xfd na odber newslettera."
    },
    password: {
        show: "zobrazi\u0165",
        hide: 'skryt'
    },
    howItWorks: {
        showButton: "Zobrazi\u0165 viac",
        hideButton: "Zobrazi\u0165 menej"
    },
    rateCalculator: {
        baseInputLabel: 'Mam',
        counterInputLabel: 'Otrzymam',
        counterInputTooltip: "Uwzgl\u0119dnia prowizj\u0119 {{commission}}%",
        ctaAlert: 'Ustaw alert'
    },
    esim: {
        searchPlaceholder: "Vyh\u013Eadajte krajinu alebo regi\xf3n...",
        searchAriaLabel: "Vyh\u013Eadajte krajinu alebo regi\xf3n",
        searchMinChars: "Zadajte <b>aspo\u0148 3 znaky</b> pre zobrazenie v\xfdsledkov.",
        searchNoResults: "<b>\u017Diadne v\xfdsledky.</b> H\u013Eadan\xe1 krajina nebola n\xe1jden\xe1.",
        searchError: "<b>Vyskytla sa chyba.</b> Nepodarilo sa na\u010D\xedta\u0165 zoznam pon\xfak."
    }
};

});

parcelRegister("9XuHE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb7bdf63fe20010e$export$2e2bcd8739ae039; });
var $eb7bdf63fe20010e$export$2e2bcd8739ae039 = {
    highcharts: {
        decimalPoint: ',',
        downloadJPEG: 'Pobierz obraz JPEG',
        downloadPDF: 'Pobierz dokument PDF',
        downloadPNG: 'Pobierz obraz PNG',
        downloadSVG: 'Pobierz obraz SVG',
        exportButtonTitle: 'Eksport',
        forexRate: "Kurs \u015Bredni FOREX",
        loading: "\u0141adowanie...",
        months: [
            "Stycze\u0144",
            'Luty',
            'Marzec',
            "Kwiecie\u0144",
            'Maj',
            'Czerwiec',
            'Lipiec',
            "Sierpie\u0144",
            "Wrzesie\u0144",
            "Pa\u017Adziernik",
            'Listopad',
            "Grudzie\u0144"
        ],
        printButtonTitle: 'Drukowanie',
        rangeSelectorFrom: 'Od',
        rangeSelectorTo: 'Do',
        rangeSelectorZoom: "Przybli\u017Cenie",
        rateTypes: {
            ask: "Najlepsza oferta sprzeda\u017Cy",
            bid: 'Najlepsza oferta kupna',
            forex: "\u015Aredni kurs na \u015Bwiecie"
        },
        resetZoom: 'Reset',
        resetZoomTitle: 'Reset',
        shortMonths: [
            'Sty',
            'Lut',
            'Mar',
            'Kwi',
            'Maj',
            'Cze',
            'Lip',
            'Sie',
            'Wrz',
            "Pa\u017A",
            'Lis',
            'Gru'
        ],
        thousandsSep: ' ',
        weekdays: [
            'Niedziela',
            "Poniedzia\u0142ek",
            'Wtorek',
            "\u015Aroda",
            'Czwartek',
            "Pi\u0105tek",
            'Sobota'
        ],
        wtBestAsk: "Najlepsza oferta sprzeda\u017Cy",
        wtBestBid: 'Najlepsza oferta kupna',
        seriesError: "Debe seleccionar al menos una opci\xf3n"
    },
    calculator: {
        title: 'Calcular el ahorro en Walutomat',
        forBuy: 'para',
        unsupportedPair: 'Actualmente no ofrecemos tarifas para el par de divisas seleccionado.',
        spinnerError: {
            generic: 'Hubo un problema con la descarga de datos',
            toManyRequests: 'La calculadora no est\xe1 disponible en este momento. Int\xe9ntalo de nuevo m\xe1s tarde o ponte en contacto con el <a href="https://www.walutomat.com/es/pongase-en-contacto-con/">Servicio de Atenci\xf3n al Cliente</a>.'
        },
        commissionWT: "Comisi\xf3n de Walutomat",
        ctaButton: 'Cambiar',
        amountText: 'Importe'
    },
    dashboard: {
        canEditPost: "Mo\u017Cesz edytowa\u0107 wpis",
        postExists: "Wpis o takim tytule ju\u017C istnieje",
        postNotExists: 'Wpis o takim tytule nie istnieje',
        emptyPostTitle: "Dodaj tytu\u0142 wpisu",
        error: "Co\u015B posz\u0142o nie tak :("
    },
    widgetCalculator: {
        title: "Comprueba los tipos de cambio y{{nbsp}}cambia divisas en{{nbsp}}Walutomat \u2013 r\xe1pido y{{nbsp}}ventajoso.",
        actualRate: 'Tipo de cambio actual',
        buySelect: 'Comprar',
        sellSelect: 'Vendo',
        exchangeAmountSellLabel: "Recibir\xe1s",
        exchangeAmountBuyLabel: "Dep\xf3sito",
        commission: "Comisi\xf3n promocional ({{commission}}%)"
    },
    formValidation: {
        emptyField: "El campo no puede estar vac\xedo",
        requiredField: 'El campo es obligatorio',
        requireAllFields: 'Todos los campos deben estar completos',
        passwordToShort: "La contrase\xf1a debe tener 8 caracteres",
        emailNotValid: "El campo debe contener una direcci\xf3n de correo electr\xf3nico v\xe1lida",
        emailReserved: "La direcci\xf3n de correo electr\xf3nico ya est\xe1 ocupada",
        emailUnregistered: "No encontramos tu direcci\xf3n de correo electr\xf3nico en nuestra base de datos de clientes.",
        markField: 'Marque al menos una de las casillas',
        serverUnknownError: "Error de comunicaci\xf3n con el servidor",
        invalidCharacters: "El campo contiene caracteres no v\xe1lidos",
        phoneNotValid: "El n\xfamero de tel\xe9fono es incorrecto",
        checkBoxBelow: 'Por favor, marque la casilla de abajo para enviar un mensaje',
        promocodeInvalid: "C\xf3digo de promoci\xf3n no v\xe1lido",
        newsletterAlreadySubscribed: "Este correo electr\xf3nico ya est\xe1 suscrito al bolet\xedn."
    },
    password: {
        show: 'mostrar',
        hide: 'ocultar'
    },
    howItWorks: {
        showButton: "Mostrar m\xe1s",
        hideButton: 'Mostrar menos'
    },
    rateCalculator: {
        baseInputLabel: 'Mam',
        counterInputLabel: 'Otrzymam',
        counterInputTooltip: "Uwzgl\u0119dnia prowizj\u0119 {{commission}}%",
        ctaAlert: 'Ustaw alert'
    },
    esim: {
        searchPlaceholder: "Buscar un pa\xeds o regi\xf3n...",
        searchAriaLabel: "Buscar un pa\xeds o regi\xf3n",
        searchMinChars: 'Introduce <b>al menos 3 caracteres</b> para ver los resultados.',
        searchNoResults: "<b>Sin resultados.</b> No encontramos el pa\xeds que buscas.",
        searchError: '<b>Se ha producido un error.</b> No se pudo cargar la lista de ofertas.'
    }
};

});

parcelRegister("7MPYI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d7d96e9810d0f02$export$2e2bcd8739ae039; });
var $5d7d96e9810d0f02$export$2e2bcd8739ae039 = {
    highcharts: {
        decimalPoint: ',',
        downloadJPEG: 'Pobierz obraz JPEG',
        downloadPDF: 'Pobierz dokument PDF',
        downloadPNG: 'Pobierz obraz PNG',
        downloadSVG: 'Pobierz obraz SVG',
        exportButtonTitle: 'Eksport',
        forexRate: "Kurs \u015Bredni FOREX",
        loading: "\u0141adowanie...",
        months: [
            "Stycze\u0144",
            'Luty',
            'Marzec',
            "Kwiecie\u0144",
            'Maj',
            'Czerwiec',
            'Lipiec',
            "Sierpie\u0144",
            "Wrzesie\u0144",
            "Pa\u017Adziernik",
            'Listopad',
            "Grudzie\u0144"
        ],
        printButtonTitle: 'Drukowanie',
        rangeSelectorFrom: 'Od',
        rangeSelectorTo: 'Do',
        rangeSelectorZoom: "Przybli\u017Cenie",
        rateTypes: {
            ask: "Najlepsza oferta sprzeda\u017Cy",
            bid: 'Najlepsza oferta kupna',
            forex: "\u015Aredni kurs na \u015Bwiecie"
        },
        resetZoom: 'Reset',
        resetZoomTitle: 'Reset',
        shortMonths: [
            'Sty',
            'Lut',
            'Mar',
            'Kwi',
            'Maj',
            'Cze',
            'Lip',
            'Sie',
            'Wrz',
            "Pa\u017A",
            'Lis',
            'Gru'
        ],
        thousandsSep: ' ',
        weekdays: [
            'Niedziela',
            "Poniedzia\u0142ek",
            'Wtorek',
            "\u015Aroda",
            'Czwartek',
            "Pi\u0105tek",
            'Sobota'
        ],
        wtBestAsk: "Najlepsza oferta sprzeda\u017Cy",
        wtBestBid: 'Najlepsza oferta kupna',
        seriesError: "Je t\u0159eba vybrat alespo\u0148 jednu mo\u017Enost"
    },
    calculator: {
        title: "V\xfdpo\u010Det \xfaspor v aplikaci Walutomat",
        forBuy: 'pro',
        unsupportedPair: "V sou\u010Dasn\xe9 dob\u011B nenab\xedz\xedme kurzy pro vybran\xfd m\u011Bnov\xfd p\xe1r.",
        spinnerError: {
            generic: "P\u0159i stahov\xe1n\xed dat do\u0161lo k probl\xe9mu",
            toManyRequests: 'Kalkul\xe1tor je moment\xe1ln\u011B nedostupn\xfd. Zkuste to pros\xedm pozd\u011Bji nebo se obra\u0165te na <a href="https://www.walutomat.com/cs/kontakt/">Z\xe1kaznick\xfd Servis</a>.'
        },
        commissionWT: 'Provize Walutomatu',
        ctaButton: "Sm\u011Bnit",
        amountText: "\u010C\xe1stka"
    },
    dashboard: {
        canEditPost: "Mo\u017Cesz edytowa\u0107 wpis",
        postExists: "Wpis o takim tytule ju\u017C istnieje",
        postNotExists: 'Wpis o takim tytule nie istnieje',
        emptyPostTitle: "Dodaj tytu\u0142 wpisu",
        error: "Co\u015B posz\u0142o nie tak :("
    },
    widgetCalculator: {
        title: "Zkontrolujte kurzy a{{nbsp}}sm\u011B\u0148te m\u011Bnu v{{nbsp}}Walutomat \u2013 rychle a{{nbsp}}v\xfdhodn\u011B.",
        actualRate: "Aktu\xe1ln\xed kurz",
        buySelect: 'Kupuji',
        sellSelect: "Prod\xe1v\xe1m",
        exchangeAmountSellLabel: "Z\xedsk\xe1te",
        exchangeAmountBuyLabel: "Vlo\u017Ete",
        commission: "Propaga\u010Dn\xed provize ({{commission}}%)"
    },
    formValidation: {
        emptyField: "Pole nem\u016F\u017Ee b\xfdt pr\xe1zdn\xe9",
        requiredField: "Pole je povinn\xe9",
        requireAllFields: "V\u0161echna pole mus\xed b\xfdt vypln\u011Bna",
        passwordToShort: "Heslo mus\xed m\xedt 8 znak\u016F",
        emailNotValid: "Pole mus\xed obsahovat platnou e-mailovou adresu",
        emailReserved: "E-mailov\xe1 adresa je ji\u017E obsazena",
        emailUnregistered: "Va\u0161i e-mailovou adresu jsme nena\u0161li v na\u0161\xed datab\xe1zi z\xe1kazn\xedk\u016F.",
        markField: "Vyberte alespo\u0148 jedno z pol\xed\u010Dek",
        serverUnknownError: 'Chyba komunikace se serverem',
        invalidCharacters: "Pole obsahuje neplatn\xe9 znaky",
        phoneNotValid: "Telefonn\xed \u010D\xedslo je nespr\xe1vn\xe9",
        checkBoxBelow: "Pro odesl\xe1n\xed zpr\xe1vy za\u0161krtn\u011Bte pol\xed\u010Dko n\xed\u017Ee",
        promocodeInvalid: "Neplatn\xfd propaga\u010Dn\xed k\xf3d",
        newsletterAlreadySubscribed: "Tento e-mail je ji\u017E p\u0159ihl\xe1\u0161en k odb\u011Bru newsletteru."
    },
    password: {
        show: 'zobrazit',
        hide: "skr\xfdt"
    },
    howItWorks: {
        showButton: "Zobrazit v\xedce",
        hideButton: "Zobrazit m\xe9n\u011B"
    },
    rateCalculator: {
        baseInputLabel: 'Mam',
        counterInputLabel: 'Otrzymam',
        counterInputTooltip: "Uwzgl\u0119dnia prowizj\u0119 {{commission}}%",
        ctaAlert: 'Ustaw alert'
    },
    esim: {
        searchPlaceholder: 'Vyhledejte zemi nebo region...',
        searchAriaLabel: 'Vyhledejte zemi nebo region',
        searchMinChars: "Zadejte <b>alespo\u0148 3 znaky</b> pro zobrazen\xed v\xfdsledk\u016F.",
        searchNoResults: "<b>\u017D\xe1dn\xe9 v\xfdsledky.</b> Hledan\xe1 zem\u011B nebyla nalezena.",
        searchError: "<b>Do\u0161lo k chyb\u011B.</b> Nepoda\u0159ilo se na\u010D\xedst seznam nab\xeddek."
    }
};

});

parcelRegister("4Unqs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $823d0efa3b012f37$export$2e2bcd8739ae039; });
var $823d0efa3b012f37$export$2e2bcd8739ae039 = {
    highcharts: {
        decimalPoint: ',',
        downloadJPEG: 'Pobierz obraz JPEG',
        downloadPDF: 'Pobierz dokument PDF',
        downloadPNG: 'Pobierz obraz PNG',
        downloadSVG: 'Pobierz obraz SVG',
        exportButtonTitle: 'Eksport',
        forexRate: "Kurs \u015Bredni FOREX",
        loading: "\u0141adowanie...",
        months: [
            "Stycze\u0144",
            'Luty',
            'Marzec',
            "Kwiecie\u0144",
            'Maj',
            'Czerwiec',
            'Lipiec',
            "Sierpie\u0144",
            "Wrzesie\u0144",
            "Pa\u017Adziernik",
            'Listopad',
            "Grudzie\u0144"
        ],
        printButtonTitle: 'Drukowanie',
        rangeSelectorFrom: 'Od',
        rangeSelectorTo: 'Do',
        rangeSelectorZoom: "Przybli\u017Cenie",
        rateTypes: {
            ask: "Najlepsza oferta sprzeda\u017Cy",
            bid: 'Najlepsza oferta kupna',
            forex: "\u015Aredni kurs na \u015Bwiecie"
        },
        resetZoom: 'Reset',
        resetZoomTitle: 'Reset',
        shortMonths: [
            'Sty',
            'Lut',
            'Mar',
            'Kwi',
            'Maj',
            'Cze',
            'Lip',
            'Sie',
            'Wrz',
            "Pa\u017A",
            'Lis',
            'Gru'
        ],
        thousandsSep: ' ',
        weekdays: [
            'Niedziela',
            "Poniedzia\u0142ek",
            'Wtorek',
            "\u015Aroda",
            'Czwartek',
            "Pi\u0105tek",
            'Sobota'
        ],
        wtBestAsk: "Najlepsza oferta sprzeda\u017Cy",
        wtBestBid: 'Najlepsza oferta kupna',
        seriesError: "Trebuie selectat\u0103 cel pu\u021Bin o op\u021Biune"
    },
    calculator: {
        title: "Calcula\u021Bi economiile \xeen Walutomat",
        forBuy: 'pentru',
        unsupportedPair: "\xcen prezent nu oferim rate pentru perechea valutar\u0103 selectat\u0103.",
        spinnerError: {
            generic: "A existat o problem\u0103 cu desc\u0103rcarea datelor",
            toManyRequests: 'Calculatorul nu este disponibil \xeen acest moment. \xcencearc\u0103 din nou mai t\xe2rziu sau contacteaz\u0103 <a href="https://www.walutomat.com/ro/contact/">Serviciul de asisten\u021B\u0103 pentru clien\u021Bi</a>.'
        },
        commissionWT: 'Comision Walutomat',
        ctaButton: "Schimb\u0103",
        amountText: 'Suma'
    },
    dashboard: {
        canEditPost: "Mo\u017Cesz edytowa\u0107 wpis",
        postExists: "Wpis o takim tytule ju\u017C istnieje",
        postNotExists: 'Wpis o takim tytule nie istnieje',
        emptyPostTitle: "Dodaj tytu\u0142 wpisu",
        error: "Co\u015B posz\u0142o nie tak :("
    },
    widgetCalculator: {
        title: "Verifica\u021Bi cursurile \u0219i{{nbsp}}schimba\u021Bi moneda \xeen{{nbsp}}Walutomat \u2013 rapid \u0219i{{nbsp}}avantajos.",
        actualRate: 'Curs actual',
        buySelect: "Cump\u0103r",
        sellSelect: "V\xe2nd",
        exchangeAmountSellLabel: "Ve\u021Bi primi",
        exchangeAmountBuyLabel: 'Depozit',
        commission: "Comision promo\u021Bional ({{commission}}%)"
    },
    formValidation: {
        emptyField: "C\xe2mpul nu poate fi gol",
        requiredField: "C\xe2mpul este obligatoriu",
        requireAllFields: "Toate c\xe2mpurile trebuie completate",
        passwordToShort: "Parola trebuie s\u0103 aib\u0103 8 caractere",
        emailNotValid: "C\xe2mpul trebuie s\u0103 con\u021Bin\u0103 o adres\u0103 de e-mail valid\u0103",
        emailReserved: "Adresa de e-mail este deja ocupat\u0103",
        emailUnregistered: "Nu am g\u0103sit adresa ta de e-mail \xeen baza noastr\u0103 de date a clien\u021Bilor.",
        markField: "\u041E\u0442\u043C\u0435\u0442\u044C\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0438\u0437 \u0444\u043B\u0430\u0436\u043A\u043E\u0432",
        serverUnknownError: 'Eroare de comunicare cu serverul',
        invalidCharacters: "C\xe2mpul con\u021Bine caractere invalide",
        phoneNotValid: "Num\u0103rul de telefon este incorect",
        checkBoxBelow: 'Please tick the box below to send a message',
        promocodeInvalid: "Cod promo\u021Bional nevalid",
        newsletterAlreadySubscribed: 'Acest e-mail este deja abonat la newsletter.'
    },
    password: {
        show: "arat\u0103",
        hide: 'ascunde'
    },
    howItWorks: {
        showButton: "Arat\u0103 mai mult",
        hideButton: "Arat\u0103 mai pu\u021Bin"
    },
    rateCalculator: {
        baseInputLabel: 'Mam',
        counterInputLabel: 'Otrzymam',
        counterInputTooltip: "Uwzgl\u0119dnia prowizj\u0119 {{commission}}%",
        ctaAlert: 'Ustaw alert'
    },
    esim: {
        searchPlaceholder: "C\u0103uta\u021Bi o \u021Bar\u0103 sau regiune...",
        searchAriaLabel: "C\u0103uta\u021Bi o \u021Bar\u0103 sau regiune",
        searchMinChars: "Introduce\u021Bi <b>cel pu\u021Bin 3 caractere</b> pentru a afi\u0219a rezultatele.",
        searchNoResults: "<b>Niciun rezultat.</b> \u021Aara c\u0103utat\u0103 nu a fost g\u0103sit\u0103.",
        searchError: "<b>A ap\u0103rut o eroare.</b> Lista de oferte nu a putut fi \xeenc\u0103rcat\u0103."
    }
};

});

parcelRegister("5MaYc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42cd97d0342d8170$export$2e2bcd8739ae039; });
var $42cd97d0342d8170$export$2e2bcd8739ae039 = {
    highcharts: {
        decimalPoint: ',',
        downloadJPEG: 'Pobierz obraz JPEG',
        downloadPDF: 'Pobierz dokument PDF',
        downloadPNG: 'Pobierz obraz PNG',
        downloadSVG: 'Pobierz obraz SVG',
        exportButtonTitle: 'Eksport',
        forexRate: "Kurs \u015Bredni FOREX",
        loading: "\u0141adowanie...",
        months: [
            "Stycze\u0144",
            'Luty',
            'Marzec',
            "Kwiecie\u0144",
            'Maj',
            'Czerwiec',
            'Lipiec',
            "Sierpie\u0144",
            "Wrzesie\u0144",
            "Pa\u017Adziernik",
            'Listopad',
            "Grudzie\u0144"
        ],
        printButtonTitle: 'Drukowanie',
        rangeSelectorFrom: 'Od',
        rangeSelectorTo: 'Do',
        rangeSelectorZoom: "Przybli\u017Cenie",
        rateTypes: {
            ask: "Najlepsza oferta sprzeda\u017Cy",
            bid: 'Najlepsza oferta kupna',
            forex: "\u015Aredni kurs na \u015Bwiecie"
        },
        resetZoom: 'Reset',
        resetZoomTitle: 'Reset',
        shortMonths: [
            'Sty',
            'Lut',
            'Mar',
            'Kwi',
            'Maj',
            'Cze',
            'Lip',
            'Sie',
            'Wrz',
            "Pa\u017A",
            'Lis',
            'Gru'
        ],
        thousandsSep: ' ',
        weekdays: [
            'Niedziela',
            "Poniedzia\u0142ek",
            'Wtorek',
            "\u015Aroda",
            'Czwartek',
            "Pi\u0105tek",
            'Sobota'
        ],
        wtBestAsk: "Najlepsza oferta sprzeda\u017Cy",
        wtBestBid: 'Najlepsza oferta kupna',
        seriesError: "Vous devez s\xe9lectionner au moins une option"
    },
    calculator: {
        title: "Calculer l'\xe9pargne en Walutomat",
        forBuy: 'pour',
        unsupportedPair: "Nous n'offrons pas actuellement de taux pour la paire de devises s\xe9lectionn\xe9e.",
        spinnerError: {
            generic: "Il y a eu un probl\xe8me avec le t\xe9l\xe9chargement des donn\xe9es",
            toManyRequests: 'Le calculateur est actuellement indisponible. Veuillez r\xe9essayer plus tard ou contacter le <a href="https://www.walutomat.com/fr/contact/">Service Client</a>.'
        },
        commissionWT: 'Commission Walutomat',
        ctaButton: "\xc9changer",
        amountText: 'Montant'
    },
    dashboard: {
        canEditPost: "Mo\u017Cesz edytowa\u0107 wpis",
        postExists: "Wpis o takim tytule ju\u017C istnieje",
        postNotExists: 'Wpis o takim tytule nie istnieje',
        emptyPostTitle: "Dodaj tytu\u0142 wpisu",
        error: "Co\u015B posz\u0142o nie tak :("
    },
    widgetCalculator: {
        title: "V\xe9rifiez les taux et changez vos devises dans Walutomat \u2013 rapidement et \xe0 des conditions avantageuses.",
        actualRate: 'Taux actuel',
        buySelect: "Valeur de l'\xe9change",
        sellSelect: 'Je vends',
        exchangeAmountSellLabel: 'Vous recevrez',
        exchangeAmountBuyLabel: 'Acompte',
        commission: 'Commission promotionnelle ({{commission}}%)'
    },
    formValidation: {
        emptyField: "Le champ ne peut pas \xeatre vide",
        requiredField: 'Le champ est obligatoire',
        requireAllFields: "Tous les champs doivent \xeatre remplis",
        passwordToShort: "Le mot de passe doit comporter 8 caract\xe8res",
        emailNotValid: "Le champ doit contenir une adresse \xe9lectronique valide",
        emailReserved: "L'adresse \xe9lectronique est d\xe9j\xe0 prise",
        emailUnregistered: "Nous n'avons pas trouv\xe9 votre adresse e-mail dans notre base de donn\xe9es clients.",
        markField: 'Cochez au moins une des cases',
        serverUnknownError: 'Erreur de communication avec le serveur',
        invalidCharacters: "Le champ contient des caract\xe8res non valides",
        phoneNotValid: "Le num\xe9ro de t\xe9l\xe9phone est incorrect",
        checkBoxBelow: 'Veuillez cocher la case ci-dessous pour envoyer un message',
        promocodeInvalid: 'Code promotionnel invalide',
        newsletterAlreadySubscribed: "Cet e-mail est d\xe9j\xe0 abonn\xe9 \xe0 la newsletter."
    },
    password: {
        show: 'afficher',
        hide: 'cacher'
    },
    howItWorks: {
        showButton: 'Afficher plus',
        hideButton: 'Afficher moins'
    },
    rateCalculator: {
        baseInputLabel: 'Mam',
        counterInputLabel: 'Otrzymam',
        counterInputTooltip: "Uwzgl\u0119dnia prowizj\u0119 {{commission}}%",
        ctaAlert: 'Ustaw alert'
    },
    esim: {
        searchPlaceholder: "Rechercher un pays ou une r\xe9gion...",
        searchAriaLabel: "Rechercher un pays ou une r\xe9gion",
        searchMinChars: "Saisissez <b>au moins 3 caract\xe8res</b> pour afficher les r\xe9sultats.",
        searchNoResults: "<b>Aucun r\xe9sultat.</b> Le pays recherch\xe9 est introuvable.",
        searchError: '<b>Une erreur est survenue.</b> Impossible de charger la liste des offres.'
    }
};

});

parcelRegister("3sWA4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d950347f0edbaebe$export$2e2bcd8739ae039; });
var $d950347f0edbaebe$export$2e2bcd8739ae039 = {
    highcharts: {
        decimalPoint: ',',
        downloadJPEG: 'Pobierz obraz JPEG',
        downloadPDF: 'Pobierz dokument PDF',
        downloadPNG: 'Pobierz obraz PNG',
        downloadSVG: 'Pobierz obraz SVG',
        exportButtonTitle: 'Eksport',
        forexRate: "Kurs \u015Bredni FOREX",
        loading: "\u0141adowanie...",
        months: [
            "Stycze\u0144",
            'Luty',
            'Marzec',
            "Kwiecie\u0144",
            'Maj',
            'Czerwiec',
            'Lipiec',
            "Sierpie\u0144",
            "Wrzesie\u0144",
            "Pa\u017Adziernik",
            'Listopad',
            "Grudzie\u0144"
        ],
        printButtonTitle: 'Drukowanie',
        rangeSelectorFrom: 'Od',
        rangeSelectorTo: 'Do',
        rangeSelectorZoom: "Przybli\u017Cenie",
        rateTypes: {
            ask: "Najlepsza oferta sprzeda\u017Cy",
            bid: 'Najlepsza oferta kupna',
            forex: "\u015Aredni kurs na \u015Bwiecie"
        },
        resetZoom: 'Reset',
        resetZoomTitle: 'Reset',
        shortMonths: [
            'Sty',
            'Lut',
            'Mar',
            'Kwi',
            'Maj',
            'Cze',
            'Lip',
            'Sie',
            'Wrz',
            "Pa\u017A",
            'Lis',
            'Gru'
        ],
        thousandsSep: ' ',
        weekdays: [
            'Niedziela',
            "Poniedzia\u0142ek",
            'Wtorek',
            "\u015Aroda",
            'Czwartek',
            "Pi\u0105tek",
            'Sobota'
        ],
        wtBestAsk: "Najlepsza oferta sprzeda\u017Cy",
        wtBestBid: 'Najlepsza oferta kupna',
        seriesError: "\xc8 necessario selezionare almeno un'opzione"
    },
    calculator: {
        title: 'Calcolo del risparmio in Walutomat',
        forBuy: 'per',
        unsupportedPair: 'Al momento non offriamo tassi per la coppia di valute selezionata.',
        spinnerError: {
            generic: "Si \xe8 verificato un problema nel download dei dati",
            toManyRequests: 'Il calcolatore non \xe8 attualmente disponibile. Riprova pi\xf9 tardi oppure contatta il <a href="https://www.walutomat.com/it/contatto/">Servizio Clienti</a>.'
        },
        commissionWT: 'Commissione Walutomat',
        ctaButton: 'Cambia',
        amountText: 'Importo'
    },
    dashboard: {
        canEditPost: "Mo\u017Cesz edytowa\u0107 wpis",
        postExists: "Wpis o takim tytule ju\u017C istnieje",
        postNotExists: 'Wpis o takim tytule nie istnieje',
        emptyPostTitle: "Dodaj tytu\u0142 wpisu",
        error: "Co\u015B posz\u0142o nie tak :("
    },
    widgetCalculator: {
        title: "Controlla i tassi di cambio e{{nbsp}}converti la valuta in{{nbsp}}Walutomat \u2013 in modo rapido e{{nbsp}}vantaggioso.",
        actualRate: 'Tasso di cambio attuale',
        buySelect: 'Compro',
        sellSelect: 'Vendo',
        exchangeAmountSellLabel: 'Riceverai',
        exchangeAmountBuyLabel: 'Deposito',
        commission: 'Commissione promozionale ({{commission}}%)'
    },
    formValidation: {
        emptyField: "Il campo non pu\xf2 essere vuoto",
        requiredField: "Il campo \xe8 obbligatorio",
        requireAllFields: 'Tutti i campi devono essere compilati',
        passwordToShort: 'La password deve essere di 8 caratteri',
        emailNotValid: 'Il campo deve contenere un indirizzo e-mail valido',
        emailReserved: "L'indirizzo e-mail \xe8 gi\xe0 occupato",
        emailUnregistered: 'Non abbiamo trovato il tuo indirizzo e-mail nel nostro database clienti.',
        markField: 'Seleziona almeno una delle caselle di controllo',
        serverUnknownError: 'Errore di comunicazione del server',
        invalidCharacters: 'Il campo contiene caratteri non validi',
        phoneNotValid: "Il numero di telefono non \xe8 corretto",
        checkBoxBelow: 'Selezionare la casella sottostante per inviare un messaggio',
        promocodeInvalid: 'Codice promozionale non valido',
        newsletterAlreadySubscribed: "Questa email \xe8 gi\xe0 iscritta alla newsletter."
    },
    password: {
        show: 'mostrare',
        hide: 'nascondere'
    },
    howItWorks: {
        showButton: "Mostra di pi\xf9",
        hideButton: 'Mostra meno'
    },
    rateCalculator: {
        baseInputLabel: 'Mam',
        counterInputLabel: 'Otrzymam',
        counterInputTooltip: "Uwzgl\u0119dnia prowizj\u0119 {{commission}}%",
        ctaAlert: 'Ustaw alert'
    },
    esim: {
        searchPlaceholder: 'Cerca un paese o una regione...',
        searchAriaLabel: 'Cerca un paese o una regione',
        searchMinChars: 'Inserisci <b>almeno 3 caratteri</b> per visualizzare i risultati.',
        searchNoResults: "<b>Nessun risultato.</b> Il paese cercato non \xe8 stato trovato.",
        searchError: "<b>Si \xe8 verificato un errore.</b> Impossibile caricare l'elenco delle offerte."
    }
};

});


parcelRegister("i928P", function(module, exports) {

$parcel$export(module.exports, "pushDataLayer", function () { return $9098f0eb9e4bc73b$export$d63e23ced30638e5; });
function $9098f0eb9e4bc73b$export$d63e23ced30638e5(eventName, eventParams) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ...eventParams
    });
}

});

parcelRegister("aFzjB", function(module, exports) {

$parcel$export(module.exports, "isApiError", function () { return $fb50b6ce5c7e79b5$export$89d83cc97c52a37; });
$parcel$export(module.exports, "getApiErrorMessage", function () { return $fb50b6ce5c7e79b5$export$a2114c7aee4dc34c; });
$parcel$export(module.exports, "getGenericErrorMessage", function () { return $fb50b6ce5c7e79b5$export$ea8de7e9c0d10316; });

var $daEfo = parcelRequire("daEfo");
const $fb50b6ce5c7e79b5$export$89d83cc97c52a37 = (error)=>{
    // 1. Check if 'error' is a non-null object.
    if (typeof error !== 'object' || error === null) return false;
    // 2. Check if 'error' has a 'response' property.
    if (!('response' in error)) return false;
    // 3. Check if 'response' is a non-null object.
    const response = error.response;
    if (typeof response !== 'object' || response === null) return false;
    // 4. Check if 'response' has 'status' (being a number) and 'data' properties.
    if (!('status' in response) || typeof response.status !== 'number' || !('data' in response)) return false;
    // 5. Check the type of the 'data' property.
    const data = response.data;
    // 5a. If 'data' is a string, it's a valid ApiError.
    if (typeof data === 'string') return true;
    // 5b. If 'data' is an object, check if it has an 'error' property which is a string.
    if (typeof data === 'object' && data !== null && 'error' in data && typeof data.error === 'string') return true;
    // If 'data' is neither a string nor a valid error object, it's not a match.
    return false;
};
const $fb50b6ce5c7e79b5$export$a2114c7aee4dc34c = (error)=>{
    const { data: data } = error.response;
    const defaultMessage = (0, $daEfo.t9n)('formValidation.serverUnknownError');
    if (typeof data === 'string') return data.length > 0 ? data : defaultMessage;
    // If 'data' is an object, the 'error' property is guaranteed by the type guard.
    if (data.error && data.error.length > 0) return data.error;
    return defaultMessage;
};
const $fb50b6ce5c7e79b5$export$ea8de7e9c0d10316 = (error)=>{
    const defaultMessage = (0, $daEfo.t9n)('formValidation.serverUnknownError');
    if (error instanceof Error) return error.message;
    if (typeof error === 'string' && error.length > 0) return error;
    if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') return error.message;
    return defaultMessage;
};

});

parcelRegister("ep8H5", function(module, exports) {

$parcel$export(module.exports, "registerUser", function () { return $bca9bbb8b7867d76$export$16015adca85344a; });

var $k0eal = parcelRequire("k0eal");
const $bca9bbb8b7867d76$export$16015adca85344a = (payload, domainType = 'user')=>{
    return (0, $k0eal.promiseWrapper)(`${domainType === 'user' ? USER_BASE_URL_WT : BIZ_BASE_URL_WT}/api/public/registration`, 'POST', payload, {
        withCredentials: true
    });
};

});

parcelRegister("3Rj1s", function(module, exports) {

$parcel$export(module.exports, "getElementsForm", function () { return $25b426a9b610530a$export$4fd0a65ecf0aa203; });
$parcel$export(module.exports, "collectDataToSend", function () { return $25b426a9b610530a$export$61fdef77cc59e4f; });
$parcel$export(module.exports, "initForm", function () { return $25b426a9b610530a$export$653023c4fd90fd41; });

var $3cM09 = parcelRequire("3cM09");

var $daEfo = parcelRequire("daEfo");

var $aFzjB = parcelRequire("aFzjB");

var $knCXs = parcelRequire("knCXs");

var $858k1 = parcelRequire("858k1");

var $lljZm = parcelRequire("lljZm");

var $3owir = parcelRequire("3owir");

var $kmZg7 = parcelRequire("kmZg7");
const $25b426a9b610530a$export$4fd0a65ecf0aa203 = ()=>{
    const $formContainerParent = document.querySelector('[data-collect-form]');
    if (!$formContainerParent) {
        console.warn('Form container not found');
        return null;
    }
    const formElements = {
        $formContainerParent: $formContainerParent,
        $emailField: $formContainerParent.querySelector('[data-email-field]'),
        $errorEmailField: $formContainerParent.querySelector('[data-error-field]'),
        $inputElementHolder: $formContainerParent.querySelector('[data-input-holder]'),
        $endView: $formContainerParent.querySelector('[data-end-view]'),
        $sendError: $formContainerParent.querySelector('[data-error-server]'),
        $eventInputElement: $formContainerParent.querySelector('[data-competition]'),
        $answerTextareaField: $formContainerParent.querySelector('[data-answer]'),
        $errorAnswerField: $formContainerParent.querySelector('[data-error-field-answer]'),
        $checkboxElement: $formContainerParent.querySelector('[data-checkbox-field="terms"]'),
        $submitFormBtn: $formContainerParent.querySelector('[data-submit-form]'),
        $newsletterRodo: $formContainerParent.querySelector('[data-newsletter-rodo]'),
        $promotionCheckbox: $formContainerParent.querySelector('[data-checkbox-field="promotion"]'),
        $modal: document.querySelector('[data-modal]')
    };
    return formElements;
};
const $25b426a9b610530a$export$9643fd7297feaaf5 = (formElements, termsCheckboxSelector)=>{
    return {
        email: (0, $3owir.getStringField)('[data-email-field]', (0, $3owir.emailValidator), formElements.$formContainerParent),
        event: formElements.$eventInputElement.value || undefined,
        answer: (0, $3owir.getStringField)('[data-answer]', $25b426a9b610530a$var$stringValidator, formElements.$formContainerParent) || '',
        date: new Date().toISOString(),
        terms_and_conditions_accepted: (0, $3owir.getBooleanField)(termsCheckboxSelector, (0, $3owir.consentValidator), formElements.$formContainerParent)
    };
};
// Validator for rate inputs field
const $25b426a9b610530a$var$rateValidator = (value, selector, formContainer = document)=>{
    const isValid = [
        !value ? (0, $daEfo.t9n)('formValidation.requireAllFields') : ''
    ];
    return (0, $3owir.checkValidity)(isValid, selector, formContainer) ? value : null;
};
const $25b426a9b610530a$var$getRate = (selector, validator, formContainer = document)=>{
    const $inputs = formContainer.querySelectorAll(selector);
    const $numbers = [];
    let isComplete = $inputs.length > 0;
    $inputs.forEach(($input, key)=>{
        const value = String($input.value).trim();
        if (!validator(value, selector, formContainer)) isComplete = false;
        $numbers.push(key === 0 ? `${value},` : value);
    });
    return isComplete ? $numbers.join('') : null;
};
const $25b426a9b610530a$var$prepareAnswer = (formElements)=>{
    const rate = $25b426a9b610530a$var$getRate('[data-rate]', $25b426a9b610530a$var$rateValidator, formElements.$formContainerParent);
    formElements.$answerTextareaField.value = rate ?? '';
    return !!rate;
};
const $25b426a9b610530a$var$handleRatesInput = (selector, formContainer = document)=>{
    const $rates = formContainer.querySelectorAll(selector);
    $rates.forEach(($rate, key)=>{
        $rate.addEventListener('input', ()=>{
            $rate.value = $rate.value.replace(/[^0-9]/g, '');
            if (key + 1 < $rates.length && $rate.value) $rates[key + 1].focus();
            if (key - 1 >= 0 && $rate.value === '') $rates[key - 1].focus();
        });
    });
};
const $25b426a9b610530a$var$stringValidator = (value, selector, formContainer = document)=>{
    const isValid = [
        !(0, $3cM09.isNotEmptyTrimmedStringValidator)(value) ? (0, $daEfo.t9n)('formValidation.emptyField') : ''
    ];
    return (0, $3owir.checkValidity)(isValid, selector, formContainer) ? value : null;
};
const $25b426a9b610530a$var$validateCheckbox = (checkbox, selector, formContainer, isRequired = true)=>{
    if (!checkbox) return !isRequired;
    if (!isRequired) return true;
    return (0, $3owir.consentValidator)(checkbox.checked, selector, formContainer);
};
const $25b426a9b610530a$export$f76e67583c33bb9a = (payload)=>{
    const REQUIRED_FIELDS = [
        'email',
        'event',
        'answer',
        'terms_and_conditions_accepted'
    ];
    const requiredFieldsValid = REQUIRED_FIELDS.every((field)=>{
        const value = payload[field];
        if (value == null) return false;
        switch(field){
            case 'email':
            case 'event':
                return typeof value === 'string' && value.trim() !== '';
            case 'answer':
                return typeof value === 'string' // answer can be empty string
                ;
            case 'terms_and_conditions_accepted':
                return value === true;
            default:
                return true // For any other fields, just check for non-null/undefined
                ;
        }
    });
    return requiredFieldsValid;
};
const $25b426a9b610530a$var$isFormLocallyValid = (payload, formElements, isNewsletterConsentRequired)=>{
    const isPayloadComplete = $25b426a9b610530a$export$f76e67583c33bb9a(payload);
    const isNewsletterConsentValid = $25b426a9b610530a$var$validateCheckbox(formElements.$newsletterRodo, '[data-newsletter-rodo]', formElements.$formContainerParent, isNewsletterConsentRequired);
    const isPromotionConsentValid = $25b426a9b610530a$var$validateCheckbox(formElements.$promotionCheckbox, '[data-checkbox-field="promotion"]', formElements.$formContainerParent, false);
    if (!isPayloadComplete || !isNewsletterConsentValid || !isPromotionConsentValid) {
        console.warn('Payload is not complete or newsletter consent is missing');
        return false;
    }
    return true;
};
const $25b426a9b610530a$var$checkEmailExistence = async (email, formElements)=>{
    try {
        const emailResponse = await (0, $lljZm.checkEmailAvailability)({
            email: email
        });
        if ('available' in emailResponse) return !emailResponse.available;
        console.error('Email check returned non-200 status:', emailResponse.response.status);
        (0, $3owir.setErrorMSG)('[data-error-server]', (0, $daEfo.t9n)('formValidation.serverUnknownError'), formElements.$formContainerParent);
        return null;
    } catch (error) {
        if ((0, $aFzjB.isApiError)(error)) {
            const errorMessage = (0, $aFzjB.getApiErrorMessage)(error);
            console.error('API error during email existence check:', errorMessage);
            (0, $3owir.setErrorMSG)('[data-error-server]', (0, $daEfo.t9n)('formValidation.serverUnknownError'), formElements.$formContainerParent);
        } else {
            const genericErrorMessage = (0, $aFzjB.getGenericErrorMessage)(error);
            console.error('Unknown error during email existence check:', genericErrorMessage);
            (0, $3owir.setErrorMSG)('[data-error-server]', (0, $daEfo.t9n)('formValidation.serverUnknownError'), formElements.$formContainerParent);
        }
        return null;
    }
};
const $25b426a9b610530a$var$handleSubmissionSuccess = (formElements)=>{
    if (formElements.$modal) formElements.$modal.showModal();
    else {
        formElements.$inputElementHolder.hidden = true;
        formElements.$endView.hidden = false;
    }
    $25b426a9b610530a$var$clearForm(formElements.$formContainerParent);
};
const $25b426a9b610530a$export$61fdef77cc59e4f = async (formElements, isRate = false, isNewsletterConsentRequired = false, termsCheckboxSelector = '[data-checkbox-field="terms"]', requireRegisteredEmail = true)=>{
    (0, $3owir.resetAllErrorMSG)(formElements.$formContainerParent);
    const isRateComplete = !isRate || $25b426a9b610530a$var$prepareAnswer(formElements);
    const payload = $25b426a9b610530a$export$9643fd7297feaaf5(formElements, termsCheckboxSelector);
    if (!$25b426a9b610530a$var$isFormLocallyValid(payload, formElements, isNewsletterConsentRequired) || !isRateComplete) return;
    if (requireRegisteredEmail) {
        const emailExists = await $25b426a9b610530a$var$checkEmailExistence(payload.email, formElements);
        if (emailExists === null) return;
        if (!emailExists) {
            console.error('Email does not exist in the database.');
            (0, $3owir.setInputErrorMSG)('[data-email-field]', (0, $daEfo.t9n)('formValidation.emailUnregistered'), formElements.$formContainerParent);
            return;
        }
    }
    if (formElements.$newsletterRodo?.checked) try {
        const newsletterResponse = await (0, $kmZg7.handleNewsletterSubscription)(formElements);
        if (!newsletterResponse) console.error('Newsletter subscription failed (falsy response).');
    } catch (err) {
        console.error('Newsletter subscription threw an error:', err);
    }
    try {
        await (0, $858k1.default)(payload);
        $25b426a9b610530a$var$handleSubmissionSuccess(formElements);
    } catch (error) {
        if ((0, $aFzjB.isApiError)(error)) {
            const errorMessage = (0, $aFzjB.getApiErrorMessage)(error);
            console.error('API error during competition subscription:', errorMessage);
            (0, $3owir.setErrorMSG)('[data-error-server]', errorMessage, formElements.$formContainerParent);
        } else {
            const genericErrorMessage = (0, $aFzjB.getGenericErrorMessage)(error);
            console.error('Unknown error during competition subscription:', genericErrorMessage);
            (0, $3owir.setErrorMSG)('[data-error-server]', genericErrorMessage, formElements.$formContainerParent);
        }
    }
};
const $25b426a9b610530a$var$clearForm = (formContainer = document)=>{
    const inputs = formContainer.querySelectorAll('input:not([data-competition])');
    const textareas = formContainer.querySelectorAll('textarea');
    inputs.forEach((input)=>{
        input.type !== 'checkbox' ? input.value = '' : input.checked = false;
    });
    textareas.forEach((textarea)=>{
        textarea.value = '';
    });
};
const $25b426a9b610530a$export$653023c4fd90fd41 = (options = {})=>{
    const { isNewsletterConsentRequired: isNewsletterConsentRequired = false, termsCheckboxSelector: termsCheckboxSelector = '[data-checkbox-field="terms"]', requireRegisteredEmail: requireRegisteredEmail = true } = options;
    const formElements = $25b426a9b610530a$export$4fd0a65ecf0aa203();
    if (!formElements) {
        console.error('Form elements could not be initialized.');
        return;
    }
    const isRate = !!formElements.$formContainerParent.querySelector('[data-rate]');
    formElements.$submitFormBtn?.addEventListener('click', ()=>$25b426a9b610530a$export$61fdef77cc59e4f(formElements, isRate, isNewsletterConsentRequired, termsCheckboxSelector, requireRegisteredEmail));
    if (isRate) $25b426a9b610530a$var$handleRatesInput('[data-rate]', formElements.$formContainerParent);
    if (formElements.$modal) (0, $knCXs.modalHandle)(formElements.$modal);
};

});
parcelRegister("858k1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a115c2b963f0bd81$export$2e2bcd8739ae039; });

var $k0eal = parcelRequire("k0eal");
const $a115c2b963f0bd81$var$competitionSubscribe = (payload)=>{
    return (0, $k0eal.promiseWrapper)(`${USER_BASE_URL_WT}/api/public/cmsEmailSubscribe`, 'POST', payload);
};
var $a115c2b963f0bd81$export$2e2bcd8739ae039 = $a115c2b963f0bd81$var$competitionSubscribe;

});

parcelRegister("lljZm", function(module, exports) {

$parcel$export(module.exports, "checkEmailAvailability", function () { return $20e0660e5c25600c$export$91c06f3217089138; });

var $k0eal = parcelRequire("k0eal");
const $20e0660e5c25600c$export$91c06f3217089138 = (payload, domainType = 'user')=>{
    const email = payload.email.trim().toLowerCase();
    return (0, $k0eal.promiseWrapper)(`${domainType === 'user' ? USER_BASE_URL_WT : BIZ_BASE_URL_WT}/api/public/emailAvailable/${email}`, 'GET');
};

});

parcelRegister("kmZg7", function(module, exports) {

$parcel$export(module.exports, "handleNewsletterSubscription", function () { return $3b5d7797679d204e$export$37769ed8a823bdb4; });

var $daEfo = parcelRequire("daEfo");

var $i928P = parcelRequire("i928P");

var $gGTPu = parcelRequire("gGTPu");

var $3owir = parcelRequire("3owir");
const $3b5d7797679d204e$var$handleApiError = (error, formElements)=>{
    const { data: data } = error.response;
    switch(data){
        case 'ALREADY_SUBSCRIBED':
            (0, $3owir.setInputErrorMSG)('[data-newsletter-rodo]', (0, $daEfo.t9n)('formValidation.newsletterAlreadySubscribed'), formElements.$formContainerParent);
            break;
        case 'INVALID_EMAIL':
            (0, $3owir.setInputErrorMSG)('[data-email-field]', (0, $daEfo.t9n)('formValidation.emailNotValid'), formElements.$formContainerParent);
            break;
        case 'INVALID_LIST':
            (0, $3owir.setErrorMSG)('[data-error-server]', (0, $daEfo.t9n)('formValidation.serverUnknownError'), formElements.$formContainerParent);
            console.error('Invalid list', error);
            break;
        default:
            (0, $3owir.setErrorMSG)('[data-error-server]', (0, $daEfo.t9n)('formValidation.serverUnknownError'), formElements.$formContainerParent);
            console.error('Unexpected error:', error);
            break;
    }
};
const $3b5d7797679d204e$export$37769ed8a823bdb4 = async (formElements, consentType = 'default')=>{
    const { $emailField: $emailField, $formContainerParent: $formContainerParent } = formElements;
    const email = $emailField?.value ?? '';
    const rodoElement = $formContainerParent.querySelector('[data-newsletter-rodo]');
    if (!email || !rodoElement || !$formContainerParent) throw new Error('Form validation failed or required fields are missing.');
    const datasetConsent = rodoElement.dataset.newsletterConsent;
    if (datasetConsent) consentType = datasetConsent;
    try {
        const response = consentType === 'currencyComments' ? await (0, $gGTPu.signUpForCurrencyCommentsNewsletter)({
            email: email
        }) : await (0, $gGTPu.signUpForNewsletter)({
            email: email
        });
        (0, $i928P.pushDataLayer)('form_submitted', {
            form_name: 'Zapis do Newslettera'
        });
        return response;
    } catch (error) {
        console.error('Error during newsletter subscription:', error);
        $3b5d7797679d204e$var$handleApiError(error, formElements);
        throw error;
    }
};

});
parcelRegister("gGTPu", function(module, exports) {

$parcel$export(module.exports, "signUpForNewsletter", function () { return $04c769fa72e13978$export$115ec547bc33484; });
$parcel$export(module.exports, "signUpForCurrencyCommentsNewsletter", function () { return $04c769fa72e13978$export$6ef183758649a5f9; });

var $k0eal = parcelRequire("k0eal");

var $7lF7b = parcelRequire("7lF7b");
const $04c769fa72e13978$var$NEWSLETTER_SUBSCRIBE_ENDPOINT = '/api/public/subscribe-to-newsletter';
const $04c769fa72e13978$export$115ec547bc33484 = (payload)=>{
    payload['list'] = (0, $7lF7b.newsletterTokenList).default;
    return (0, $k0eal.promiseWrapper)(`${USER_BASE_URL_WT}${$04c769fa72e13978$var$NEWSLETTER_SUBSCRIBE_ENDPOINT}`, 'POST', payload);
};
const $04c769fa72e13978$export$93ed85d772443d7 = (payload, opinionsConsent)=>{
    payload['list'] = opinionsConsent ? (0, $7lF7b.newsletterTokenList).cardTestsWithOpinions : (0, $7lF7b.newsletterTokenList).cardTestsWithoutOpinions;
    return (0, $k0eal.promiseWrapper)(`${USER_BASE_URL_WT}${$04c769fa72e13978$var$NEWSLETTER_SUBSCRIBE_ENDPOINT}`, 'POST', payload);
};
const $04c769fa72e13978$export$6ef183758649a5f9 = (payload)=>{
    payload['list'] = (0, $7lF7b.newsletterTokenList).currencyComments;
    return (0, $k0eal.promiseWrapper)(`${USER_BASE_URL_WT}${$04c769fa72e13978$var$NEWSLETTER_SUBSCRIBE_ENDPOINT}`, 'POST', payload);
};

});
parcelRegister("7lF7b", function(module, exports) {

$parcel$export(module.exports, "newsletterTokenList", function () { return $a1a23427d9cdc164$export$2a509c948cb4da52; });
const $a1a23427d9cdc164$export$2a509c948cb4da52 = {
    default: '5',
    currencyComments: 'E',
    forTests: '4',
    cardTestsWithOpinions: 'P',
    cardTestsWithoutOpinions: 'Z'
};

});





parcelRegister("1IA9E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd34050ffdd5b0d5$export$2e2bcd8739ae039; });

var $g1MHW = parcelRequire("g1MHW");

var $k708F = parcelRequire("k708F");

var $736Jt = parcelRequire("736Jt");

var $eHZGN = parcelRequire("eHZGN");

var $i928P = parcelRequire("i928P");

var $3owir = parcelRequire("3owir");
const $bd34050ffdd5b0d5$var$EXIT_POPUP_SESSION_KEY = 'wt_exitpopup_shown';
// Same form name as the `form_submitted` event of the landing registration form, so the funnel can be joined.
const $bd34050ffdd5b0d5$var$EXIT_POPUP_FORM_NAME = 'Rejstracja z landingu';
const $bd34050ffdd5b0d5$var$MOUSE_LEAVE_DELAY = 10000;
const $bd34050ffdd5b0d5$var$DESKTOP_BREAKPOINT_NAME = 'big';
const $bd34050ffdd5b0d5$var$FORM_FIELD_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
const $bd34050ffdd5b0d5$var$isNotShownInSession = ()=>(0, $eHZGN.sessionStorageService).getItem($bd34050ffdd5b0d5$var$EXIT_POPUP_SESSION_KEY) !== 'true';
const $bd34050ffdd5b0d5$var$createIsFormUntouched = ()=>{
    const controller = new AbortController();
    let hasInteracted = false;
    const handleInteraction = (event)=>{
        const { target: target } = event;
        if (target instanceof HTMLElement && $bd34050ffdd5b0d5$var$FORM_FIELD_TAGS.includes(target.tagName)) {
            hasInteracted = true;
            controller.abort();
        }
    };
    document.addEventListener('focusin', handleInteraction, {
        signal: controller.signal
    });
    document.addEventListener('change', handleInteraction, {
        signal: controller.signal
    });
    return ()=>!hasInteracted;
};
/**
 * ALL of these must be met for an automatic trigger to open the popup.
 * Add, remove or comment out a line to change when the popup may appear.
 * (Clicking `[data-open-exit-popup]` ignores them.)
 */ const $bd34050ffdd5b0d5$var$createDisplayConditions = ()=>[
        $bd34050ffdd5b0d5$var$isNotShownInSession,
        $bd34050ffdd5b0d5$var$createIsFormUntouched()
    ];
/** Main page form (`[data-main-form]`) has been seen and then scrolled out of the viewport upwards. */ const $bd34050ffdd5b0d5$var$watchMainFormScrolledPast = (onTrigger, signal)=>{
    const $mainForm = document.querySelector('[data-main-form]');
    if ($mainForm) (0, $736Jt.watchElementScrolledPast)($mainForm, onTrigger, signal);
};
/** Cursor leaves the window (only after `MOUSE_LEAVE_DELAY`). */ const $bd34050ffdd5b0d5$var$watchMouseLeave = (onTrigger, signal)=>{
    const timeoutId = window.setTimeout(()=>{
        document.body.addEventListener('mouseleave', onTrigger, {
            once: true,
            signal: signal
        });
    }, $bd34050ffdd5b0d5$var$MOUSE_LEAVE_DELAY);
    signal.addEventListener('abort', ()=>clearTimeout(timeoutId));
};
/**
 * ANY of these may open the popup (if all display conditions are met).
 * Add, remove or comment out a line to change what opens the popup.
 */ const $bd34050ffdd5b0d5$var$AUTOMATIC_TRIGGERS = [
    $bd34050ffdd5b0d5$var$watchMainFormScrolledPast,
    $bd34050ffdd5b0d5$var$watchMouseLeave
];
const $bd34050ffdd5b0d5$var$findPopupElements = ()=>{
    const $popup = document.querySelector('[data-exit-popup]');
    const $closeButton = document.querySelector('[data-close-exit-popup]');
    const $openButtons = document.querySelectorAll('[data-open-exit-popup]');
    if (!$popup || !$closeButton) {
        console.warn('ExitPopup: Could not find the popup element or the close button.');
        return null;
    }
    return {
        $popup: $popup,
        $closeButton: $closeButton,
        $openButtons: $openButtons
    };
};
const $bd34050ffdd5b0d5$var$createPopupActions = ($popup)=>{
    const open = ()=>{
        $popup.hidden = false;
        (0, $g1MHW.blockScrollOnBody)();
        (0, $eHZGN.sessionStorageService).setItem($bd34050ffdd5b0d5$var$EXIT_POPUP_SESSION_KEY, 'true');
        (0, $i928P.pushDataLayer)('popup_view', {
            form_name: $bd34050ffdd5b0d5$var$EXIT_POPUP_FORM_NAME
        });
    };
    const close = ()=>{
        $popup.hidden = true;
        (0, $g1MHW.releaseScrollOnBody)();
    };
    const handleOpenClick = (event)=>{
        event.preventDefault();
        open();
    };
    const handleCloseClick = ()=>{
        close();
        (0, $i928P.pushDataLayer)('click_button', {
            button_type: 'Button',
            button_text: "Zamkni\u0119cie popupu rejestracji z landingu"
        });
    };
    return {
        open: open,
        close: close,
        handleOpenClick: handleOpenClick,
        handleCloseClick: handleCloseClick
    };
};
const $bd34050ffdd5b0d5$var$createOpenIfConditionsMet = (open)=>{
    const displayConditions = $bd34050ffdd5b0d5$var$createDisplayConditions();
    return ()=>{
        if (displayConditions.every((isMet)=>isMet())) open();
    };
};
const $bd34050ffdd5b0d5$var$bindClickTriggers = ({ $closeButton: $closeButton, $openButtons: $openButtons }, { handleCloseClick: handleCloseClick, handleOpenClick: handleOpenClick }, signal)=>{
    $closeButton.addEventListener('click', handleCloseClick, {
        signal: signal
    });
    $openButtons.forEach(($button)=>$button.addEventListener('click', handleOpenClick, {
            signal: signal
        }));
};
const $bd34050ffdd5b0d5$var$bindAutomaticTriggers = (onTrigger, signal)=>{
    $bd34050ffdd5b0d5$var$AUTOMATIC_TRIGGERS.forEach((startWatching)=>startWatching(onTrigger, signal));
};
/** `enable` runs `bind` (it registers listeners on the given signal), `disable` removes them all and calls `onDisable`. */ const $bd34050ffdd5b0d5$var$createToggleableListeners = (bind, onDisable)=>{
    let controller = null;
    return {
        enable: ()=>{
            if (!controller) {
                controller = new AbortController();
                bind(controller.signal);
            }
        },
        disable: ()=>{
            if (controller) {
                controller.abort();
                controller = null;
                onDisable();
            }
        }
    };
};
/** Without `disableOnMobile` the triggers are always on; with it they follow the desktop breakpoint. */ const $bd34050ffdd5b0d5$var$toggleByViewport = (disableOnMobile, enable, disable)=>{
    if (disableOnMobile) (0, $k708F.watchBreakpoint)($bd34050ffdd5b0d5$var$DESKTOP_BREAKPOINT_NAME, enable, disable);
    else enable();
};
/**
 * Initializes and manages an exit-intent popup.
 *
 * It can be opened by clicking an element with `[data-open-exit-popup]` (always), or by an
 * automatic trigger (see `AUTOMATIC_TRIGGERS`) provided all display conditions are met
 * (see `createDisplayConditions`).
 *
 * @param {ExitPopupOptions} [options] - Configuration options, see `ExitPopupOptions`.
 */ const $bd34050ffdd5b0d5$var$initExitPopup = (options = {})=>{
    const { isOnlyClickListener: isOnlyClickListener = false, disableOnMobile: disableOnMobile = false, bindExitPopupForm: bindExitPopupForm = (0, $3owir.initExitPopupFormControls) } = options;
    const popupElements = $bd34050ffdd5b0d5$var$findPopupElements();
    if (!popupElements) return;
    bindExitPopupForm();
    const popupActions = $bd34050ffdd5b0d5$var$createPopupActions(popupElements.$popup);
    const openIfConditionsMet = $bd34050ffdd5b0d5$var$createOpenIfConditionsMet(popupActions.open);
    const { enable: enable, disable: disable } = $bd34050ffdd5b0d5$var$createToggleableListeners((signal)=>{
        $bd34050ffdd5b0d5$var$bindClickTriggers(popupElements, popupActions, signal);
        if (!isOnlyClickListener) $bd34050ffdd5b0d5$var$bindAutomaticTriggers(openIfConditionsMet, signal);
    }, popupActions.close);
    $bd34050ffdd5b0d5$var$toggleByViewport(disableOnMobile, enable, disable);
};
var $bd34050ffdd5b0d5$export$2e2bcd8739ae039 = $bd34050ffdd5b0d5$var$initExitPopup;

});
parcelRegister("g1MHW", function(module, exports) {

$parcel$export(module.exports, "blockScrollOnBody", function () { return $b37a23e083b0f366$export$bc03913d20c6d9dd; });
$parcel$export(module.exports, "releaseScrollOnBody", function () { return $b37a23e083b0f366$export$2c723d7b648f178; });
const $b37a23e083b0f366$export$bc03913d20c6d9dd = ()=>{
    document.documentElement.style.scrollbarGutter = 'stable';
    document.body.style.overflowX = 'hidden';
    document.body.style.overflowY = 'hidden';
};
const $b37a23e083b0f366$export$2c723d7b648f178 = ()=>{
    document.documentElement.style.scrollbarGutter = 'auto';
    document.body.style.overflowX = '';
    document.body.style.overflowY = '';
};

});

parcelRegister("k708F", function(module, exports) {

$parcel$export(module.exports, "isActiveBreakpoint", function () { return $6a5124bf93db9b4b$export$479dd0c69bc20f82; });
$parcel$export(module.exports, "watchBreakpoint", function () { return $6a5124bf93db9b4b$export$de941bba7286dc15; });
const $6a5124bf93db9b4b$export$d07517a676ce386f = {
    small: 360,
    medium: 480,
    big: 768,
    large: 992,
    xtralarge: 1200,
    nav: 1260,
    hd: 1280,
    hdplus: 1600,
    fullhd: 1920
};
const $6a5124bf93db9b4b$export$f68cee56cc062164 = [
    {
        name: 'fullhd',
        query: `(min-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.fullhd}px)`
    },
    {
        name: 'hdplus',
        query: `(min-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.hdplus}px)`
    },
    {
        name: 'hd',
        query: `(min-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.hd}px)`
    },
    {
        name: 'nav',
        query: `(min-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.nav}px)`
    },
    {
        name: 'xtralarge',
        query: `(min-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.xtralarge}px)`
    },
    {
        name: 'large',
        query: `(min-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.large}px)`
    },
    {
        name: 'big',
        query: `(min-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.big}px)`
    },
    {
        name: 'medium',
        query: `(min-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.medium}px)`
    },
    {
        name: 'small',
        query: `(min-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.small}px)`
    }
];
const $6a5124bf93db9b4b$var$maxQueriesSensitivity = 0.02;
const $6a5124bf93db9b4b$export$68a3437e00a7012a = [
    {
        name: 'small',
        query: `(max-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.small - $6a5124bf93db9b4b$var$maxQueriesSensitivity}px)`
    },
    {
        name: 'medium',
        query: `(max-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.medium - $6a5124bf93db9b4b$var$maxQueriesSensitivity}px)`
    },
    {
        name: 'big',
        query: `(max-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.big - $6a5124bf93db9b4b$var$maxQueriesSensitivity}px)`
    },
    {
        name: 'large',
        query: `(max-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.large - $6a5124bf93db9b4b$var$maxQueriesSensitivity}px)`
    },
    {
        name: 'xtralarge',
        query: `(max-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.xtralarge - $6a5124bf93db9b4b$var$maxQueriesSensitivity}px)`
    },
    {
        name: 'nav',
        query: `(max-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.nav - $6a5124bf93db9b4b$var$maxQueriesSensitivity}px)`
    },
    {
        name: 'hd',
        query: `(max-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.hd - $6a5124bf93db9b4b$var$maxQueriesSensitivity}px)`
    },
    {
        name: 'hdplus',
        query: `(max-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.hdplus - $6a5124bf93db9b4b$var$maxQueriesSensitivity}px)`
    },
    {
        name: 'fullhd',
        query: `(max-width: ${$6a5124bf93db9b4b$export$d07517a676ce386f.fullhd - $6a5124bf93db9b4b$var$maxQueriesSensitivity}px)`
    }
];
const $6a5124bf93db9b4b$export$4adb988360925c51 = (breakpointName)=>$6a5124bf93db9b4b$export$d07517a676ce386f[breakpointName] || null;
const $6a5124bf93db9b4b$export$3fc67109cee92a6b = ()=>$6a5124bf93db9b4b$export$f68cee56cc062164.find(({ query: query })=>window.matchMedia(query).matches)?.name ?? 'small';
const $6a5124bf93db9b4b$export$62db2259d9257522 = ()=>$6a5124bf93db9b4b$export$68a3437e00a7012a.find(({ query: query })=>window.matchMedia(query).matches)?.name ?? 'fullhd';
const $6a5124bf93db9b4b$export$479dd0c69bc20f82 = (breakpointName)=>{
    const mediaQuery = $6a5124bf93db9b4b$export$f68cee56cc062164.find(({ name: name })=>name === breakpointName);
    if (!mediaQuery) return false;
    return window.matchMedia(mediaQuery.query).matches;
};
const $6a5124bf93db9b4b$export$5fd8151d726691b6 = (breakpointName)=>{
    const mediaQuery = $6a5124bf93db9b4b$export$f68cee56cc062164.find(({ name: name })=>name === breakpointName);
    return mediaQuery ? window.matchMedia(mediaQuery.query) : null;
};
const $6a5124bf93db9b4b$export$de941bba7286dc15 = (breakpointName, onEnter, onLeave)=>{
    const mediaQuery = $6a5124bf93db9b4b$export$5fd8151d726691b6(breakpointName);
    if (!mediaQuery) return;
    if (mediaQuery.matches) onEnter();
    mediaQuery.addEventListener('change', (event)=>event.matches ? onEnter() : onLeave());
};
const $6a5124bf93db9b4b$export$47898728eaa242f5 = (breakpointName)=>{
    const mediaQuery = $6a5124bf93db9b4b$export$68a3437e00a7012a.find(({ name: name })=>name === breakpointName);
    if (!mediaQuery) return false;
    return window.matchMedia(mediaQuery.query).matches;
};
const $6a5124bf93db9b4b$export$b7681040b444ff40 = (breakpointName)=>{
    const mediaQuery = $6a5124bf93db9b4b$export$68a3437e00a7012a.find(({ name: name })=>name === breakpointName);
    return mediaQuery ? window.matchMedia(mediaQuery.query) : null;
};

});

parcelRegister("736Jt", function(module, exports) {

$parcel$export(module.exports, "watchElementScrolledPast", function () { return $388d1ce4806dd795$export$2828607d453ddc; });
/**
 * Calls `onScrolledPast` (once) when the element has been visible in the viewport and then scrolled out
 * of it upwards. An element that was never visible, or that disappears without going above the viewport
 * (e.g. gets hidden), does not trigger it.
 *
 * @param {Element} $element - The element to observe.
 * @param {() => void} onScrolledPast - Called when the element has been scrolled past.
 * @param {AbortSignal} [signal] - Stops observing when aborted.
 */ const $388d1ce4806dd795$export$2828607d453ddc = ($element, onScrolledPast, signal)=>{
    let wasVisible = false;
    const observer = new IntersectionObserver((entries)=>{
        const { isIntersecting: isIntersecting, boundingClientRect: boundingClientRect } = entries[entries.length - 1];
        if (isIntersecting) wasVisible = true;
        else if (wasVisible && boundingClientRect.top < 0) {
            observer.disconnect();
            onScrolledPast();
        }
    });
    observer.observe($element);
    signal?.addEventListener('abort', ()=>observer.disconnect());
};

});

parcelRegister("eHZGN", function(module, exports) {

$parcel$export(module.exports, "storageService", function () { return $22f1e3c519019e6f$export$f274b028e0d144cc; });
$parcel$export(module.exports, "sessionStorageService", function () { return $22f1e3c519019e6f$export$e7755ba4414c4f99; });
const $22f1e3c519019e6f$var$localStorageFallback = {};
const $22f1e3c519019e6f$var$sessionStorageFallback = {};
function $22f1e3c519019e6f$var$storageServiceFor(storage, fallback) {
    let storageAvailable = false;
    try {
        const x = 'storageTest';
        storage.setItem(x, x);
        storage.removeItem(x);
        storageAvailable = true;
    } catch (e) {
        storageAvailable = false;
    }
    return {
        setItem (key, value) {
            if (storageAvailable) storage.setItem(key, value);
            else fallback[key] = value;
        },
        getItem (key) {
            return storageAvailable ? storage.getItem(key) : fallback[key];
        },
        removeItem (key) {
            if (storageAvailable) storage.removeItem(key);
            else fallback[key] = null;
        },
        clear () {
            if (storageAvailable) storage.clear();
            else Object.keys(fallback).forEach((key)=>{
                delete fallback[key];
            });
        }
    };
}
const $22f1e3c519019e6f$var$getStorageType = (storageType)=>{
    if (typeof window !== 'undefined') try {
        return storageType === 'localStorage' ? localStorage : sessionStorage;
    } catch  {
        return undefined;
    }
};
const $22f1e3c519019e6f$export$f274b028e0d144cc = $22f1e3c519019e6f$var$storageServiceFor($22f1e3c519019e6f$var$getStorageType('localStorage'), $22f1e3c519019e6f$var$localStorageFallback);
const $22f1e3c519019e6f$export$e7755ba4414c4f99 = $22f1e3c519019e6f$var$storageServiceFor($22f1e3c519019e6f$var$getStorageType('sessionStorage'), $22f1e3c519019e6f$var$sessionStorageFallback);

});



var $d8tQ2 = parcelRequire("d8tQ2");

var $3owir = parcelRequire("3owir");

var $1IA9E = parcelRequire("1IA9E");
(0, $d8tQ2.default)();
(0, $3owir.initForm)();
(0, $1IA9E.default)();

})();
//# sourceMappingURL=script.js.map
